export const kg: { [key: string]: string } = {
  subscribe_with_click: 'Бир чыкылдатуу менен жазылуу',
  subscribe: 'Бир чыкылдатуу менен жазылуу',
  minimum_number_characters: 'кеминде 2 белги',
  request_details: 'Сурамдын чоо-жайы',
  form_title: 'Биз жакын арада сиз менен байланышабыз',
  form_required: '* менен белгиленген талаалар милдеттүү',
  form_name_placeholder: 'Аты',
  form_email_placeholder: 'Электрондук почта',
  form_phone_placeholder: 'Телефон номери',
  form_company_placeholder: 'Компания',
  form_submit: 'Жөнөтүү',
  form_1: 'Мен жеке маалыматтарды иштетүүгө макулдугумду берем',
  form_2: 'Купуялык саясаты',
  validation_privacy_policy: 'Купуялык саясатын кабыл алыңыз',
  validation_phone: 'Телефон номери жараксыз',
  validation_email: 'Электрондук почтанын форматы жараксыз',
  validation_required: 'Милдеттүү талаалар толтурулган эмес',
  submit_error: 'Форманы сактоо учурунда ката кетти',
  footer_1: 'Биздин өнөктөштөр:',
  footer_2: 'Методдор',
  footer_3: 'Продукттар',
  footer_4: 'Байланыштар:',
  footer_5: 'Импринт',
  footer_6: 'Купуялык саясаты',
  footer_7: 'Маркетингдик изилдөө',
  about_us_1: '4Service корпоративдик социалдык жоопкерчилиги',
  about_us_2:
    'Командабыздын ар бир мүчөсүнүн жүрөгүнөн жана жан дүйнөсүнөн. Биз ар бир кызматкерибизде боорукерликтин учкунун сактап, айланабыздагы дүйнөнү бир аз жакшыраак кылууга аракет кылабыз',
  about_us_3: '4Service корпоративдик социалдык жоопкерчилиги',
  about_us_4:
    'Командабыздын ар бир мүчөсүнүн жүрөгүнөн жана жан дүйнөсүнөн. Биз ар бир кызматкерибизде боорукерликтин учкунун сактап, айланабыздагы дүйнөнү бир аз жакшыраак кылууга аракет кылабыз',
  about_us_5: 'Service Mania бизнес оюну',
  about_us_6: 'Балдар жана студенттер үчүн биздин демилгелер',
  about_us_7: 'Кайрымдуулук / Ыктыярчылык',
  about_us_8:
    'Балдар үйлөрү, карылар үйлөрү жана украин армиясы үчүн ыктыярчылык. Бул биздин ишмердүүлүктүн эң таасирдүү бөлүгү',
  about_us_9: 'Жаныбарларды коргоо',
  about_us_10:
    'Каалаган адам биздин кеңсеге үй жаныбары менен келе алат. Биз баш калкалоочу жайларга жардам берип, жем үчүн каражат чогултуп, кээде үйсүз жаныбарларга үй табууга аракет кылабыз',
  about_us_11: '4Service Group',
  about_us_12:
    'Кардарлардын тажрыйбасын башкарган эл аралык изилдөө компаниясы.',
  about_us_13:
    'Биз сатууну көбөйтүү жана кардарга багытталган компаниялардын бизнесин өнүктүрүү үчүн татаал долбоорлорду ишке ашырабыз.',
  about_us_14:
    'Баш кеңсеси Австриянын Вена шаарында жайгашкан эл аралык изилдөө холдинги. Компания 2001-жылы кардарларынын жана бизнес менен өз ара аракеттенген, анын кызматтарын колдонгон жана өнүмдөрүн керектеген адамдардын жашоо сапатын жакшыртуу максатында түзүлгөн. Анткени “Forservice” аталышы кардарларды тейлөөнү жана сапатты билдирген компания үчүн бекеринен тандалган эмес.',
  about_us_15:
    'Бул Украинадагы Киев шаарында mystery shopping кызматтарынын алдыңкы провайдери катары 4Service тарыхынын башталышы болду. Компания 52 өлкөдө кардарлардын тажрыйба чынжырын талдоо жана жакшыртуу боюнча жаңы мүмкүнчүлүктөр менен ийгиликтүү иштеп келет',
  about_us_16: 'тейлөө аты менен төрөлгөн',
  about_us_17: 'Украинадан тышкаркы биринчи кеңсе',
  about_us_18: 'Баш кеңсени Венага көчүрүү',
  about_us_19: 'MSPA элиталык мүчөсү, Европадагы Топ-10 агенттик',
  about_us_20: '9 өлкөдө кеңселерди ачуу',
  about_us_21: 'биринчи санарип долбоорлор, Voicer',
  about_us_22: 'DesignThinkers Academy өнөктөштөрү',
  about_us_23: 'биринчи глобалдык CX долбоорлору',
  about_us_24: 'Миссия',
  about_us_25:
    'Биздин миссия — дүйнө жүзү боюнча кардарларды тейлөөнү жакшыртуу! Бизди шыктандырган нерсе — биз иштеген адамдардагы жана компаниялардагы сапаттуу өзгөрүүлөр.',
  about_us_26: '20+ жылдык Customer Experience тажрыйбасы',
  about_us_27: '95 өлкө',
  about_us_28:
    'Биз дүйнө жүзүндөгү эң мыкты тармактык тажрыйбаларды чогултуп жана бөлүшөбүз',
  about_us_29: 'Баш кеңсе Венада',
  about_us_30:
    'өлкөлөр. Биз дүйнө жүзүндөгү эң мыкты тармактык тажрыйбаларды чогултуп жана бөлүшөбүз',
  about_us_31: 'тейлөө сапатынын рейтингдери',
  about_us_32: 'Биз Европадагы Топ-10 CX агенттиктеринин катарына киребиз',
  about_us_33: 'өкүлчүлүктөр / Австриядагы HQ',
  about_us_34: 'активдүү долбоорлор',
  about_us_35: 'Сиздин келечектеги иш ордуңуз',
  about_us_36: 'Биздин кеңселер',
  about_us_37:
    '4Service ™ кызматкерлер үчүн ыңгайлуу иш мейкиндигин түзүүгө аракет кылат. Биздин кызматкерлер ар биринин ыңгайлуулугу жана өндүрүмдүүлүгү үчүн кеңседе, алыстан же гибрид форматта иштешет. Эс алуу бөлмөлөрү, акысыз психологиялык колдоо жана жылуу чөйрө бар. Биз адамдарга жана жаныбарларга достук мамиле жасайбыз.',
  about_us_38: 'Жаркыраган команда',
  about_us_39:
    'Биздин көп улуттуу команда кардарларыбызды угууга, алардын пикирлерин кабыл алууга жана биргелешип өсүүгө умтулат. Кардарларыбыздын биз менен болгон тажрыйбасы жаңы өнүмдөрдү ишке киргизүү же финансылык максаттарга жетүү сыяктуу эле биздин бизнес үчүн маанилүү. Биздин ишмердүүлүк коомчулукка оң таасир тийгизүүгө жана кардарларыбыз үчүн инновациялык жана адамдарга багытталган чечимдерди сунуштоого багытталган.',
  about_us_40: 'Баары',
  about_us_41: 'Башкаруу',
  about_us_42: 'Global командасы',
  about_us_43: 'Продукт ээлери',
  about_us_44: 'Биздин өнөктөштөр',
  about_us_45:
    'Биз сатууну көбөйтүү жана кардарга багытталган компаниялардын бизнесин өнүктүрүү үчүн татаал долбоорлорду ишке ашырабыз',
  about_us_46:
    '25 өлкөдө өкүлчүлүгү бар жана чыгармачыл көп тармактуу командаларды жана коомчулуктарды окуткан, өнүктүргөн жана колдогон алдыңкы “design driven” кесиптик окутуу институттарынын бири. Design Thinking инновациялык идеяларды, өзгөрүүлөрдү жана татаал көйгөйлөрдүн чечимдерин иштеп чыгууга жана ишке ашырууга жардам берет.',
  about_us_47:
    'Алардын миссиясы — командаларга жана адамдарга шыктанууга жана чакырыктарды кабыл алууга, “иш жүзүндө үйрөнүүгө”, чыгармачыл көйгөй чечүү жөндөмдөрүн бекемдөөгө жана уюмдарга тайманбас инновацияларды баштоо үчүн керектүү чөйрөнү жана ой жүгүртүүнү түзүүгө жардам берүү.',
  about_us_48:
    'mystery shopping тармагындагы компаниялардын өкүлчүлүк соода ассоциациясы. Ассоциация дүйнө жүзү боюнча аймактык негизде иштейт жана Америка, Европа/Африка жана Азия/Тынч океан бөлүмдөрүнө ээ. Мүчө компаниялар биргелешкен аракеттер аркылуу mystery shopping тармагын бекемдөө максатында биригишет.',
  about_us_49:
    'коммерциялык эмес мүчөлүк уюм. Мүчөлөр маалымат аналитикасынын, изилдөөлөрдүн жана инсайттардын коомдорду, уюмдарды жана ар бир адамдын жашоосун жакшыртуудагы мүмкүнчүлүгүнө ишенген коомчулукту түзөт.',
  about_us_50:
    'ESOMAR баш кеңсеси Нидерландиянын Амстердам шаарында жайгашкан. ESOMAR 1947-жылдан бери мүчөлөрү аркылуу 130дан ашуун өлкөдө иш алып барат.',
  about_us_51:
    '(UCCA) — байланыш борборлору жана кардарларды тейлөө тармагындагы өнүгүү жана өз ара аракеттенүү максатында бириккен жеке эксперттердин жана компаниялардын кесиптик коомчулугу. UCCA философиясы заманбап технологияларга жана жогорку стандарттарга негизделген байланыш борбору индустриясынын маданиятын жогорулатуу болуп саналат.',
  about_us_52:
    'Украинанын Contact Center Association уюму 2010-жылы негизделген',
  about_us_53:
    'билим берүү тармагындагы дүйнөлүк мыкты тажрыйбаларды изилдеп, аларды украин рыногуна ылайыкташтырып колдонууда. Ошондуктан Academy DTEK алдыңкы эл аралык бизнес мектептери менен кызматташат: INSEAD, IE Business School жана Stanford University.',
  about_us_54:
    'Academy DTEK D.Client School, ID School, Executive Education: Energy of Innovation, Power of Communications, DX School санариптик программасы, Effective Leader: Pre-MBA, Change Energy аркылуу кардарга багытталган жана инновациялык маданиятты өнүктүрүүгө багытталган.',
  about_us_55: 'Сергей Пашковский',
  about_us_56: 'Виктория Скорбота',
  about_us_57: 'Артем Фомин',
  about_us_58: 'Макс Папка',
  about_us_59: 'Эл аралык сатуу менеджери',
  bht_1: 'Бренд ден соолугу',
  bht_2: 'Мониторинг',
  bht_3: 'Бренддер укмуштай күчтүү',
  bht_4: 'Брендиңиздин жалпы көрсөткүчтөрүн билип алыңыз',
  bht_5: 'Жөнүндө',
  bht_6: 'Brand Health Tracking деген эмне?',
  bht_7:
    'Бул рыноктук изилдөөнүн бир түрү болуп саналат, ал белгилүү бир үзгүлтүксүздүк менен (ар эки жумада, ай сайын ж.б.) жүргүзүлөт жана төмөнкүлөр тууралуу маалымат алуу үчүн колдонулат:',
  bht_8:
    'рыноктогу бренддин абалы, анын таанымалдыгы, суроо-талап, имидж, керектөөчүлөрүнүн мүнөздөмөлөрү, бренддин ден соолугу ж.б. көрсөткүчтөрүнүн негизинде.',
  bht_9: 'Брендди эң көп сатып алышат',
  bht_10: 'Лоялдуу',
  bht_11: '3 ай ичинде брендди сатып алышкан',
  bht_12: 'Туруктуу / дайыма кардарлар',
  bht_13: '6 ай ичинде брендди сатып алышкан',
  bht_14: 'Кыска мөөнөттүү кардарлар',
  bht_15: 'Бир жыл ичинде брендди сатып алышкан',
  bht_16: 'Узак мөөнөттүү кардарлар',
  bht_17:
    'Бренд жөнүндө билишет, бирок эч качан колдонушкан/сатып алышкан эмес',
  bht_18: 'Билишет, бирок кардар эмес',
  bht_19: 'Билбейт: бренд жөнүндө эч качан уккан эмес',
  bht_20: 'Билбейт',
  bht_21: 'Бренд сатып алуучулардын профили',
  bht_22: 'Брендди түзүү үчүн узак мөөнөттүү аракеттердин туруктуулугун баалоо',
  bht_23: 'Кардарлардын бренд тууралуу маалымдуулук деңгээлин өлчөө',
  bht_24: 'Жарнама жана маалыматтык кампаниялардын натыйжалуулугун көрсөтүү',
  bht_25:
    'Жогорку жарнама мезгили атаандаштардын сатуу/маркетинг ишмердүүлүгүнө кандай таасир тийгизерин аныктоо',
  bht_26:
    'Рыноктун үзгүлтүксүз өзгөрүү мезгилинде бизнес ээсине туруктуу көзөмөлдү камсыз кылуу',
  bht_27: 'BHT аркылуу кандай милдеттерди чечсе болот:',
  bht_28: 'Изилдөөгө суроо жөнөтүү',
  bht_29: 'Чечиле турган милдет',
  bht_30: 'Мисалы,',
  bht_31:
    'эгер компанияга рынок үлүшүн өлчөө үчүн кварталына бир гана BHT сессиясы керек болсо, анда кардарлардын жарнамадан бренд тууралуу маалымдуулугун өлчөөдө респонденттер арасында сурамжылоо көбүрөөк жүргүзүлүшү керек.',
  bht_32: 'CATI',
  bht_33: 'Face-to-Face',
  bht_53: 'Маектер',
  bht_34: 'CAWI',
  bht_35: 'Чечиле турган милдет',
  bht_36: 'Маалымат чогултуу аркылуу',
  bht_37:
    'ар кандай ыкмалар аркылуу бренд мониторинги, адатта, максаттуу аудиторияга жана аларга жетүүнүн татаалдыгына жараша үч этапка бөлүнөт:',
  bht_38:
    'Биз маалымат чогултуу үчүн салттуу жана заманбап ыкмаларды колдонобуз:',
  bht_39:
    'Биз эки модель менен иштейбиз: биринчиси жөнөкөй көрсөткүчтөр топтому менен, экинчиси тамак-аш жана тейлөө тармактары сыяктуу татаал тармактарга багытталган. Татаал модель 10го чейин бааланган индекстерди камтыган терең изилдөөнү талап кылат.',
  bht_40: 'Биз сунуштайбыз',
  bht_41: 'баштапкы маалыматтарды көзөмөлдөө',
  bht_42: 'Биз камтыйбыз',
  bht_43: 'бүт өлкөнү',
  bht_44: 'Биз чечим сунуштайбыз',
  bht_45:
    'динамикасы төмөн рыноктор / катышуучулары чектелген рыноктор үчүн (Brand Point Analyze)',
  bht_46: 'Эмне үчүн биз?',
  bht_47: 'Эмне үчүн бизди тандашат?',
  bht_50: 'Начар жыйынтык',
  bht_51: 'Жакшы жыйынтык',
  bht_52: 'Орточо жыйынтык',
  cases_1:
    'Маселе: Hyundai шоурумдарында электр унаасын сатып алуу тажрыйбасын кантип жакшыртуу керек?',
  cases_2: 'Customer Journey mapping',
  cases_3: 'Идеяларды иштеп чыгуу',
  cases_4: 'Сапаттык изилдөө',
  cases_5:
    'Маселе: Кардарлардын Oppo брендине кызыгуусун арттыруу үчүн дүкөндөрдө (тейлөө процессинде, интерьерде, брендди кабыл алууда) эмнени өзгөртүү керек?',
  cases_6: 'Онлайн CJM',
  cases_7: 'UI тестирлөө',
  cases_8: 'Маектер',
  cases_9:
    'Маселе: Кардарлардын Oppo брендине кызыгуусун арттыруу үчүн дүкөндөрдө эмнени өзгөртүү керек?',
  cases_10: 'Сапаттык бөлүк',
  cases_11: 'Идеяларды иштеп чыгуу',
  cases_12: 'Сандык бөлүк',
  cases_13: 'Customer Journey Map',
  cases_14: 'Кейстер',
  cases_15: 'Баары',
  cases_16: 'Келиңиз, сиздин мыкты кейсиңизди бирге түзөлү',
  csi_1: 'Кардар',
  csi_2: 'канааттануу индекси',
  csi_3: 'Керектөөчүлөрдүн',
  csi_4: 'канааттануусунун жана нааразычылыгынын себептерин аныктоо',
  csi_5: 'Кардарлардын канааттануусун изилдөө',
  csi_6:
    'бул кардардын сатып алуу чечимине, ошондой эле максаттуу аудиториянын жүрүм-турумуна таасир эткен факторлорду, себептерди жана мотивацияларды аныктоо.',
  csi_7: 'Кардарлардын канааттануусу боюнча сурамжылоо',
  csi_8:
    'кардардын кызматтын белгилүү бир аспектисине же жалпы продуктка канчалык деңгээлде канааттанганын же нааразы экенин көрсөтөт.',
  csi_9: 'Канааттануу боюнча сурамжылоо',
  csi_10:
    'компаниянын учурдагы кардарларынын жана белгилүү бир өнүмдөрдүн/кызматтардын колдонуучуларынын арасында жүргүзүлөт.',
  csi_11: 'CSI деген эмне?',
  csi_12:
    'Кардарлардын канааттануусу — бул сиздин компания сунуштаган өнүмдү же кызматты сатып алууга байланыштуу кардардын күтүүлөрү канчалык деңгээлде аткарылганын өлчөө.',
  csi_13: 'Бактылуу адам',
  csi_14: 'Жөнүндө',
  csi_15: 'Жашыруун факторлорду аныктоо',
  csi_16: 'кардардын канааттануусуна таасир этиши мүмкүн болгон',
  csi_17: 'Себептерин аныктоо',
  csi_18:
    'товарларга жана кызматтарга суроо-талаптын өсүшү/төмөндөшүнүн артында турган',
  csi_19: 'Компаниянын',
  csi_20: 'бизнес процесстерин оптималдаштыруу',
  csi_21: 'Аларды ыңгайлаштыруу',
  csi_22: 'заманбап керектөөчүнүн муктаждыктарына ылайык',
  csi_23: 'Натыйжалуу жарнамалык билдирүү түзүү',
  csi_24: 'жана продуктту кардардын суроо-талабына ылайык позициялоо',
  csi_25: 'Чечиле турган милдеттер',
  csi_26:
    'Кардарлардын канааттануусу боюнча сурамжылоолор кандай милдеттерди чече алат',
  csi_27: 'Телефон кармаган адам',
  csi_28: 'Биз математикалык моделди түзөбүз',
  csi_29:
    'кардардын канааттануусуна/кардарлардын лоялдуулугуна таасир этүүчү факторлор үчүн (регрессиялык анализ)',
  csi_30: 'Оптималдаштыруу',
  csi_31: 'компаниянын бизнес процесстерин',
  csi_32: 'Биз эсептелген кардарлардын канааттануу индексин түзөбүз',
  csi_33: '(CSI) жана аны декларативдүү көрсөткүч менен салыштырабыз',
  csi_34: 'Биз изилдөө жүргүзөбүз',
  csi_35: 'B2B жана B2C сегменттери үчүн.',
  csi_36: 'Биздин анкеталар аналитиктер тобу тарабынан иштелип чыгат',
  csi_37: 'кардарларыбыздын жеке долбоорлору үчүн атайын',
  csi_38: 'Эмне үчүн биз',
  csi_39: 'Эмне үчүн бизди тандашат?',
  csi_40: 'Маалымат чогултуу ыкмалары:',
  main_1:
    'кардарларыбыздын финансылык көрсөткүчтөрүн кардарларынын тажрыйбасынан үйрөнүү аркылуу жакшыртышат',
  main_2: 'CX изилдөө жана консалтинг кызматтары: бизнесиңизге 360° көз караш',
  main_3:
    'Бизнесиңизди колдоо үчүн биздин чечимдер жана инструменттер спектрин таап чыгыңыз',
  main_4: 'Продукттар',
  main_5:
    'Сапаттык изилдөө — бул түшүнүктөрдү, пикирлерди же тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултуу жана талдоо',
  main_6:
    'Сандык изилдөө ыкмалары — бул сурамжылоолор, анкеталар жана изилдөөлөр аркылуу чогултулган маалыматтарды объективдүү өлчөө жана сандык талдоо',
  main_7:
    'Mystery shopping — алдын ала аныкталган сценарий учурунда кардар менен компаниянын же уюмдун ортосундагы өз ара аракеттенүүнү өлчөө жана мониторинг жүргүзүү үчүн рыноктук изилдөө ыкмасы',
  main_8:
    'Пикирлерди башкаруу системасы. Кардарыңыздын үнү бир системада Customer Feedback Management System',
  main_9:
    'Аудиториядан алынган инсайттарды сунуштаган AI негизиндеги контент аналитика платформасы',
  main_10:
    'Performance Management Software. Сатууну көбөйтүү үчүн геймификацияланган колдонмо',
  main_11:
    'Бааларды мониторингдөө — бул атаандаштардын бааларын чогултуу, иштетүү жана талдоо процесси',
  main_12:
    'кардарга багытталган кызматтарды жана өнүмдөрдү долбоорлоо. Процесс кардарлардын муктаждыктары жана күтүүлөрүнөн алардын иштөө ыкмасына чейинки тең салмактуу кыймылды камтыйт',
  main_13:
    'Биздин аналитикалык команда көптөгөн кардарлар менен ийгиликтүү далилденген эң заманбап жана фундаменталдуу ыкмаларды колдонот',
  main_14: 'Методологиялар',
  main_15: 'Customer journey map',
  main_16:
    'Customer Journey Mapping (CJM) — бул максаттуу аудиторияны аныктоо, алардын муктаждыктарын жана чөйрөсүн түшүнүү, андан соң кызыктуу тажрыйбаны камсыз кылуу планын түзүү',
  main_17: 'CJM',
  main_18: 'Net Promotion Score',
  main_19:
    'Net Promoter Score (NPS) — бул кардар тажрыйбасынын алтын стандарты болуп саналган метрика, ал бир суроого негизделет: Уюмду/Продуктту/Кызматты сунуштоо ыктымалдыгыңыз кандай?',
  main_20: 'NPS',
  main_21: 'Brand Health Tracking',
  main_22:
    'Brand Health Tracking (BHT) изилдөөсү брендиңиздин таанымалдуулук, колдонуу, бренд позициясы жана бренд натыйжалуулугу боюнча көрсөткүчтөрүн өлчөй алат',
  main_23: 'BHT',
  main_24: 'Адам ресурстарын изилдөө',
  main_25:
    'Human Resource Research HR практикасын жана натыйжалуулугун баалоо үчүн колдонулат жана учурдагы өнүгүү жана башкаруу боюнча кеңири талдоо сунуштайт',
  main_26: 'HR изилдөө',
  main_27: 'Кардарлардын канааттануу индекси',
  main_28:
    'Customer Satisfaction Index (CSI) — бул кардарларыңыздын компаниянын өнүмдөрүнө/кызматтарына канчалык канааттанганын көрсөткөн баа.',
  main_29: 'CSI',
  main_30: 'UX тестирлөө',
  main_31:
    'Usability (UX) testing — бул чыныгы адамдардын вебсайт, колдонмо же башка продукт менен кандайча өз ара аракеттенерин жана алардын жүрүм-туруму менен реакцияларын байкоо',
  main_32: 'Эмне үчүн биз',
  main_33:
    'Биздин миссия — бизнеске жогорку натыйжалуу кардар тажрыйбасын камсыз кылууга жардам берүү',
  main_34: 'Сапатка көңүл буруу',
  main_35: 'Биз сапатты көзөмөлдөйбүз',
  main_36:
    'изилдөө маалыматтарына келгенде. Биз бардык маалымат топтомдорун кардарларга жеткиликтүү кылабыз',
  main_37: 'Үнөмдүү',
  main_38: 'Биздин тажрыйба, ресурстар жана оптималдаштырылган',
  main_39:
    'бизнес процесстер сизге акчаңызды жана убактыңызды үнөмдөөгө мүмкүндүк берет',
  main_40: 'Акылдуу чечимдер',
  main_41: 'Биз ар кандай ыкмаларды колдонобуз',
  main_42: 'жана сиздин өзгөчө көйгөйлөрүңүздү чечүү үчүн инструменттерди',
  main_43: 'Сапатка көңүл буруу',
  main_44: 'Биз сапатты көзөмөлдөйбүз',
  main_45:
    'изилдөө маалыматтарына келгенде. Биз бардык маалымат топтомдорун кардарларга жеткиликтүү кылабыз',
  main_46: 'Үнөмдүү',
  main_47: 'Биздин тажрыйба, ресурстар жана оптималдаштырылган',
  main_48:
    'бизнес процесстер сизге акчаңызды жана убактыңызды үнөмдөөгө мүмкүндүк берет',
  main_49: 'Акылдуу чечимдер',
  main_50: 'Биз ар кандай ыкмаларды колдонобуз',
  main_51: 'жана сиздин өзгөчө көйгөйлөрүңүздү чечүү үчүн инструменттерди',
  main_52: 'Cash & Carry',
  main_53: 'Электроника',
  main_54: 'Люкс/Премиум',
  main_55: 'Тамактануу жана меймандостук',
  main_56: 'Чекене соода',
  main_57: 'Автомобиль тармагы',
  main_58: 'Мода',
  main_59: 'Банктар',
  main_60: 'Саякат жана эс алуу',
  main_61: 'Сааттар жана зер буюмдар',
  main_62: 'Үй тиричилиги жана тиричилик техникасы',
  main_63: 'Блог',
  main_64: 'Кызыктуу макалаларды окуу үчүн блогго өтүңүз',
  main_65: 'Retail audit',
  main_66:
    'Дүкөнүңүз же брендиңиз тууралуу кеңири маалыматтарды чогултуп, өсүү тоскоолдуктарын талдап жана аларды жеңүү үчүн натыйжалуу стратегияларды түзүңүз',
  main_73: 'Diary Study',
  main_74:
    'Diary studies узак мөөнөттүү тажрыйбаларды жана кайталануучу аракеттерди изилдөө үчүн пайдалуу. Колдонуучулардын күнүмдүк чөйрөсүндөгү өзгөрүп жаткан тажрыйбаларын жана жашоо образын убакыттын өтүшү менен байкап жана түшүнүп алыңыз.',
  main_75: 'Employee Experience (EX)',
  main_76:
    'Employee Experience (EX) методологиясы — бул уюмдарга кызматкерлердин күтүүлөрүнө жана бизнес максаттарына шайкеш келген жакшыраак процесстерди, маданияттарды жана чөйрөлөрдү түзүүгө жардам берген стратегиялык ыкма, натыйжада кызматкерлердин жыргалчылыгын жана компаниянын натыйжалуулугун жогорулатат',
  main_77: 'CATI',
  main_78: 'Компьютердин жардамы менен телефон аркылуу маектешүү (CATI)',
  main_79:
    'CATI — бул ийкемдүү жана натыйжалуу изилдөө методологиясы, ал кардарлардын канааттануусунан жана кызматкерлердин катышуусунан тартып рыноктук жана социалдык изилдөөлөргө чейин ар кандай бизнес муктаждыктарына ылайыкташтырылган жогорку сапаттагы маалыматтарды чогултууга мүмкүндүк берет жана так, өз убагындагы жана пайдалуу инсайттарды камсыз кылат',
  cjm_1: 'Кардар',
  cjm_2: 'Journey map',
  cjm_3: 'Кардарлар дүйнөсүнө кирип, алардын тажрыйбасын бөлүшүңүз',
  cjm_4: 'Customer Journey Map деген эмне?',
  cjm_5:
    'CJM ар кандай каналдар аркылуу жана белгилүү бир убакыт аралыгында керектөөчүнүн продукт, кызмат, компания же бренд менен болгон өз ара аракеттенүүсүнүн визуалдаштырылган тарыхын көрсөтөт.',
  cjm_6:
    'Бул компанияларга кардарлардын өз ара аракеттенүү тажрыйбасын объективдүү талдоого, жаралган тоскоолдуктарды оңдоого жана жоюуга, ошондой эле продуктту жакшыртуу боюнча сунуштарды берүүгө мүмкүндүк берет.',
  cjm_7: 'Максаттуу аудиторияны аныктоо, сегментация',
  cjm_8: 'Кардар менен өз ара аракеттенүү этаптарын аныктоо',
  cjm_9: 'Кардарлар менен өз ара аракеттенүүнүн негизги каналдарын аныктоо',
  cjm_10: 'Кардар тажрыйбасын изилдөө',
  cjm_11: 'Тоскоолдуктарды талдоо жана оптималдаштыруу боюнча гипотезалар',
  cjm_12: 'Гипотезаларды ишке ашыруу жана тестирлөө',
  cjm_13: 'Customer Journey Map түзүү төмөнкү кадамдардан турат:',
  cjm_14: 'Customer Journey Map төмөнкүлөрдү көрсөтөт:',
  cjm_15:
    'CJM ар кандай каналдар аркылуу жана белгилүү бир убакыт аралыгында керектөөчүнүн продукт, кызмат, компания же бренд менен болгон өз ара аракеттенүүсүнүн визуалдаштырылган тарыхын көрсөтөт.',
  cjm_16: 'Биз командалык ишти камсыздайбыз',
  cjm_17: 'аналитиктер менен дизайнерлердин ортосунда',
  cjm_18: 'Биз жекече',
  cjm_19: 'ар бир кардарга мамиле сунуштайбыз',
  cjm_20: 'Биз жалпы деңгээлди жогорулата алабыз',
  cjm_21:
    'кардардын кызматка/продуктка канааттануусун жана акырында алардын компанияга болгон лоялдуулугун',
  cjm_22: 'Биз кепилдик беребиз',
  cjm_23:
    'керектөөчүнүн жолун оптималдаштырууга жана компаниянын бизнес процесстерин эске алууга',
  cjm_24: 'Биз кардарларыбызга сунуштайбыз',
  cjm_25:
    'айкалышкан ыкмаларды колдонуу мүмкүнчүлүгүн: CATI, CAWI, фокус-топтор, тереңдетилген маектер, эксперттик маектер, этнография ж.б.',
  cjm_26: 'Эмне үчүн бизди тандашат?',
  methods_hr_1: 'Адам ресурстарын изилдөө',
  methods_hr_2:
    'Командаңыз тууралуу объективдүү маалыматтарды алып, HR натыйжалуулугун кантип жакшыртууну билиңиз',
  methods_hr_3: 'Сизге HR изилдөөсү керек болушу мүмкүн болгон айрым себептер',
  methods_hr_4: 'сурамжылоого катышкан кызматкерлердин',
  methods_hr_5: 'ишке ашырылган HR долбоорлор',
  methods_hr_6: 'кызматкерлер үчүн өткөрүлгөн тренингдер',
  methods_hr_7:
    'Кардар тажрыйбасы жана кызматкерлерди изилдөө боюнча алдыңкы европалык холдинг',
  methods_hr_8: 'Сандар менен 4service HR изилдөөлөрү',
  methods_hr_9:
    'Компанияңыздын кызматкерлеринин жашоо циклинин ар бир этабындагы көйгөйлөрдү жана алсыз жактарды аныктоо үчүн: издөө/жалдоо/онбординг/карьералык өнүгүү/кайра аттестация',
  methods_hr_10:
    'Кайсы учурлар айлыкты көтөрүүгө жана бонустарга татыктуу экенин билүү үчүн',
  methods_hr_11:
    'Сиз кызматкерлердин нааразычылыгын алдын ала болжолдошуңуз же чечимдерди сунушташыңыз керек',
  methods_hr_12:
    'HR изилдөө аркылуу HR саясаттарын, программаларын жана практикаларын баалоонун жаңы жана учурдагы ыкмалары мүмкүн болот',
  methods_hr_13:
    'Компания кызматкерлеринин психикалык ден соолугун жакшыртуу үчүн',
  methods_hr_14:
    'Эгерде сиз максатка багытталган ыкма аркылуу өндүрүмдүүлүктү жакшыртууну кааласаңыз',
  methods_hr_15:
    'Эгерде сизде эл аралык жана/же алыстан иштеген команда болсо жана аны башкаруу керек болсо',
  methods_hr_16:
    'Иш берүүчү брендиңиз потенциалдуу кызматкерлер үчүн канчалык жагымдуу экенин түшүнүү үчүн',
  methods_hr_17: 'Кызматкерлердин канааттануусу',
  methods_hr_18: 'HR брендинг изилдөөсү',
  methods_hr_19: 'Маданий ар түрдүүлүк',
  methods_hr_20: 'Компенсация жана айлык пландары',
  methods_hr_21: 'Команданын катышуусу жана лоялдуулугу',
  methods_hr_22: 'Корголгон класстагы кызматкерлер',
  methods_hr_23: 'Изилдөө багыттары',
  methods_hr_24: 'Чечим 1',
  methods_hr_25:
    'eNPS, кызматкерлердин канааттануусу, кызматкерлердин лоялдуулугу',
  methods_hr_26: 'Биз эмнени өлчөйбүз:',
  methods_hr_27: 'Лоялдуулук:',
  methods_hr_28:
    'кызматкерлердин лоялдуулугу, келечектеги жүрүм-турумду болжолдоо, лоялдуулукка таасир этүүчү факторлордун салмагын аныктоо',
  methods_hr_29: 'Катышуу:',
  methods_hr_30:
    'кызматкерлердин ишке катышуусу, жыйынтыктарга жана жетишкендиктерге кызыгуусу',
  methods_hr_31: 'Engagement:',
  methods_hr_32:
    'кызматкерлердин баалуулуктарын жана компаниянын баалуулуктарын аныктоо',
  methods_hr_33: 'Trust 360:',
  methods_hr_34:
    'жетекчиликке, кесиптештерге, кол алдындагы кызматкерлерге ишеним, иш берүүчүнүн стратегияларына жана саясаттарына ишеним',
  methods_hr_35: 'Канааттануу:',
  methods_hr_36:
    'ар бир компания үчүн уникалдуу факторлорду аныктоо, лоялдуулукка таасир этүүчү ар бир негизги фактор боюнча канааттанууну баалоо',
  methods_hr_37: 'Чечим 2',
  methods_hr_38: 'Иш берүүчү брендинг',
  methods_hr_39: 'Ички иш берүүчү',
  methods_hr_40:
    'бренд анализи (кызматкерлер, стейкхолдерлер, ички рекрутерлер жана HR адистер арасында сурамжылоо)',
  methods_hr_41: 'Тышкы иш берүүчү анализи',
  methods_hr_42:
    '(атаандаштардын EVP анализи, тышкы рекрутерлер арасында сурамжылоо, жумуш издөөчүлөр арасында сурамжылоо)',
  methods_hr_43: 'Бренддин таанымалдуулугу жана репутациясы',
  methods_hr_44: 'анализи',
  methods_hr_45: 'Иш берүүчүнүн катышуусу',
  methods_hr_47: 'Иш берүүчү жөнүндө пикирлерди',
  methods_hr_48: 'чогултуу',
  methods_hr_49: 'Атаандаштык benchmarking',
  methods_hr_50: 'төмөнкү негизги факторлор боюнча:',
  methods_hr_51: 'Айлык акы,',
  methods_hr_52: 'иш чөйрөсү, атмосфера, иштин мүнөзү',
  methods_hr_53: 'Муктаждыктарды жана күтүүлөрдү талдоо',
  methods_hr_54: 'жумуш издөөчүлөрдүн',
  methods_hr_55: 'Тереңдетилген маектер,',
  methods_hr_56: 'desk research жана сандык изилдөөлөр колдонулат',
  methods_hr_57: 'Чечим 3',
  methods_hr_58: 'Кызматкердин саякат картасы/сырдуу кызматкер',
  methods_hr_59: 'жумуш издөөчүнүн жолун түзүү жана аныктоо',
  methods_hr_60:
    'издөөнүн негизги этаптарын, байланыш каналдарын, тандоо критерийлерин жана жумуш издөөчүлөрдү баалоону',
  methods_hr_61: 'бардык этаптарды мониторингдөө',
  methods_hr_62:
    'жана mystery job seekers менен байланыш каналдарын (маекке жазылуу, маектен өтүү, компаниядагы стажировка)',
  methods_hr_63: 'Аныктоо',
  methods_hr_64: 'жалдоо жана онбординг процесстериндеги алсыз жактарды',
  methods_hr_65: 'Жакшыртуу боюнча сунуштар,',
  methods_hr_66: 'тармак лидерлери менен benchmarking',
  mystery_shopping_1: 'Mystery',
  mystery_shopping_2: 'Shopping',
  mystery_shopping_3: 'Кызматыңызды чыныгы кардарлар менен баалаңыз',
  mystery_shopping_4:
    'Стандарттарды текшериңиз, кызматкерлериңизди баалаңыз жана кардарыңызга жакыныраак болуңуз',
  mystery_shopping_5:
    'Биз MSPA Europe кесиптик Mystery Shopping Providers ассоциациясынын элиталык мүчөсүбүз',
  mystery_shopping_6: 'тажрыйба',
  mystery_shopping_7: 'ай сайынкы визиттер',
  mystery_shopping_8: 'дүйнө жүзүндөгү mystery shoppers',
  mystery_shopping_9: 'Активдүү долбоорлор',
  mystery_shopping_10: 'кеңселер, HQ Австрияда',
  mystery_shopping_11: 'Европалык Mystery Shopping Providers',
  mystery_shopping_12: 'кызмат сапатынын рейтингдери',
  mystery_shopping_13: 'Анкета',
  mystery_shopping_14: 'Программалык камсыздоо',
  mystery_shopping_15: 'Шоппердин профили',
  mystery_shopping_16: 'Валидация жана каршылыктар',
  mystery_shopping_17: 'Аналитика',
  mystery_shopping_18:
    'Ушул 5 кадам аркылуу биздин 4Service компаниясы mystery shopper кызматынын сапатына кепилдик берет',
  mystery_shopping_19: 'Программа',
  mystery_shopping_20:
    '4Service тарабынан сунушталган Mystery Shopping программасынын 5 элементи',
  mystery_shopping_21: 'Анкета:',
  mystery_shopping_22: 'программаңыздын өзөгү',
  mystery_shopping_23:
    'Программанын бул бөлүгү бардык кызыкдар тараптар үчүн жеткиликтүү',
  mystery_shopping_24: 'Жогорку менеджерлер үчүн.',
  mystery_shopping_25:
    'Процесстин бардык маанилүү кадамдарын жана деталдарын көрсөтөт',
  mystery_shopping_26: 'Кызматкерлер үчүн.',
  mystery_shopping_27: 'Иш берүүчүлөр алардан эмнени күтөөрүн чагылдырат',
  mystery_shopping_28: 'Mystery shoppers үчүн.',
  mystery_shopping_29:
    'Түшүнбөстүктөрдү жана бир жактуулукту болтурбоо үчүн так жана структураланган',
  mystery_shopping_30: 'Shopmetrics программасы:',
  mystery_shopping_31: 'колдонууга ыңгайлуу жана инновациялык',
  mystery_shopping_32: 'Артыкчылыктары:',
  mystery_shopping_33: 'Интеграцияланат',
  mystery_shopping_34:
    'сиздин бизнес процесстериңиз жана программалык камсыздооңуз менен',
  mystery_shopping_35: 'GDPR негизиндеги',
  mystery_shopping_36: 'Купуялуулукту башкаруу инструменттери',
  mystery_shopping_37: 'Кеңири',
  mystery_shopping_38: 'Юридикалык шайкештик пакети',
  mystery_shopping_39: 'Отчет',
  mystery_shopping_40: 'түзүүчү',
  mystery_shopping_41: 'Башкаруу',
  mystery_shopping_42: 'жеткиликтүүлүк деңгээлдерин',
  mystery_shopping_43: 'Көпчүлүк анкеталар',
  mystery_shopping_44: 'бир сааттын ичинде толтурулат',
  mystery_shopping_45: 'Шопперлердин профили:',
  mystery_shopping_46: 'дүйнө жүзү боюнча 200 000+ mystery shoppers',
  mystery_shopping_47:
    'Негизги критерийлер: сиздин максаттуу аудиторияңызга максималдуу жакындык жана компанияңыз же атаандаштарыңыз менен мурдагы тажрыйба',
  mystery_shopping_48: 'Шопперлерди окутуу:',
  mystery_shopping_49: 'Киришүү тренинг тести',
  mystery_shopping_50: 'Skype/Телефон чалуу',
  mystery_shopping_51: 'Баалоо тести (милдеттүү эмес)',
  mystery_shopping_52: 'Валидация жана каршылыктар',
  mystery_shopping_53: 'Валидация',
  mystery_shopping_54: 'Системасы',
  mystery_shopping_55: '100% отчеттор',
  mystery_shopping_56: 'валидация командасы тарабынан текшерилет',
  mystery_shopping_57: 'Кошумча чалуулар',
  mystery_shopping_58: 'тактоо үчүн',
  mystery_shopping_59: 'Аудио жазуулар',
  mystery_shopping_60: 'визиттен кийин эң маанилүү маселелерди белгилөө үчүн',
  mystery_shopping_61: 'Кызматкерлердин алдамчылыгын',
  mystery_shopping_62: 'алдын алуу системасы',
  mystery_shopping_63: 'Каршылык',
  mystery_shopping_64: 'Системасы',
  mystery_shopping_65: 'Ар бир шоппердин баасы',
  mystery_shopping_66:
    'кызматкер тарабынан түздөн-түз вебсайтта талашылышы мүмкүн',
  mystery_shopping_67: 'Ар бир каршылык',
  mystery_shopping_68:
    'жергиликтүү валидация командасы тарабынан каралып, жооп берилет',
  mystery_shopping_69: 'Сиз статистиканы көрө аласыз',
  mystery_shopping_70: 'каршылыктар боюнча',
  mystery_shopping_71: 'Аналитика.',
  mystery_shopping_72:
    'Отчеттор жеке түрдө сунушталат жана төмөнкүлөрдү камтыйт:',
  mystery_shopping_73: 'Компаниянын',
  mystery_shopping_74: 'оор чекиттери жана көйгөйлөрү',
  mystery_shopping_75: 'Динамика',
  mystery_shopping_76: 'бөлүмдөр жана секциялар боюнча',
  mystery_shopping_77: 'Корреляция',
  mystery_shopping_78:
    'стандарттарды аткаруу менен кардарлардын канааттануусунун ортосунда',
  mystery_shopping_79: 'Benchmarking',
  mystery_shopping_80: 'атаандаштар менен салыштыруу',
  mystery_shopping_81: 'Практикалык',
  mystery_shopping_82: 'кызматты жакшыртуу боюнча сунуштар',
  mystery_shopping_83: 'Бизди эмне айырмалап турат?',
  mystery_shopping_84: 'Биз ideation сессияларын өткөрөбүз',
  mystery_shopping_85:
    'Биз эмне кылуу керектигин гана сунуштабайбыз, ошондой эле сиз менен бирге тейлөө көйгөйлөрүн чечүүнүн практикалык жолдорун издейбиз.',
  mystery_shopping_86:
    'Ideation сессиялары бизге жардам берген күчтүү инструмент:',
  mystery_shopping_87:
    'Продуктту же кызматтарды жакшыртуу багыттарын иштеп чыгуу',
  mystery_shopping_88:
    'Жаңы киреше булактарын жана бизнес стратегияларын изилдөө',
  mystery_shopping_89:
    'Кардарга багытталган татаал көйгөйлөрдүн чечимдерин табуу',
  mystery_shopping_90:
    'Кардарлардын оор маселелерин жагымдуу тажрыйбага айландыруу',
  mystery_shopping_91: 'Биз видео маектерди өткөрөбүз',
  mystery_shopping_92:
    'Биз анкеталарды гана чогултпайбыз — шопперлерден түз комментарийлерди да алабыз',
  mystery_shopping_93: 'Биз муну төмөнкүлөр үчүн жасайбыз:',
  mystery_shopping_94:
    'Биздин фасилитаторлор тереңдетилген маектерди өткөрүп, натыйжалуу пикир беришет',
  mystery_shopping_95: 'Тажрыйбаны кардардын көз карашы менен көрүү',
  mystery_shopping_96: 'Контент маркетинг стратегияңызды жакшыртуу',
  mystery_shopping_97: 'Кардарлардын жүрүм-турумун алдын ала болжолдоо',
  mystery_shopping_98: 'Биз Customer Journey Map түзөбүз',
  mystery_shopping_99:
    'Customer Journey Mapping кардарлардын муктаждыктарын жана кыйынчылыктарын түшүнүү үчүн алардын ордуна өзүбүздү коюуга жардам берет.',
  mystery_shopping_100: 'Кардардын жолун түзүү — эң мыкты ыкма:',
  mystery_shopping_101: 'Тажрыйбаны кардардын көз карашы менен көрүү',
  mystery_shopping_102: 'Контент маркетинг стратегияңызды жакшыртуу',
  mystery_shopping_103: 'Кардарлардын жүрүм-турумун алдын ала болжолдоо',
  mystery_shopping_104: 'Кызматтагы же коммуникациядагы боштуктарды аныктоо',
  mystery_shopping_105: 'Биз Mystery Shopping ар кандай түрлөрүн сунуштайбыз',
  mystery_shopping_106: 'Mystery Shopping түрлөрү',
  mystery_shopping_107: 'Mystery Caller',
  mystery_shopping_108:
    'Телефон аркылуу көрсөтүлгөн кызматтын сапатын аныктоо үчүн менеджерлериңизге жана/же колл-борборуңузга чалат',
  mystery_shopping_109: 'Luxury mystery shopping',
  mystery_shopping_110:
    'Атайын категориядагы mystery shoppers тарабынан люкс жайлардагы тейлөөнү текшерүү',
  mystery_shopping_111: 'Атаандаштык визиттер',
  mystery_shopping_112:
    'Атаандашыңыз кантип иштей турганын түшүнүүнүн эң оңой жолу',
  mystery_shopping_113: 'Mystery Employee',
  mystery_shopping_114:
    'Кызматкериңиздин толук жолун (жалдоо, адаптация, кеңсе процесстери ж.б.) түшүнүүгө жардам берет',
  mystery_shopping_115: 'Мотивациялык визиттер',
  mystery_shopping_116:
    'Кошумча кызматтарды жана/же өнүмдөрдү сунуштоону, белгилүү өнүмдөрдүн сатылышын стимулдаштыруу үчүн пайдалуу инструмент',
  mystery_shopping_117: 'Mystery Shopper Online',
  mystery_shopping_118:
    'Онлайн дүкөнүңүздө, вебсайтыңызда же колдонмоңузда кардар тажрыйбасын симуляциялап жана өлчөйт',
  mystery_shopping_119: 'Сатууларды жана акцияларды текшерүү',
  mystery_shopping_120:
    'Акциялар бардык жайларда кандай көрсөтүлүп жатканын жана алардын канчалык натыйжалуу иштеп жатканын аныктоого жардам берет',
  mystery_shopping_121: 'Сатып алуу жана кайтаруу визиттери',
  mystery_shopping_122:
    'Кардар тажрыйбасын жакшыртуу үчүн сатып алуудан тартып кайтарууга чейинки бүт процессти чагылдырууга жардам берет',
  mystery_shopping_123: '> 20 жыл',
  nps_1: 'Net Promotion',
  nps_2: 'Score',
  nps_3: 'Кардарлардын лоялдуулугун өлчөңүз, байкаңыз жана жакшыртыңыз',
  nps_4: 'Алар 0дөн 6га чейинки бааны беришет.',
  nps_5:
    'Алар начар тажрыйбага ээ болушу мүмкүн жана кайра сизден сатып алышы күмөн, атүгүл башкаларды да сатып албоого үндөшү мүмкүн.',
  nps_6: 'Бул 7 менен 8дин ортосунда баа берген респонденттер.',
  nps_7:
    'Алар сиздин кызматыңызга канааттанган, бирок промоутер деп эсептелгидей деңгээлде эмес.',
  nps_8: 'Бул сиздин бизнесиңизди 9 же 10 деп баалаган респонденттер.',
  nps_9:
    'Бул алардын сизди досуна же кесиптешине сунуштай турганын билдирет жана алар сиздин атыңыздан сунуш берип жатышат.',
  nps_10: 'NPS деген эмне?',
  nps_11: 'Ал кардардын кабыл алуусун бир жөнөкөй суроонун негизинде өлчөйт:',
  nps_12:
    'Сиз [Уюмду/Продуктту/Кызматты] досуңузга же кесиптешиңизге сунуштоо ыктымалдыгы канчалык?',
  nps_13: 'Менин компанияма бул керекпи?',
  nps_14: 'NPS — бул туруктуу өсүшүңүз',
  nps_15: 'Кардарлардын лоялдуулугунун динамикасын түшүнүңүз',
  nps_16: 'Кызматкерлериңизди мотивациялаңыз',
  nps_17: 'Ар кандай продукттарга болгон мамилени түшүнүңүз',
  nps_18:
    'Кардарлар сизге жана атаандаштарыңызга кандай мамиле жасаарын салыштырыңыз',
  nps_19: 'NPS менен эмне кылса болот?',
  nps_20: 'NPS кандай бизнес үчүн ылайыктуу?',
  nps_21: 'Маалымат чогултуу ыкмалары:',
  nps_22: 'NPS менен иштөө боюнча биздин сунуштар',
  nps_23:
    'Бул биз Detractors’тарды промоутерлерге айландырууга жардам берүүчү көрсөтмөлөрдү иштеп чыгабыз дегенди билдирет',
  nps_24: 'Биз "closed loop" ыкмасы менен иштейбиз',
  nps_25:
    'NPS — бул кардарлардын лоялдуулугундагы өзгөрүүлөрдү көзөмөлдөгөн tracking изилдөө',
  nps_26: 'Биз динамиканы көзөмөлдөйбүз',
  nps_27:
    'Тереңирээк анализ үчүн ар дайым сиздин нишадагы атаандаштарды баалоону сунуштайбыз',
  nps_28: 'Атаандаштарды баалоо',
  price_monitoring_1: 'Бааларды мониторингдөө',
  price_monitoring_2: 'Чекене мониторинг',
  price_monitoring_3:
    'Атаандаштардын бааларын мониторингдөө аркылуу сатуунун потенциалын жогорулатып жана баа саясатыңызды оптималдаштырыңыз',
  price_monitoring_4:
    '4Service дүйнө жүзү боюнча 20 жылдан ашык убакыттан бери бааларды мониторингдөө кызматтарын көрсөтүп келет',
  price_monitoring_5:
    'Баалар биздин квалификациялуу ички аудиторлор командасы тарабынан кыска убакытта мониторингден өткөрүлөт, бул атаандаштардын бааларындагы өзгөрүүлөргө тез жооп берүүгө мүмкүндүк берет',
  price_monitoring_6:
    'Биздин компания бааларды мониторингдөө аркылуу чечүүгө жардам бере турган маселелер',
  price_monitoring_7: 'Атаандаштардын баа саясатын баалоо',
  price_monitoring_8: 'жана продукт саясатын',
  price_monitoring_9: 'Акцияларды мониторингдөө',
  price_monitoring_10: 'жана атайын сунуштарды',
  price_monitoring_11: 'Рынок шарттарын мониторингдөө',
  price_monitoring_12: 'жана рынок чөйрөсүн',
  price_monitoring_13: 'Соода түйүндөрүн текшерүү жана көзөмөлдөө',
  price_monitoring_14: 'атайын жабдуулар жана товарлар үчүн',
  price_monitoring_15: 'Продукт агымын',
  price_monitoring_16: 'соода ичинде башкаруу',
  price_monitoring_17: 'Шарттарды оптималдаштыруу',
  price_monitoring_18:
    'жеткирүүчүлөр жана дилерлер менен жакшыраак кызматташуу үчүн',
  price_monitoring_19: 'Текче мейкиндигин өлчөө,',
  price_monitoring_20: 'товарлардын жайгашуусун жана кампада бар-жогун баалоо',
  price_monitoring_21: 'Негизги көрсөткүчтөр жана мониторинг критерийлери',
  price_monitoring_22:
    'Бардык маалыматтар бир интерфейсте чогултулат, анын ичинде:',
  price_monitoring_23: 'аты',
  price_monitoring_24: 'продукттун жана бренд категориясынын',
  price_monitoring_25: 'жеткиликтүүлүгү',
  price_monitoring_26: 'жарнамалык материалдардын',
  price_monitoring_27: 'баасы',
  price_monitoring_28: 'жана бардык жарнамалык сунуштардын жеткиликтүүлүгү',
  price_monitoring_29: 'текче',
  price_monitoring_30: 'өлчөмү',
  price_monitoring_31: 'продукт',
  price_monitoring_32: 'көрсөтүлүшү',
  price_monitoring_33: 'SKU',
  price_monitoring_34: 'facing',
  price_monitoring_35: 'түрү',
  price_monitoring_36: 'таңгактын',
  price_monitoring_37: 'каалаган башка',
  price_monitoring_38: 'жалпы маалымат',
  price_monitoring_39: 'Долбоор алдындагы анализ:',
  price_monitoring_40: 'Биз изилдейбиз',
  price_monitoring_41:
    'сиздин компанияңыздын баа жана продукт саясатын, бизнес жана тармактык практикаларды',
  price_monitoring_42: 'Биз камсыздайбыз',
  price_monitoring_43:
    'аудиторлор үчүн ыкчам окутуу, тестирлөө жана сертификация',
  price_monitoring_44: 'Биз ыңгайлаштырабыз',
  price_monitoring_45: 'жана программалык камсыздоону жөнгө салабыз',
  price_monitoring_46: 'Талаа иштери:',
  price_monitoring_47: 'Чекене соода түйүндөрүнө',
  price_monitoring_48: 'визиттер',
  price_monitoring_49: 'Отчеттуулук:',
  price_monitoring_50: 'Биздин аналитикалык команда',
  price_monitoring_51:
    'компаниянын жеке аккаунттарында онлайн отчетторду даярдайт',
  price_monitoring_52: 'Биз камсыздайбыз',
  price_monitoring_53:
    'жергиликтүү пункттун түрү, тармактын аталышы, түйүндүн дареги боюнча толук фото отчет, PPT отчет жана Excel отчет',
  price_monitoring_54: 'Бул кантип',
  price_monitoring_55: 'иштейт',
  price_monitoring_56: 'жеке арзандатуулардын өлчөмү',
  price_monitoring_57: 'наркты эсептөө',
  price_monitoring_58: 'жеке бонустардын өлчөмү',
  price_monitoring_59: 'лоялдуулук программалары',
  price_monitoring_60: 'ж.б.',
  price_monitoring_61:
    'Биз адистештирилген программалык камсыздоону колдонобуз:',
  price_monitoring_62:
    'PRADATA, Shopmetrics жана комплекстүү техникалык колдоону сунуштайбыз',
  price_monitoring_63: 'Тез ишке киргизүү',
  price_monitoring_64: 'жана масштабдоо (1-күндөн баштап)',
  price_monitoring_65: 'Бардык маалыматтар тастыкталат',
  price_monitoring_66: 'сүрөттөр жана GPS белгилөө аркылуу',
  price_monitoring_67: 'Бизде керектүү сандагы',
  price_monitoring_68: 'талаа агенттери каалаган өлкөдө бар',
  price_monitoring_69: 'Биз чоң көлөмдөгү',
  price_monitoring_70: 'маалыматтар менен иштей алабыз',
  price_monitoring_71: 'Жеке бааларды мониторингдөө',
  price_monitoring_72:
    'Эгерде сизде татаал продукттар болсо — биз сизге баа стратегияңызды аныктоого жардам бере алабыз',
  price_monitoring_73:
    'Биз атаандаштардын жеке бааларын мониторингдей алабыз, мисалы:',
  price_monitoring_74: 'Төмөн',
  price_monitoring_75: 'нарк',
  price_monitoring_76: 'Жогорку',
  price_monitoring_77: 'натыйжалуулук',
  price_monitoring_78: 'Excel отчет',
  price_monitoring_79: 'PPT отчет',
  price_monitoring_80: 'BI отчет',
  price_monitoring_81:
    'Атаандаштардын баа маалыматтары сизге эң жакшы баа чечимдерин кабыл алууга жардам берет',
  price_monitoring_82:
    'Биз жергиликтүү пункттун түрү боюнча толук фото отчет, PPT отчет жана Excel отчет беребиз',
  qualitative_research_1: 'Сапаттык',
  qualitative_research_2: 'изилдөөлөр',
  qualitative_research_3:
    'Кардарларыңыздын аракеттерин жана сөздөрүн байкоо аркылуу маалыматтарды чогултуу, талдоо жана чечмелөө',
  qualitative_research_4: 'Баалуулуктар',
  qualitative_research_5: 'Жүрүм-турум',
  qualitative_research_6: 'Фон',
  qualitative_research_7: 'Күтүүлөр',
  qualitative_research_8: 'Чөйрө',
  qualitative_research_9: 'Коркуулар/Тоскоолдуктар',
  qualitative_research_10: 'Кардардын тандоосунун максаты эмнеде?',
  qualitative_research_11: 'Телефон кармаган адам',
  qualitative_research_12: 'бренд',
  qualitative_research_13: 'категория',
  qualitative_research_14: 'жарнама',
  qualitative_research_15: 'продукт',
  qualitative_research_16:
    'Сапаттык методдордун өзгөчөлүгү — алар керектөөчүлөрдүн жүрүм-турумунун себептерин жана мотивациясын түшүнүүгө мүмкүндүк берет',
  qualitative_research_17:
    'Керектөөчүнүн белгилүү бир көрүнүшкө болгон мамилесин талдоо',
  qualitative_research_18: 'Жеке көз караштар жана тажрыйбалар',
  qualitative_research_19:
    'Сурамжылоо аркылуу изилдөөгө мүмкүн болбогон темалар',
  qualitative_research_20: 'Сезимтал темалар',
  qualitative_research_21: 'Жетүү кыйын болгон аудитория',
  qualitative_research_22: 'Татаал география',
  qualitative_research_23: 'Тереңдетилген маектер төмөнкүлөр үчүн пайдалуу:',
  qualitative_research_24: 'Тереңдетилген маектер',
  qualitative_research_25:
    'Тереңдетилген маек — бул белгилүү бир идея, программа же кырдаал боюнча респонденттердин көз караштарын изилдөө үчүн жеке маектерди жүргүзүүнү камтыган сапаттык изилдөө ыкмасы. Тереңдетилген маек жеке тажрыйбаларды / кабылдоолорду / практикаларды кеңири изилдейт.',
  qualitative_research_26: 'Максаттар:',
  qualitative_research_27: 'Социалдык жана маданий нормаларды мүнөздөө',
  qualitative_research_28: 'Жетүү кыйын болгон аудитория',
  qualitative_research_29:
    'Бөлүшүү жана салыштыруу (Morgan) сурамжылоолор аркылуу изилденет',
  qualitative_research_30:
    'Сурамжылоолор аркылуу изилдөөгө мүмкүн болбогон темалар',
  qualitative_research_31:
    'Тереңдетилген фокус-топтор төмөнкүлөр үчүн пайдалуу:',
  qualitative_research_32: 'Фокус-топтор',
  qualitative_research_33:
    'Жеке жолугушууларды терең изилдөө, топ модераторунун таасири астында пайда болгон талкуулар жана көрүнүштөр ортосундагы талкуулар.',
  qualitative_research_34:
    'Топтук талкуу жана багытталган талкуудагы баяндоо маалыматтары аркылуу жалпы тажрыйбалар жана социалдык нормалар боюнча инсайттарды жаратуу.',
  qualitative_research_36: 'Артыкчылыктар:',
  qualitative_research_37:
    'Керектөөчүнүн жашоо образын жана жүрүм-турумун ар кандай реалдуу шарттарда изилдөө (үйдө, сатуу түйүнүндө, жумушта ж.б.)',
  qualitative_research_38:
    'Жаңы продукттарды, таңгактоону, кызматты жакшыртууну ж.б. иштеп чыгуу үчүн инсайттарды издөө',
  qualitative_research_39:
    'Тереңдетилген этнографиялык изилдөө төмөнкүлөр үчүн пайдалуу:',
  qualitative_research_40: 'Этнографиялык изилдөө',
  qualitative_research_41:
    'Этнография — бул белгилүү бир коомчулукка же уюмга кирип, алардын жүрүм-турумун жана өз ара аракеттенүүсүн жакындан байкоону камтыган сапаттык изилдөөнүн бир түрү.',
  qualitative_research_42:
    'Этнография — бул топтун жалпы маданиятын, эрежелерин жана социалдык динамикасын терең түшүнүүгө мүмкүндүк берген ийкемдүү изилдөө ыкмасы. Бирок ал айрым практикалык жана этикалык кыйынчылыктарды да камтыйт.',
  qualitative_research_43: 'Методдор:',
  qualitative_research_44:
    'Этнография — бул керектөөчүнү чыныгы жашоо шарттарында жана продукт/кызмат менен өз ара аракеттенүүдө изилдөө',
  qualitative_research_45: 'Биз менен иштөөнүн артыкчылыктары',
  qualitative_research_46:
    'Биз каалаган максаттуу аудиториядан респонденттерди таба алабыз. Жана рекрутингдин сапатын көзөмөлдөйбүз',
  qualitative_research_47: 'Каалаган татаалдыктагы рекрутинг',
  qualitative_research_48:
    'Биздин модераторлор көп тилдүү жана фасилитация көндүмдөрүнө ээ',
  qualitative_research_49: 'Эксперт модераторлор',
  qualitative_research_50: 'Онлайн/офлайн иштөө',
  qualitative_research_51: 'Биз аудио/видео',
  qualitative_research_52: 'жазууларды камсыздайбыз',
  qualitative_research_53:
    'Биз каалаган жергиликтүү пунктта сапаттык изилдөө жүргүзө алабыз',
  quantitative_research_1: 'Кардарлардын канааттануусун изилдөө',
  quantitative_research_2: 'белгилүү бир продукт же кызмат менен (SCI, NPS)',
  quantitative_research_3: 'Сегментация жүргүзүү',
  quantitative_research_4: 'ар кандай рыноктор боюнча сурамжылоолор',
  quantitative_research_5: 'Рыноктук изилдөө',
  quantitative_research_6: 'NPS башкаруу',
  quantitative_research_7: 'Атаандаштарды талдоо',
  quantitative_research_8: 'Сандык',
  quantitative_research_9: 'изилдөөлөр',
  quantitative_research_10:
    'Адамдардын мамилеси жана жүрүм-туруму тууралуу теорияларды объективдүү, сандык жана статистикалык маалыматтардын негизинде текшерүү үчүн колдонулган изилдөө методологиясы',
  quantitative_research_11: 'жыл',
  quantitative_research_12: 'дүйнө жүзүндөгү CX тажрыйбасы',
  quantitative_research_13: 'панель',
  quantitative_research_14: 'респонденттердин',
  quantitative_research_15: 'өлкөлөр',
  quantitative_research_16: 'биз дүйнө жүзү боюнча долбоорлорду жүргүзөбүз',
  quantitative_research_17: 'Биз кимбиз',
  quantitative_research_18:
    '4Service — бул глобалдык маркетингдик изилдөө жана CX холдинги. Биз ар түрдүү бизнес үчүн эксперттик маалымат чогултуу кызматтарын сунуштайбыз',
  quantitative_research_19: '4Service сандар менен',
  quantitative_research_20: 'Компьютердин жардамы менен',
  quantitative_research_21: 'Веб-маектешүү',
  quantitative_research_22:
    'Интернетке негизделген анкета ыкмасы. Респондент интервьюердин жардамысыз электрондук анкетаны толтурат. Анкета электрондук түрдө жөнөтүлүшү же вебсайтка жайгаштырылышы мүмкүн.',
  quantitative_research_23: 'Computer Assisted Web Interviewing',
  quantitative_research_24: 'Көпчүлүк учурларда',
  quantitative_research_25:
    'бул ыкма материалдык жана убакыт чыгымдары боюнча эң үнөмдүү болуп саналат',
  quantitative_research_26: 'Бул сурамжылоо камсыздайт',
  quantitative_research_27:
    'жетүү кыйын болгон аудитория менен маектешүү мүмкүнчүлүгүн',
  quantitative_research_28: 'Ал кеңири мүмкүнчүлүктөрдү берет',
  quantitative_research_29:
    'видео жана аудио материалдарды, ошондой эле сүрөттөрдү көрсөтүү үчүн',
  quantitative_research_30: 'Респонденттер',
  quantitative_research_31: 'дүйнөнүн каалаган жеринде жайгашышы мүмкүн',
  quantitative_research_32: 'Бул изилдөөгө мүмкүндүк берет',
  quantitative_research_33:
    'интернет аудиториясынын өзгөчө жүрүм-турумун. Негизги жыйынтыктар кардар үчүн веб-интерфейс аркылуу реалдуу убакыт режиминде жеткиликтүү болот',
  quantitative_research_34: 'Ар кандай купуя,',
  quantitative_research_35:
    'сезимтал, жеке темалар же суроолор үчүн ылайыктуу, респонденттер интервьюер менен сүйлөшүүдө жооп берүүдөн тартынышы мүмкүн',
  quantitative_research_36: '150 000+ панель',
  quantitative_research_37:
    'Бизде дүйнө жүзү боюнча өз респонденттер панелибиз бар',
  quantitative_research_38: 'Биз татаал сурамдар менен иштейбиз',
  quantitative_research_39:
    'Кошумча куралдарды (социалдык тармактар, жарнама) колдонуу аркылуу биз белгилүү бир аудиторияны жана респонденттин так профилин таба алабыз',
  quantitative_research_40: 'Биз респонденттерибизди мотивациялайбыз',
  quantitative_research_41:
    'Биз материалдык стимулдарды берүү аркылуу узак сурамжылоолорду аяктоого шыктандыруучу алкак түздүк',
  quantitative_research_42: 'Face-to-face маектер',
  quantitative_research_43: 'планшет колдонуу менен жүргүзүлөт',
  quantitative_research_44:
    'Бул сандык маалыматтарды чогултуунун негизги ыкмаларынын бири, анда интервьюер респондент менен катуу структураланган анкета боюнча түз байланышат.',
  quantitative_research_45:
    'Face-to-face маектер респонденттердин иш ордунда же жашаган жеринде, көчөдө же белгиленген соода жайларында планшет колдонуу менен жүргүзүлүшү мүмкүн',
  quantitative_research_46:
    'Планшет колдонуу менен жүргүзүлгөн face-to-face маектер',
  quantitative_research_47: 'Деңгээлин аныктоо',
  quantitative_research_48: 'бренддин популярдуулугу жана таанылышынын',
  quantitative_research_49: 'Керектөөчүлөрдү сегментациялоо',
  quantitative_research_50: 'алардын сатып алуу жүрүм-турумуна негизделген',
  quantitative_research_51: 'Натыйжалуулукту талдоо',
  quantitative_research_52: 'жарнамалык кампаниянын',
  quantitative_research_53: 'Кардарлардын канааттануусу',
  quantitative_research_54: 'өлчөө',
  quantitative_research_55: 'Эң жакшы бааны аныктоо',
  quantitative_research_56: 'продукт же кызмат үчүн',
  quantitative_research_57: 'Талдоо',
  quantitative_research_58: 'керектөөчүлөрдүн артыкчылыктарынын',
  quantitative_research_59: 'Изилдөө',
  quantitative_research_60: 'керектөөчүлөр кандайча сатып аларынын',
  quantitative_research_61: 'Баалоо',
  quantitative_research_62: 'рынок сыйымдуулугунун',
  quantitative_research_63: 'DigSee программасы',
  quantitative_research_64:
    'Биз аудио жаздыруу жана GPS менен атайын программалык камсыздоону колдонобуз',
  quantitative_research_65: 'Интервьюерлер жана супервайзерлер',
  quantitative_research_66:
    'биз каалаган тилде маек жүргүзүп жана кардардын каалаган тилине которо алабыз',
  quantitative_research_67: 'Тандоо',
  quantitative_research_68:
    'Аналитикалык бөлүм эң жакшы натыйжа алуу үчүн респонденттерди тартуу системасын иштеп чыгат',
  quantitative_research_69: 'Компьютердин жардамы менен',
  quantitative_research_70: 'Телефондук интервью алуу',
  quantitative_research_71:
    'Так структураланган анкета аркылуу телефондук маектер менен сандык маалыматтарды чогултуу методологиясы.',
  quantitative_research_72: 'Computer Assisted Telephone Interviewing',
  quantitative_research_73: 'Бизде өз call-борборлорубуз бар',
  quantitative_research_74:
    'Биз аудио жаздыруу жана GPS менен атайын программалык камсыздоону колдонобуз',
  quantitative_research_75: 'Квалификациялуу операторлор',
  quantitative_research_76:
    'Биздин операторлор ар кандай тилдерде сүйлөйт, окутулган, жакшы текшерилген жана өз көндүмдөрүн дайыма өркүндөтүп турушат',
  quantitative_research_77: 'Маалымат базалары',
  quantitative_research_78:
    'Биз өзүбүздүн маалымат базаларыбыз жана сиздин кардар базаларыңыз менен да иштейбиз',
  quantitative_research_79: 'SLA',
  quantitative_research_80:
    'Биз сапатка кепилдик берип, SLA (Service Level Agreement) келишимине кол коёбуз',
  quantitative_research_81: 'Максаттарды коюу',
  quantitative_research_82: 'Методологияны аныктоо',
  quantitative_research_83: 'Сегментация жана тандоо',
  quantitative_research_84: 'Маалымат чогултуу каналдарын аныктоо',
  quantitative_research_85: 'Респондент үчүн логикалуу анкета түзүү',
  quantitative_research_86: 'Маалыматтарды чогултуу процесси',
  quantitative_research_87: 'Сапатты камсыздоо',
  quantitative_research_88: 'Талдоо ыкмалары',
  quantitative_research_89: 'Маалыматтарды иштетүү',
  quantitative_research_90: 'Сурамжылоону долбоорлоо',
  quantitative_research_91: 'Интервьюерлердин GPS жайгашкан жерин көзөмөлдөө',
  quantitative_research_92: 'Маалыматтарды текшерүү',
  quantitative_research_93: 'Анкетаны программалоо жана тестирлөө',
  quantitative_research_94: 'Маалыматтарды валидациялоо',
  quantitative_research_95: 'GDPR талаптарын сактоо менен аудио жазуулар',
  quantitative_research_96:
    'Изилдөө кызматкерлеринин окутуусу жана компетенттүүлүгү',
  quantitative_research_97: 'Сапатты камсыздоо',
  quantitative_research_98: 'Фактордук талдоо',
  quantitative_research_99: 'Сегментация',
  quantitative_research_100: 'Перцепциялык карталоо',
  quantitative_research_101: 'Корреляция',
  quantitative_research_102: 'Конверсия модели',
  quantitative_research_103: 'Jaccard',
  quantitative_research_104: 'Кластердик талдоо',
  quantitative_research_105: 'ж.б.',
  quantitative_research_106: 'Аналитикалык отчеттор',
  quantitative_research_107:
    'Биз ар кандай методологияларды колдонуу менен аналитикалык отчетторду түзүү үчүн SPSS® жана башка куралдарды колдонобуз',
  quantitative_research_108: 'Кандай бизнес маселелерин чечсе болот:',
  quantitative_research_109: 'Кандай бизнес маселелерин чечсе болот:',
  social_responsibility_1: '4Service корпоративдик социалдык жоопкерчилиги',
  social_responsibility_2:
    'Биздин команданын ар бир мүчөсүнүн жүрөгүнөн жана жан дүйнөсүнөн. Биз ар бир кызматкерибизде жакшылыктын учкунун сактоого жана айланадагы дүйнөнү бир аз жакшыраак кылууга аракет кылабыз',
  social_responsibility_3: 'Билим берүү иш-чаралары / Жаштарды колдоо',
  social_responsibility_4: 'Балдар жана студенттер үчүн биздин демилгелер',
  social_responsibility_5: 'Service Mania бизнес оюну',
  social_responsibility_6:
    'Биздин окутуу иш-чараларыбыздын маанилүү бөлүгү — бул Service Mania бизнес оюну.',
  social_responsibility_7:
    'Service Mania сизди адаттан тыш кырдаалдарды кантип чечүү керектиги тууралуу стратегиялык ойлонууга чакырат.',
  social_responsibility_8: 'Изилдөөнүн презентациясы / Diiya. Business',
  social_responsibility_9:
    'Кызмат көрсөтүү абалына бизнес жана кардар көз карашы: 4Service Украина өнүгүү бөлүмүнүн жетекчиси Виктория Скорботанын 4Service изилдөөлөрүнүн жыйынтыктарынын презентациясы',
  social_responsibility_10: 'Service Design сессиялары',
  social_responsibility_11:
    'Service Design методологиясы 4Service компаниясынын маанилүү бөлүгү болуп саналат. Бир нече жыл мурун биз DesignThinkers Academy өнөктөшү болуп калдык жана мыкты практикаларды ишибизде колдонуу менен гана чектелбестен, мыкты компанияларга активдүү окутуу өткөрөбүз',
  social_responsibility_12: 'Кайрымдуулук / Волонтёрлук',
  social_responsibility_13:
    'Балдар үйлөрү, карылар үйлөрү жана украин армиясы үчүн волонтёрлук. Биздин ишмердүүлүгүбүздүн эң таасирдүү бөлүгү',
  social_responsibility_14: '#HelpEasyWith4ServiceGroup',
  social_responsibility_15:
    'Биз Blagomai кайрымдуулук фонду менен өнөктөштүктө иштеп, майрам тартуулоого жана абдан муктаж адамдарга жардам берүүгө аракет кылабыз',
  social_responsibility_16:
    'Балдар үйлөрү жана карылар үйлөрү үчүн каражат чогултуу',
  social_responsibility_17:
    '4Service компаниясында биз карылар үйлөрү жана балдар үйлөрү үчүн негизги керектөөлөрдү сатып алууга багытталган бир нече каражат чогултуу акцияларын баштадык',
  social_responsibility_18: '#SaveUkraine',
  social_responsibility_19:
    'Согуш биздин көптөгөн кызматкерлерибизге жана жакын досторубузга таасирин тийгизди. Ар бирибиз колдон келишинче жардам берип жатабыз',
  social_responsibility_20: 'Жаныбарларды коргоо',
  social_responsibility_21:
    'Ар ким биздин кеңсеге үй жаныбары менен келе алат. Биз баш калкалоочу жайларга жардам берип, тамак-аш үчүн каражат чогултуп жана кээде үй-жайсыз жаныбарларга үй издейбиз',
  social_responsibility_22: 'Жаныбарлар баш калкалоочу жайларын колдоо',
  social_responsibility_23:
    'Үй-жайсыз жаныбарлар биздин коомдун бардык аялуу мүчөлөрү сыяктуу эле жардамга муктаж.',
  social_responsibility_24:
    'Биздин компания Sirius Stray Animal Shelter (Киев облусу, Украина) баш калкалоочу жайын камкордугуна алган.',
  social_responsibility_25:
    'Кароосуз жаныбарларга жардам берүү боюнча чыгармачыл демилгелер',
  social_responsibility_26:
    'Жаныбарлар баш калкалоочу жайларынын шашылыш көйгөйүнө кардарларыбыз менен өнөктөштөрүбүздүн көңүлүн кантип бура алабыз?',
  social_responsibility_27: 'Pet friendly кеңсе',
  social_responsibility_28:
    'Биздин команданын көп мүчөлөрүнүн үй жаныбарлары бар. Биз ар ким үй жаныбары менен кеңсеге келип, өзүн ыңгайлуу сезе ала турган ден соолукка пайдалуу чөйрөнү түздүк',
  ux_testing_1: 'UX тестирлөө',
  ux_testing_1_1: 'UX тестирлөө',
  ux_testing_2:
    'Сиздин вебсайттарыңызды жана тиркемелериңизди тестирлөө жана жакшыртуу үчүн адамдык жана AI негизиндеги ыкма',
  ux_testing_3: 'UX тестирлөө деген эмне',
  ux_testing_4:
    'UX тестирлөө адамдар сиздин продукт, тиркеме же вебсайт менен кандайча өз ара аракеттенерин түшүнүүгө жардам берет',
  ux_testing_5: 'Навигация анчалык түшүнүктүү эмес',
  ux_testing_6: 'Кантип заказ берүү керектигин түшүнбөй жатам',
  ux_testing_7: 'Каталогдо сүрөттөр жетишсиз',
  ux_testing_8: 'Сиз:',
  ux_testing_9: 'Жакшыртуу мүмкүнчүлүктөрүн табасыз',
  ux_testing_10:
    'Дизайндагы жана кардардын өз ара аракеттенүүсүндөгү көйгөйлөрдү аныктайсыз',
  ux_testing_11:
    'Колдонуучу сайт менен иштөөдө кандай кыйынчылыктарга туш болорун билесиз',
  ux_testing_12: 'Кардардын жолун байкайсыз',
  ux_testing_13:
    'Максаттуу аудиторияңыз качан жана эмне үчүн сайттан чыгып кетерин түшүнөсүз',
  ux_testing_14:
    'Кайсы бөлүмдөр эң аз жана эң көп кызыгууну жана эмоцияны жаратарын аныктайсыз',
  ux_testing_15: 'Колдонуучуга негизделген UX тестирлөө',
  ux_testing_16:
    '4Service сизге сапаттык жана сандык методдорду колдонуу аркылуу кардарга багытталган вебсайттарды жана тиркемелерди түзүү үчүн керектүү реалдуу адамдык инсайттарды берет',
  ux_testing_17:
    'Сайтты кантип колдонууну түшүнбөй жатам. Меню кайда жашырылган?',
  ux_testing_18:
    'Менимче, тамгалардын ортосунда өтө көп аралык бар, текст окулбайт',
  ux_testing_19:
    'Сүрөттөр бири-биринин үстүнө чыгып жатат. Ушундай болушу керекпи?',
  ux_testing_20:
    'UX тестирлөө адамдар сиздин продукт, тиркеме же вебсайт менен кандайча өз ара аракеттенерин түшүнүүгө жардам берет',
  ux_testing_21: 'Колдонуучуга негизделген UX тестирлөө изилдөөсүнүн дизайны:',
  ux_testing_22: 'Жакшыртуу мүмкүнчүлүктөрүн табуу',
  ux_testing_23: 'Тестирлөөнүн түрүн жана ыкмасын аныктоо (сапаттык/сандык)',
  ux_testing_24: 'Гипотезаларды жана колдонуучу сценарийлерин түзүү',
  ux_testing_25: 'Тест жыйынтыктарын талдоо жана отчет берүү',
  ux_testing_26: 'Эки чечим',
  ux_testing_27: 'Биз ийгиликтүү UX тестирлөө үчүн эки ыкманы сунуштайбыз',
  ux_testing_28: 'Колдонуучуга негизделген UX тестирлөө',
  ux_testing_29: 'AI + адамга негизделген UX тестирлөө',
  ux_testing_30: 'Биздин күчтүү жактарыбыз:',
  ux_testing_31: 'Биз атаандаштык чөйрөнү талдай алабыз',
  ux_testing_32:
    'Биз маектерди өткөрүү жана катышуу үчүн тар адистерди тарта алабыз',
  ux_testing_33:
    'Биз ар кандай тилдерде маек өткөрүп, аларды талап кылынган тилге которо алабыз',
  ux_testing_34: 'учурдагы usability',
  ux_testing_35: 'метрикалары же стандарттары менен',
  ux_testing_36: 'сиздин көрсөткүчтөрүңүз',
  ux_testing_37: 'атаандаштын көрсөткүчтөрүнө салыштырмалуу',
  ux_testing_38: 'версиялар',
  ux_testing_39: 'бир эле продукттун',
  ux_testing_40: 'Канааттануу рейтинги',
  ux_testing_41: 'NPS',
  ux_testing_42: 'Ийгилик көрсөткүчтөрү',
  ux_testing_43: 'Ката көрсөткүчү',
  ux_testing_44: 'Тапшырманы аткаруу убактысы',
  ux_testing_45: 'Колдонуучуга негизделген UX тестирлөө',
  ux_testing_46: 'Сандык ыкма',
  ux_testing_47:
    'Бул этаптагы UX тестирлөөгө катышуу үчүн биз кеминде 100 адамды колдонобуз',
  ux_testing_48:
    'Сизге вебсайтыңызды же тиркемеңизди салыштыруу керек болгондо актуалдуу:',
  ux_testing_49: 'Сандык ыкма өлчөйт:',
  ux_testing_50: 'Байкоо',
  ux_testing_51:
    'Колдонуучу же колдонуучулар тобу менен убакыт өткөрүп, алардын продуктту күнүмдүк жашоодо колдонуудагы жүрүм-турумун байкоо',
  ux_testing_52: 'Терең маек',
  ux_testing_53:
    'Сайтыңызга кирген колдонуучулардын көз карашын, ишенимдерин, каалоолорун жана тажрыйбасын билүүгө мүмкүнчүлүк берет. Биз 15-20 маек өткөрүүнү сунуштайбыз',
  ux_testing_54: 'Этнографиялык изилдөө',
  ux_testing_55:
    'Респонденттер продуктту колдоно турган чөйрөдө жүргүзүлөт. Байкоо жүргүзүү аркылуу сиз колдонуучунун психологиясын жана алар туш болгон эмоционалдык кыйынчылыктарды жакшыраак түшүнө баштайсыз.',
  ux_testing_56: 'Колдонуучуга негизделген UX тестирлөө',
  ux_testing_57: 'Сапаттык ыкма',
  ux_testing_58:
    'Бул ыкма колдонуучулардын жүрүм-турумунун мотивациясын жана логикасын түшүнүүгө жардам берет',
  ux_testing_59: 'Биз колдонобуз:',
  ux_testing_60:
    'Изилдөөнүн жыйынтыктарын көрсөтүү үчүн биз кардардын жол картасын иштеп чыгып жатабыз',
  ux_testing_61: '30 катышуучу (эркек/аял)',
  ux_testing_62:
    'Респонденттер алдын ала тандалып, сурамжылоого катышууга чакырылат',
  ux_testing_63: 'Wantent платформасында алыстан онлайн маек жүргүзүү',
  ux_testing_64: 'AI + адамга негизделген',
  ux_testing_65: 'AI + адамга негизделген UX тестирлөө',
  ux_testing_66:
    'Wantent уникалдуу жасалма интеллект технологиясы менен чыныгы колдонуучулардын айкалышы',
  ux_testing_67: 'Башкы аталыштагы чоң шрифт көңүлдү бурду',
  ux_testing_68:
    "Колдонуучулар 'көзгө урунарлык' сандарды карашат, бирок жанындагы маалыматты окушпайт",
  ux_testing_69:
    'UX тестирлөө адамдар сиздин продукт, колдонмо же веб-сайт менен кандайча өз ара аракеттенерин түшүнүүгө жардам берет',
  ux_testing_70: 'AI + адамга негизделген тестирлөө изилдөө дизайны',
  ux_testing_71: 'Бул кандай иштейт',
  ux_testing_72: 'Wantent — AI негизиндеги content-market fit чечими.',
  ux_testing_73:
    'Wantent аудиториянын эмоционалдык реакцияларын жана катышуусун талдоо үчүн ML технологияларын колдонуп, веб-сайттар менен колдонмолордун натыйжалуулугун баалайт.',
  ux_testing_74:
    'Жыйынтыктарды чечмелөө үчүн биз storytelling ыкмаларын, ар түрдүүлүктү жана эмпатияны колдонобуз, бул өндүрүмдүүлүк менен өсүштү камсыз кылат.',
  ux_testing_75:
    'Бөлүмдөр ортосунда өтүү учурунда колдонуучунун көңүлү жана эмоциялары',
  ux_testing_76:
    'Катышуучулар тобу боюнча статистика (сессия учурунда көңүл буруу жана фокус)',
  ux_testing_77: 'Баракча конверсияларын талдоо',
  ux_testing_78: 'Тапшырмаларды аткаруу учурунда көңүл жана эмоциялар',
  ux_testing_79: 'Кабыл алуу боюнча жыйынтыктар',
  ux_testing_80:
    'ар кандай катышуучулар топтору тарабынан веб-сайтты кабыл алуу боюнча',
  ux_testing_81: 'Ыңгайлуулукту талдоо',
  ux_testing_82:
    'баракчалар боюнча навигациянын жана маанилүү элементтерди табуунун жеңилдиги',
  ux_testing_83: 'Кабыл алууну талдоо',
  ux_testing_84: 'веб-сайтта берилген маалымат боюнча',
  ux_testing_85: 'Аныкталган аймактар',
  ux_testing_86:
    'өзүнчө баракчалардагы жакшыртуу үчүн (навигация, маалымат блоктору ж.б.)',
  ux_testing_87: 'Биз деталдуу талдайбыз',
  ux_testing_88: 'Изилдөөнүн негизги жыйынтыктары',
  ux_testing_89:
    'Веб-сайттын түзүмүн жана өзүнчө баракчаларды жакшыртуу боюнча сунуштар',
  ux_testing_90:
    'Биз Usability Testing үчүн максаттуу аудиторияны кылдаттык менен тандайбыз.',
  ux_testing_91:
    'Биз ар кандай өлкөлөрдө, ар кандай тилдерде жана ар кандай колдонуучулар топторунун арасында изилдөө жүргүзөбүз',
  ux_testing_92: 'Биз колдонмолордо тест жүргүзө алабыз',
  ux_testing_93:
    'жана атаандаштардын веб-сайттарында салыштырма талдоо жүргүзөбүз',
  ux_testing_94: 'Биз ар кандай изилдөө ыкмаларын айкалыштырабыз.',
  ux_testing_95:
    'Биздин квалификациялуу фасилитаторлор катышуучуларды тестирлөө процессинде жетектейт.',
  ux_testing_96: 'Биз тестирлөө жүргүзөбүз',
  ux_testing_97:
    'ар кандай түзмөктөрдө жана программалык камсыздоонун версияларында',
  ux_testing_98: 'Эмне үчүн бизди тандашат?',
  wantent_1: '4Service x',
  wantent_2: 'Wantent',
  wantent_3:
    '4Service жана Wantent © тарабынан түзүлгөн уникалдуу өнөктөш долбоор — контентти талдоо үчүн жасалма интеллект менен адамга негизделген ыкманын айкалышы',
  wantent_4: 'контент эфирге чыкканга чейин ийгиликти өлчөө',
  wantent_5: 'ар түрдүүлүк маселелеринин тобокелдиктерин азайтуу',
  wantent_6: 'контентти жакшыртуу үчүн терең инсайттар жана сунуштар',
  wantent_7: 'контент жана маркетинг стратегиясы боюнча объективдүү чечимдер',
  wantent_8: 'Wantent — AI негизиндеги content-market fit чечими.',
  wantent_9:
    'Wantent — контентти рынокко ылайыкташтыруу үчүн жасалма интеллектке негизделген чечим. Wantent аудиториянын эмоционалдык реакциясын жана катышуусун талдоо үчүн ML технологияларын колдонуп, видео контенттин натыйжалуулугун баалайт.',
  wantent_10:
    'Wantent контенттин рынокко шайкештигин аныктоого жана анын натыйжалуулугун жогорулатууга жардам берет:',
  wantent_11: 'Сценарийди даярдоо жана катышуучуларды тартуу',
  wantent_12: 'жекелештирилген долбоор дизайны жана дүйнөлүк аудитория',
  wantent_13: 'Көрүүчүлөрдүн реакцияларын чогултуу',
  wantent_14: 'аудиториядан деталдуу жана так пикир алуу',
  wantent_15: 'Контентти кабыл алууну талдоо',
  wantent_16: 'AI аркылуу жүрүм-турумду жана эмоционалдык реакцияны талдоо',
  wantent_17: 'Акыркы жыйынтык үчүн инсайттарды берүү',
  wantent_18: 'жакшыртуу боюнча сунуштар',
  wantent_19: 'Wantent сиздин контенттин натыйжалуулугун максималдаштырат',
  wantent_20: 'Жарнама концепцияларын алдын ала тестирлөө',
  wantent_21: 'Креативдүү концепцияларды тестирлөө',
  wantent_22:
    'Келечектеги креативдин иштелип чыккан стратегияга шайкештигин текшерүү жана максаттуу аудиториянын реакциясын түшүнүү, креативдүү концепцияларды/билдирүүлөрдү тууралоо үчүн',
  wantent_23:
    'Бренд элементтеринин көрүнүмдүүлүгүн тестирлөө (post-production)',
  wantent_24: 'Жарнама/демөөрчүлүк инвестициясынын натыйжалуулугун ырастоо',
  wantent_25: 'Жарнаманы тестирлөө',
  wantent_26: 'A/B тестирлөө',
  wantent_27:
    'Креативдердин натыйжалуулугун салыштыруу жана өндүрүш фазасында катышууну жана көңүлдү жогорулатуу',
  wantent_28: 'Ишке киргизилген жарнаманы тестирлөө',
  wantent_29:
    'Билдирүүлөрдүн натыйжалуулугун аныктоо жана аудио менен визуалды жакшыртуу боюнча сунуштарды түзүү',
  wantent_30: 'ТВ үчүн чечимдер',
  wantent_31:
    'Пилотторду, промолорду, жаңы форматтарды жана ТВ алып баруучуларды тестирлөө',
  wantent_32:
    'Эң кызыктуу вариантты аныктоо жана аны күчөтүү үчүн салыштырма талдоо жүргүзүү',
  wantent_33: 'ТВ шоуларын жана көркөм фильмдерди тестирлөө',
  wantent_34:
    'Узун контентти табигый шарттарда көрүү учурунда көрүүчүлөрдүн катышуусун, көңүл буруу деңгээлин жана эмоционалдык реакциясын талдоо. Биз аудиториянын кетип калуу чокуларын жана алаксыган учурларын автоматтык түрдө аныктап, видеомонтажды баалоого жана жакшыртууга жардам беребиз',
  wantent_35: 'UI/UX тестирлөө',
  wantent_36: 'Веб-сайт прототиптерин жана мобилдик тиркемелерди тестирлөө',
  wantent_37:
    'Wantent технологиясын колдонуу менен колдонуучулардын реакциясын жана эмоцияларын талдоо:',
  wantent_38: 'көңүл буруу деңгээли',
  wantent_39: 'эмоционалдык реакциялар',
  wantent_40: 'катышуучулардын көз карашынын багыты боюнча heatmap карталары',
  wantent_41:
    'Катышуучулардын пикиринин негизинде веб-сайттын жана тиркеменин колдонууга ыңгайлуулугун талдоо:',
  wantent_42: 'Системанын колдонууга ыңгайлуулук шкаласы (SUS)',
  wantent_43: 'Кардардын аракет индекси (өз ара аракеттенүүнүн жеңилдиги)',
  wantent_44: 'Таза сунуштоо көрсөткүчү (NPS)',
  wantent_45: 'GDPR талаптарына шайкештик жана колдонуучунун купуялыгы',
  wantent_46:
    'Wantent GDPR жана CCPA саясаттарына толук шайкеш келет жана катышуучулардын жеке маалыматтарын чогултуу, сактоо, иштетүү жана коргоо принциптерине жооп берет',
  wantent_47: 'Никита Лобынцев',
  wantent_48: 'СDO, Reface (Медиа жана көңүл ачуу)',
  wantent_49:
    'Биз күн сайын машина үйрөнүү технологиялары менен көптөгөн жаңы контент идеяларын сынап көрөбүз. Wantent бизге тобокелдиктерди жана артыкчылыктарды түшүнүүгө жана баалоого, колдонуучулардын пикирлерин, жүрүм-турумун жана кабылдоосун изилдөөгө жардам берип, чечимдерибиздин ар кандай аспектилеринин себеп-натыйжасын түшүнүүгө мүмкүндүк берет.',
  wantent_50: 'Александр Смирнов',
  wantent_51: 'TABASCO компаниясынын тең ээси (Жарнама)',
  wantent_52:
    'Wantent бизге керектөөчүлөр эмнени жактырарын жана жактырбасын эң майда деталдарына чейин түшүнүүгө жардам берген чындап уникалдуу кызматты сунуштайт. Бул жерде алдоо же жалган айтуу мүмкүн эмес — Wantent ар дайым чындыкты билет, ал эми биз маркетинг адистери катары коммуникациябызды жакшыртуу боюнча баа жеткис (ха-ха — биз анын так баасын билебиз жана ал жеткиликтүү) сунуштарды алабыз.',
  wantent_53: 'Пикирлер',
  terms_1: 'Шарттар жана жоболор',
  terms_2: 'Колдонуу шарттары жөнүндө келишим',
  terms_3:
    'Сураныч, 4Service Holdings GmbH тарабынан башкарылган веб-сайтты колдонордон мурун ушул Колдонуу шарттары жөнүндө келишимди (“колдонуу шарттары”, “келишим”) кунт коюп окуп чыгыңыз',
  terms_4: '(“веб-сайт”) (“4Service”, “биз”, “биздин”).',
  terms_5:
    'Колдонуу шарттары. Бул веб-сайтты колдонуу менен сиз ушул Келишимди окуп чыгып, анын шарттарын аткарууга макул экениңизди ырастайсыз. Эгер сиз ушул Келишимдин шарттарына баш ийүүнү каалабасаңыз, веб-сайттан чыгып кетүү сунушталат. 4Service бул веб-сайтты, анын өнүмдөрүн жана кызматтарын ушул шарттарды кабыл алган адамдарга гана колдонууга жана жетүүгө уруксат берет.',
  terms_6: 'Купуялык саясаты',
  terms_7:
    'Веб-сайтыбызды колдонууну улантуудан мурун, колдонуучулардын маалыматтарын чогултуу боюнча биздин Купуялык саясатыбызды окуп чыгууну сунуштайбыз. Бул биздин практикаларды жакшыраак түшүнүүгө жардам берет.',
  terms_8: 'Жаш курак боюнча чектөө',
  terms_9:
    'Бул веб-сайтты колдонуу үчүн сиз кеминде 16 (он алты) жашта болушуңуз керек. Бул веб-сайтты колдонуу менен сиз кеминде 16 жашта экениңизди жана ушул Келишимге мыйзамдуу түрдө кошула аларыңызды кепилдейсиз. 4Service жаш куракты туура эмес көрсөтүүгө байланыштуу эч кандай жоопкерчилик тартпайт.',
  terms_10: 'Интеллектуалдык менчик',
  terms_11:
    'Сиз бул веб-сайттагы бардык материалдар, өнүмдөр жана кызматтар 4Service компаниясынын, анын туунду компанияларынын, директорлорунун, кызматкерлеринин, агенттеринин, жеткирүүчүлөрүнүн же лицензия берүүчүлөрүнүн менчиги экенине макул болосуз, анын ичинде бардык автордук укуктар, коммерциялык сырлар, товардык белгилер, патенттер жана башка интеллектуалдык менчик объектилери. Ошондой эле сиз 4Service компаниясынын интеллектуалдык менчигин кандайдыр бир жол менен, анын ичинде электрондук, санариптик же жаңы товардык белги каттоолору аркылуу көчүрбөөгө жана кайра таратпоого макул болосуз.',
  terms_12: 'Веб-сайтыбызга жетүү',
  terms_13:
    'Биздин Сайтка жетүү убактылуу негизде берилет жана биз сайтта сунушталган кызматтарды алдын ала эскертүүсүз өзгөртүү же токтотуу укугун өзүнө калтырабыз. Эгер кандайдыр бир себептерден улам биздин сайт каалаган убакта же белгилүү бир мезгил ичинде жеткиликсиз болуп калса, биз жоопкерчилик тартпайбыз. Кээде биз сайттын айрым бөлүктөрүнө же толугу менен сайтка жетүүнү бизде катталган колдонуучулар үчүн чектешибиз мүмкүн. Сиз биздин сайтка жетүү үчүн зарыл болгон бардык шарттарды, анын ичинде биздин сайтка шайкеш келген жабдууларды колдонуу боюнча жоопкерчилик тартасыз. Ошондой эле сиздин интернет байланышыңыз аркылуу биздин сайтка кирген бардык адамдар ушул шарттар менен тааныш болуп, аларды сакташын камсыз кылуу сиздин милдетиңиз.',
  terms_14: 'Колдонулуучу мыйзам',
  terms_15:
    'Бул веб-сайтка кирүү менен сиз Австрия Республикасынын мыйзамдары, мыйзамдардын карама-каршылыгынын принциптерине карабастан, ушул шарттарды жана 4Service менен сиздин ортодо жаралышы мүмкүн болгон ар кандай талаштарды жөнгө саларына макул болосуз.',
  terms_16: 'Талаштар',
  terms_17:
    'Бул веб-сайтка кирүүңүзгө байланыштуу бардык талаштар Венадагы Коммерциялык сот тарабынан каралат.',
  terms_18: 'Ордун толтуруу',
  terms_19:
    'Сиз 4Service жана анын туунду компанияларын биздин веб-сайтты колдонууңуздан же туура эмес колдонууңуздан келип чыгышы мүмкүн болгон юридикалык дооматтардан жана талаптардан коргоого макул болосуз. Биз өзүбүздүн юридикалык кеңешчибизди тандоо укугун сактайбыз.',
  terms_20: 'Сактоо мөөнөтү',
  terms_21:
    'Иштетүүнүн максаттарын эске алуу менен, Колдонуучулардын жеке маалыматтарын сактоо мөөнөтү (сактоо мөөнөтү) сизден маалыматтарды иштетүүгө макулдук мыйзамдуу түрдө алынган күндөн тартып 24 айды түзөт.',
  terms_22: 'Жоопкерчиликти чектөө',
  terms_23:
    '4Service биздин веб-сайтты туура эмес колдонууңуздун натыйжасында келип чыгышы мүмкүн болгон эч кандай зыян үчүн жооп бербейт. 4Service бул Келишимди алдын ала эскертүүсүз каалаган убакта түзөтүү, өзгөртүү жана жаңыртуу укугун өзүнө калтырат. Веб-сайтты мындан ары колдонууңуз мындай өзгөртүүлөрдү кабыл алганыңызды билдирет. Эгер ушул келишимдин кандайдыр бир бөлүгү мыйзамсыз, жараксыз же аткарылгыс деп табылса, анда ал бөлүк өзүнчө каралат жана калган жоболордун жарактуулугуна жана аткарылышына таасир этпейт. Веб-сайтты мыйзамсыз максаттарда колдонуу боюнча мүмкүн болгон далилдер укук коргоо органдарына берилет. Бул Келишим 4Service менен колдонуучунун ортосундагы түшүнүшүүнү билдирет.',
  terms_24:
    'Купуялыкка/колдонууга байланыштуу бардык суроолорду жана кайрылууларды төмөнкү дарекке жөнөтүңүз:',
  terms_25: '4Service Holdings GmbH',
  terms_26: 'Tegetthoffstrasse 7',
  terms_27: '1010 Вена',
  terms_28: 'Австрия',
  terms_29: 'Карап чыгуу',
  terms_30:
    'Эгерде сиз бизге берген жеке маалыматтар так эмес болсо, анда сиз аларды оңдоону талап кылууга укуктуусуз (GDPR 16-берене).',
  thank_you_1: 'Рахмат!',
  thank_you_2: 'Биз сиз менен 24 сааттын ичинде байланышабыз',
  thank_you_3:
    'P.S. Биздин менеджерлер сизге жакшыраак сунуш даярдоо үчүн өтүнүчүңүздү азыртан карап жатышат',
  thank_you_4: 'Меню',
  thank_you_5: 'Терип жаткан аял',
  privacy_policy_1:
    'Маалымат субъекттери үчүн купуялык билдирүүсү (веб-сайт колдонуучулары үчүн)',
  privacy_policy_2:
    'Бул Купуялык билдирүүсү (Купуялык билдирүүсү) GDPR талаптарына ылайык 4Service Holdings GmbH тарабынан веб-сайтка кирүү учурунда жеке маалыматтары чогултулган жеке адамдарга (Маалымат субъекттерине) арналган',
  privacy_policy_3:
    '(мындан ары Веб-сайт жана тиешелүүлүгүнө жараша Веб-сайттын колдонуучулары/Колдонуучулар деп аталат).',
  privacy_policy_4:
    '4Service Holdings GmbH компаниясынын Маалымат субъекттери үчүн Купуялык билдирүүсү 4Service Group курамындагы жана 4Service Holdings GmbH юридикалык көзөмөлүндө турган бардык компанияларга колдонулат.',
  privacy_policy_5: 'Байланыштар',
  privacy_policy_6: '4Service Holdings GmbH',
  privacy_policy_7: '(Компания/биз),',
  privacy_policy_8: 'Дарек:',
  privacy_policy_9: 'Tegetthoffstraße 7, 1010 Вена, Австрия.',
  privacy_policy_10: 'Электрондук почта:',
  privacy_policy_12: 'Биз кимбиз?',
  privacy_policy_13:
    'Каалаган максатта Веб-сайтка кирген Жеке адам (Сиз). Ушул Документтин максаттары үчүн Сиз ошондой эле Колдонуучу деп аталасыз.',
  privacy_policy_14: 'Биз сизден чогулткан жеке маалыматтар',
  privacy_policy_15:
    'Веб-сайтыбызга киргенде, биз сизге Купуялык билдирүүсүн жөнөтөбүз, анда төмөнкү маалыматтарды иштетүүгө макулдугуңузду берүү сунушталат:',
  privacy_policy_16:
    'IP дарек, колдонуучунун аты-жөнү, фамилиясы, дареги, телефон номери (үй же мобилдик), электрондук почта дареги, компаниянын аталышы, өлкө, аты, фамилиясы, телефон номери, облус, штат жана ZIP/почта индекси, колдонуу маалыматтары, тышкы социалдык тармактар же платформалар менен өз ара аракеттенүү тууралуу маалымат, веб-сайтта катталуу жана аутентификация тууралуу маалымат',
  privacy_policy_17: 'географиялык жайгашкан жери.',
  privacy_policy_18:
    'Эгерде сиз өз эркиңизди билдирип, бизге мындай макулдукту берсеңиз, анда биз сизден алынган бул маалыматтарды иштете баштайбыз.',
  privacy_policy_19: 'Мыйзамдуулук (макулдук)',
  privacy_policy_20:
    'Веб-сайтыбызга киргенде, биз сизге Купуялык билдирүүсүн жөнөтөбүз, анда төмөнкү маалыматтарды иштетүүгө макулдугуңузду берүү сунушталат:',
  privacy_policy_21:
    'Жеке маалыматтарды иштетүүнүн укуктук негизи — бул төмөнкү шилтеме аркылуу макулдук формасын толтуруу менен сизден ала турган макулдук:',
  privacy_policy_22:
    'Эгерде сиз макулдук формасын толтурсаңыз, анда бул сиз ушул Купуялык билдирүүсүндө көрсөтүлгөн бардык шарттарды түшүнүп жана кабыл алганыңызды билдирет.',
  privacy_policy_23: 'Макулдукту кайтарып алуу',
  privacy_policy_24:
    'Сиз бизге мурда берген макулдукту каалаган убакта кайтарып алууга укуктуусуз. Макулдукту кайтарып алуу ага чейин берилген макулдуктун негизинде жүргүзүлгөн иштетүүнүн мыйзамдуулугуна таасир этпейт. Сиз макулдугуңузду withdraw@4service-group.com электрондук дарегине тиешелүү өтүнүч жөнөтүү аркылуу кайтарып ала аласыз, өтүнүч формасы төмөнкү шилтемеде жеткиликтүү:',
  privacy_policy_25: 'Колдонуучу үчүн кайтарып алуу формасы',
  privacy_policy_26: 'Иштетүүнүн максаттары',
  privacy_policy_27:
    'We process your personal data for the following purposes:',
  privacy_policy_28:
    '– кардарларды тейлөөнү жакшыртуу (бул кардарлардын суроо-талаптарына натыйжалуураак жооп берүүгө мүмкүндүк берет); – Колдонуучулардын тажрыйбасын жекелештирүү (бул кызматтар ким үчүн көбүрөөк кызыктуу экенин аныктоого мүмкүндүк берет); – Сайтты жакшыртуу (бул өнүмдөрдүн жана кызматтардын сапатын, аларды колдонуунун ыңгайлуулугун жакшыртууга, жаңы Кызматтарды иштеп чыгууга жана биздин өнүмдөр менен кызматтарды өркүндөтүүгө мүмкүндүк берет); – Колдонуучу менен жаңылыктар, маркетингдик же жарнамалык материалдар жана биздин жаңылыктар, жаңыртуулар, кызматтар тууралуу маалыматтарды жөнөтүү аркылуу байланышуу, ошондой эле кийинки электрондук каттарды алуудан кантип баш тартуу керектиги тууралуу көрсөтмөлөрдү берүү; – анонимдештирилген маалыматтардын негизинде статистикалык жана башка изилдөөлөрдү жана талдоолорду жүргүзүү; – Колдонуучуга жекелештирилген кызматтарды көрсөтүү жана келишимдерди аткаруу; – Колдонуучунун Сайт аркылуу биз ишке ашырган ар кандай долбоорлорго катышуусу, Колдонуучу тарабынан Сайт аркылуу жөнөтүлгөн суроолорго жооп берүү, изилдөө жүргүзүү, эсептерди жана жазууларды жүргүзүү жана кызматтарды илгерилетүү.',
  privacy_policy_29:
    'Жеке маалыматтар өткөрүлүп берилиши мүмкүн болгон субъекттер',
  privacy_policy_30:
    'Сиздин жеке маалыматтарыңызды иштетүү учурунда биз аларды Компаниянын процессорлору катары иш алып барган субъекттерге өткөрүп беребиз. Компаниянын процессорлору Компаниянын көрсөтмөлөрүнүн негизинде гана иш жүргүзөт. Компаниянын процессорлору жүргүзгөн аракеттердин өзгөчөлүктөрү жана мындай процессорлордун тизмеси төмөнкү шилтемедеги Купуялык жана маалыматтарды коргоо саясатында көрсөтүлгөн: Купуялык жана маалыматтарды коргоо саясаты',
  privacy_policy_31:
    'Жеке маалыматтар өткөрүлүп берилиши мүмкүн болгон өлкөлөр',
  privacy_policy_32:
    'Компания сиздин жеке маалыматтарыңызды GDPR жана ЕБ Комиссиясынын талаптарына ылайык жетиштүүлүк чечиминин негизинде өткөрүп берет. АКШга жеке маалыматтарды өткөрүп берүү боюнча кошумча маалыматты төмөнкү шилтемедеги Купуялык жана маалыматтарды коргоо саясатынан таба аласыз: Купуялык жана маалыматтарды коргоо саясаты.',
  privacy_policy_33: 'Сактоо мөөнөтү',
  privacy_policy_34:
    'Иштетүүнүн максаттарын эске алуу менен, Колдонуучулардын жеке маалыматтарын сактоо мөөнөтү (сактоо мөөнөтү) маалыматтарды иштетүүгө сизден тийиштүү макулдук алынган күндөн тартып 24 айды түзөт.',
  privacy_policy_35: 'Жеткиликтүүлүк укугу',
  privacy_policy_36:
    'Сиз өзүңүзгө тиешелүү жеке маалыматтар иштетилип жатканын билүүгө жана эгер ошондой болсо, GDPR 15-беренесинде көрсөтүлгөн кошумча шарттар менен бул маалыматтарга жетүүгө укуктуусуз.',
  privacy_policy_37: 'Оңдоо укугу',
  privacy_policy_38:
    'Эгерде сиз бизге берген жеке маалыматтар так эмес болсо, анда сиз аларды оңдоону талап кылууга укуктуусуз (GDPR 16-берене).',
  privacy_policy_39: 'Өчүрүү укугу (унутулуу укугу)',
  privacy_policy_40:
    'Сиз биздин тараптан жеке маалыматтарыңызды негизсиз кечиктирбестен өчүрүүнү талап кылууга укуктуусуз, ал эми GDPR 17-беренесинде көрсөтүлгөн негиздер колдонулган учурда биз аларды кечиктирбестен өчүрүүгө милдеттүүбүз.',
  privacy_policy_41: 'Иштетүүнү чектөө укугу',
  privacy_policy_42:
    'GDPR алкагында, айрыкча GDPR 18-беренесинде көрсөтүлгөн айрым өзгөчөлүктөр менен, сиз жеке маалыматтарыңызды иштетүүнү чектөөгө укуктуусуз.',
  privacy_policy_43:
    'Биз сизге кандай маалыматтар чогултулуп жатканын, алар кантип колдонуларын, канча убакыт сакталарына жана үчүнчү жактарга берилер-берилбесин маалымдоого милдеттүүбүз. Бул маалымат кыска жана түшүнүктүү тилде берилүүгө тийиш.',
  privacy_policy_44: 'Маалыматтарды көчүрүп алуу укугу',
  privacy_policy_45:
    'Сиз жеке маалыматтарыңызды ар кандай кызматтар арасында өз максаттарыңыз үчүн алууга жана кайра колдонууга укуктуусуз.',
  privacy_policy_46: 'Каршы чыгуу укугу',
  privacy_policy_47:
    'Сиз Компания тарабынан иштетилип жаткан жеке маалыматтарды иштетүүгө каршы чыгууга укуктуусуз. Эгерде биз иштетүүнүн адамдын кызыкчылыктарынан, укуктарынан жана эркиндиктеринен жогору турган олуттуу мыйзамдуу негиздерин көрсөтө албасак же иштетүү юридикалык дооматтарды түзүү, жүзөгө ашыруу же коргоо үчүн зарыл болбосо, анда биз жеке маалыматтарды иштетүүнү токтотууга милдеттүүбүз.',
  privacy_policy_48:
    'Толугу менен автоматташтырылган иштетүүгө негизделген чечимге баш ийбөө укугу',
  privacy_policy_49:
    'Сиз макулдугуңузсуз жүргүзүлгөн ар кандай автоматташтырылган профилдештирүүгө каршы чыгууга укуктуусуз. Ошол эле учурда, сиздин жеке маалыматтарыңыз адамдын катышуусу менен иштетилиши керек.',
  privacy_policy_50: 'Даттануулар',
  privacy_policy_51:
    'Эгерде сиз Компания (же жогоруда сүрөттөлгөн процессорлор) тарабынан жеке маалыматтарыңыз кандай иштетилип жатканы же сиздин даттанууңуз кандай каралып жатканы тууралуу даттангыңыз келсе, анда сиз түздөн-түз көзөмөлдөөчү органга жана Компанияга даттанууга укуктуусуз.',
  privacy_policy_52: 'Бул байланыштардын ар бири үчүн маалыматтар төмөнкүлөр:',
  privacy_policy_53: 'Көзөмөлдөөчү орган:',
  privacy_policy_54: 'Австриянын маалыматтарды коргоо органы',
  privacy_policy_55: 'Österreichische Datenschutzbehörde',
  privacy_policy_56: 'Wickenburggasse 8',
  privacy_policy_57: '1080 Вена',
  privacy_policy_58: 'Австрия / Европа',
  privacy_policy_59: 'Компания:',
  privacy_policy_60: '4Service Holdings GmbH (Компания/биз),',
  privacy_policy_61: 'Дарек: Tegetthoffstraße 7, 1010 Вена, Австрия.',
  privacy_policy_62: 'Электрондук почта:',
  privacy_policy_63: 'Купуялык жана маалыматтарды коргоо саясаты',
  privacy_policy_64:
    'Маалыматтарыңызды кантип жана эмне үчүн колдонорубуз тууралуу кененирээк бул жерден окуңуз: Купуялык жана маалыматтарды коргоо саясаты',
  privacy_policy_65: 'Бекитүү',
  privacy_policy_66:
    'Компания Компаниянын ичинде жеке маалыматтарды иштетүүгө байланыштуу кызматкерлердин ролдорун аныктоо үчүн бардык ички документтерди иштеп чыккан, айрыкча бул документтин мыйзамдуулугун бекитүү жана кайра кароо үчүн Башкы директор жооптуу.',
  contacts_1: 'Кардарлар үчүн',
  contacts_2:
    'Бардык түрдөгү бизнес, маркетингдик изилдөө агенттиктери жана ири компаниялар, бизнес өнөктөштөр жана медиа үчүн.',
  contacts_3: 'Tegetthoffstrasse 7, Вена, Австрия',
  contacts_4: 'Шопперлер үчүн',
  contacts_5:
    'Жергиликтүү тургундар жана саякатчылар, айдоочулар жана студенттер, кесипкөй mystery shopperлер жана үйдө отургандар.',
  contacts_6: 'Өлкөңүздөн биз менен байланышыңыз:',
  contacts_7: 'Италия',
  contacts_8: 'АКШ',
  contacts_9: 'Улуу Британия',
  contacts_10: 'Швейцария',
  contacts_11: 'Нидерланддар',
  contacts_12: 'Словакия',
  contacts_13: 'Словения',
  contacts_14: 'Румыния',
  contacts_15: 'Азербайжан',
  contacts_16: 'Украина',
  contacts_17: 'Казакстан',
  contacts_18: 'Дүйнөнүн калган бөлүгү',
  menu_1: 'CJM',
  menu_2: 'NPS',
  menu_3: 'CSI',
  menu_4: 'BHT',
  menu_5: 'UX тестирлөө',
  menu_6: 'HR изилдөөлөрү',
  menu_7: 'Сапаттык изилдөөлөр',
  menu_8: 'Сандык изилдөөлөр',
  menu_9: 'Mystery shopping',
  menu_10: 'Voicer',
  menu_11: 'Play4Sales',
  menu_12: 'Wantent',
  menu_13: 'Бааларды мониторинг кылуу',
  menu_14: 'Биз жөнүндө',
  menu_15: 'Байланыштар',
  menu_16: 'Блог',
  menu_17: 'Методдор',
  menu_18: 'Продукттар',
  menu_19: 'Шопперлер \n платформасы',
  menu_20: 'CSR',
  menu_21: 'Автомобилдик бааларды талдоо',
  menu_22: 'Facility Check Audit',
  menu_23: 'Service Design',
  menu_24: 'CX',
  nps_passives: 'Пассивдер',
  nps_detractors: 'Сынчылар',
  nps_promoters: 'Жарнамалоочулар',
  nps_a_score: 'баа',
  area: 'Аймак',
  products_tabs_1:
    'Максималдуу натыйжалуулукка жетүү үчүн биз комплекстүү түрдө дагы жүргүзөбүз:',
  products_tabs_2: 'Продукттар',
  products_tabs_3:
    'Сапаттык изилдөө — бул түшүнүктөрдү, пикирлерди же тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултуу жана талдоо',
  products_tabs_4:
    'Сандык изилдөө ыкмалары — бул сурамжылоолор, анкеталар жана изилдөөлөр аркылуу чогултулган маалыматтарды объективдүү өлчөө жана сандык талдоо',
  our_clients_1: 'Биздин кардарлар',
  preview_cases_section_1: 'Кейстер',
  preview_cases_section_2:
    'Кызыктуу материалдарды окуу үчүн кейстер бөлүмүнө өтүңүз',
  blog_1: 'Кызыктуу контент блогу',
  blog_2: 'Сиздин сурооңуз боюнча посттор табылган жок',
  about: 'Жөнүндө',
  why_us: 'Эмне үчүн биз?',
  about_us: 'Биз жөнүндө',
  key_features: 'Негизги өзгөчөлүктөр',
  solutions: 'Чечимдер',
  monitoring: 'Мониторинг',
  how: 'Кантип',
  how_it_works: 'Бул кандай иштейт',
  when_to_use: 'Качан колдонуу керек',
  mystery_shopping: 'Mystery shopping',
  voicer: 'Кардардын үнү',
  wantent: 'Видео контентти тестирлөө',
  play4sales: 'Play4Sales',
  price_monitoring: 'Бааларды мониторинг кылуу',
  service_design: 'Кызмат дизайны',
  qualitative_research: 'Сапаттык изилдөө',
  quantitative_research: 'Сандык изилдөө',
  cawi: 'CAWI',
  f2f: 'F2F',
  cati: 'CATI',
  hashtag_automotive: '#Автоунаа',
  hashtag_retayl: '#Чекене_соода',
  hashtag_all_posts: '#Бардык_посттор',
  hashtag_feedback: '#пикир',
  hashtag_4Service_csr: '#4Service_CSR',
  hashtag_cases: '#Кейстер',
  hashtag_market_research: '#рынок_изилдөө',
  more: 'Көбүрөөк',
  speak_to_an_expert: 'Эксперт менен сүйлөшүү',
  book_consultancy: 'Консультацияга жазылуу',
  read_all: 'Баарын окуу',
  find_out_more: 'Көбүрөөк билүү',
  address: 'Дарек',
  mon_fri: 'Дүй-Жум',
  phone_number: 'Телефон номери',
  flag: 'туу',
  scroll_to_left: 'солго жылдыруу',
  online: 'онлайн',
  tel: 'Тел',
  email: 'E-mail',
  light_it_up: 'Жандыр',
  about_us_60: 'Алина Андреева',
  about_us_61: 'Бизнести өнүктүрүү боюнча директор',
  about_us_62: 'Юлия Кравченко',
  about_us_63: 'Улук долбоор менеджери',
  about_us_64: 'Ольга Аксонова',
  about_us_65: 'Бизнести өнүктүрүү боюнча менеджер',
  about_us_66: 'Желевский Дмитрий',
  about_us_67: 'Операциялык директор',
  about_us_roles_1: 'Башкаруу',
  about_us_roles_2: 'Глобалдык команда',
  about_us_roles_3: 'Продукт ээлери',
  ad_testing_1: 'Жарнама тестирлөөсү',
  ad_testing_2:
    'Жарнамалык кампания — бул чоң инвестиция. Жарнамаларыңыз күчтүү болуп, максималдуу ROI алып келерине ынаныңыз',
  ad_testing_3: 'кулпу',
  ad_testing_4: 'Биз кызмат көрсөткөн тармактар',
  ad_testing_5: '4Service — кардар тажрыйбасын изилдөөчү глобалдык холдинг',
  ad_testing_6:
    '4Service — глобалдык маркетингдик изилдөө жана CX холдинги. Биз ар түрдүү бизнес үчүн эксперттик маалымат чогултуу кызматтарын сунуштайбыз',
  ad_testing_7: 'Cash & Carry',
  ad_testing_8: 'Чекене соода',
  ad_testing_9: 'Электроника',
  ad_testing_10: 'Люкс/Премиум',
  ad_testing_11: 'Тамактануу жана меймандостук',
  ad_testing_12: 'Автоунаа',
  ad_testing_13: 'Саякат жана эс алуу',
  ad_testing_14: 'Мода',
  ad_testing_15: 'Банктар',
  ad_testing_16: 'Сааттар жана зер буюмдар',
  ad_testing_17: 'Үй-тиричилик техникасы',
  ad_testing_18: 'Esomar мүчөсү',
  ad_testing_19:
    'Биз ар түрдүү тармактардагы бизнес үчүн жарнамаларды тестирлөө боюнча изилдөөлөрдү жүргүзгөнбүз',
  ad_testing_20: 'Сизге Ad Testing керек, эгерде сиз',
  ad_testing_21: 'Жаңы продукт же кызматты жайылтып жатсаңыз',
  ad_testing_22: 'Сезимтал теманы козгоп жатсаңыз',
  ad_testing_23:
    'Жаңы максаттуу аудиторияга же рынокко жетүүгө аракет кылып жатсаңыз',
  ad_testing_24: 'Бир нече дизайн варианттарын талкуулап жатсаңыз',
  ad_testing_25:
    'Башкаруу командасы же инвесторлор үчүн концепциянын далили керек болсо',
  ad_testing_26: 'Сиз төмөнкү суроолорго жооп аласыз',
  ad_testing_27: 'Бул жарнамалар үчүн кайсы жарнама каналдары эң ылайыктуу?',
  ad_testing_28:
    'Билдирүүнү жеткирүү үчүн туура визуалдарды колдонуп жатабызбы?',
  ad_testing_29:
    'Сиздин жарнамалык тексттер жана билдирүүлөр аудиторияга таасир этеби?',
  ad_testing_30: 'Бул жарнамалар үчүн кайсы жарнама каналдары эң ылайыктуу?',
  ad_testing_31: 'Алардын көңүлүн биринчи эмне бурат?',
  ad_testing_32: 'Жарнаманын жайгашуусу жана түзүлүшү түшүнүүгө жеңилби?',
  ad_testing_33: 'Биз баалайбыз',
  ad_testing_34: 'Брендинг',
  ad_testing_35:
    'сиздин бренд жарнама менен кандай байланышта экенин жана канчалык эсте каларын',
  ad_testing_36: 'Негизги көрсөткүчтөр',
  ad_testing_37: 'Интеграция',
  ad_testing_38: 'Таануу',
  ad_testing_39: 'Шайкештик',
  ad_testing_40: 'Креатив',
  ad_testing_41: 'Жарнамаңыз адамдардын көңүлүн кантип бурат жана айырмаланат',
  ad_testing_42: 'Негизги көрсөткүчтөр',
  ad_testing_43: 'ТААНУУ',
  ad_testing_44: 'ЖАКТЫРУУ',
  ad_testing_45: 'MTO',
  ad_testing_46: 'МОТИВАЦИЯ',
  ad_testing_47: 'Кардар тажрыйбасы, эмоционалдык тартылуу',
  ad_testing_48:
    'Жасалма интеллект технологиясы жана эксперт аналитиктердин жардамы менен биз адамдардын чыныгы эмоцияларын талдап, жарнама тууралуу кабылдоолору боюнча инсайттарды алабыз',
  ad_testing_49: 'Рейтинг',
  ad_testing_50: 'Эркек',
  ad_testing_51: 'Аял',
  ad_testing_52: 'Жогорку тартылуу',
  ad_testing_53: 'Көңүл буруу',
  ad_testing_54: 'Аудиторияга эмне жакты жана эмнеси эсте калды?',
  ad_testing_55: 'Актриса',
  ad_testing_56: 'Теңдик',
  ad_testing_57: 'Музыкалык фон',
  ad_testing_58: 'Позитивдүү эмоциялар',
  ad_testing_59: 'Ар кандай расадагы жана сырткы көрүнүштөгү адамдар',
  ad_testing_60: 'Сырттагы кадрлар',
  ad_testing_61: 'Аудиторияга эмне жаккан жок жана эмнеси эсте калган жок?',
  ad_testing_62:
    'Спикердин үнү экранда болуп жаткан окуяларга туура келген жок',
  ad_testing_63: 'Продуктка көңүл буруу төмөн',
  ad_testing_64: 'Өтө динамикалуу',
  ad_testing_65: 'Түшүнүүгө кыйын',
  ad_testing_66: 'TRP',
  ad_testing_67: 'Көрүүлөр',
  ad_testing_68: 'Көрсөтүүлөр',
  ad_testing_69: 'Конверсия',
  ad_testing_70: 'Медиа',
  ad_testing_71:
    'Биз жарнамалык кампаниянын натыйжалуулугун медиа активдүүлүк менен бирге өлчөйбүз, ар кандай каналдардагы медиа инвестициялардын натыйжаларга тийгизген таасирин эсептейбиз.',
  ad_testing_72:
    'Биз каалаган форматта, платформада же каналда жарнамалык изилдөө жүргүзөбүз',
  ad_testing_73: 'видеоконтент',
  ad_testing_74: 'тышкы жарнама',
  ad_testing_75: 'ТВ жарнамалар',
  ad_testing_76: 'басма',
  ad_testing_77: 'санарип',
  ad_testing_78: 'жарнамалык кампаниялар',
  ad_testing_79: 'POS дисплей жана жарнама',
  ad_testing_80: 'аниматиктер',
  ad_testing_81:
    'Биздин жардамыбыз менен сиз жарнамаңызды каалаган этапта тестирлей аласыз',
  ad_testing_82: 'Концепция',
  ad_testing_83: 'кайсы идеялардын потенциалы күчтүүрөөк?',
  ad_testing_84: 'Өндүрүштүн алгачкы этабы',
  ad_testing_85: 'кайсы аниматиктер өндүрүшкө өтөт?',
  ad_testing_86: 'Өндүрүш',
  ad_testing_87:
    'видеону көңүлдү сактап кала тургандай кантип монтаждоо керек?',
  ad_testing_88: 'Pre-media',
  ad_testing_89: 'кайсы байланыш каналдары иштейт жана кандай натыйжа күтүлөт?',
  ad_testing_90: 'Жарнаманы пост-тестирлөө',
  ad_testing_91: 'Өндүрүш',
  ad_testing_92:
    'менин жарнамам кызыктырабы? Креативдин натыйжалуулугу убакыт өтүшү менен төмөндөйбү?',
  ad_testing_93: 'Pre-media',
  ad_testing_94:
    'менин жарнамам сандар боюнча канчалык натыйжалуу? Ал атаандаштар менен салыштырганда кандай?',
  ad_testing_95: 'Жарнаманы алдын ала тестирлөө',
  ad_testing_96: 'Сизге жогорку сапаттагы маалымат берүү үчүн биз колдонобуз',
  ad_testing_97: 'Сандык изилдөө методологиясы',
  ad_testing_98: 'CAWI',
  ad_testing_99: 'Сапаттык изилдөө методологиясы',
  ad_testing_100: 'Фокус-топтор',
  ad_testing_101: 'AI',
  ad_testing_102: 'Wantent',
  ad_testing_103: 'Сиз ала турган аналитикалык отчеттор',
  ad_testing_104:
    'Биздин аналитиктер, медиа эксперттер жана маркетологдор командасы сиз үчүн деталдуу сунуштар менен жекелештирилген отчет даярдап, сунуштайт',
  ad_testing_age: 'жаш',
  ad_testing_ad: 'Жарнама',
  automotive_industry_price_analysis_1: 'Автоунаа тармагындагы бааларды талдоо',
  automotive_industry_price_analysis_2:
    'Атаандаштык бааларды талдоо жоголгон кирешенин алдын алууга, рынок үлүшүн көбөйтүүгө жана рыноктогу позицияңызды көзөмөлдөөгө жардам берет. Ийгиликтүү атаандаштык стратегиясын тандоодо сизге жардам берели!',
  automotive_industry_price_analysis_3: 'Баа сунушун сураңыз',
  automotive_industry_price_analysis_4: 'Биздин методология',
  automotive_industry_price_analysis_5:
    'Стилдүү жарашыктуу адамдар унаа салонунда',
  automotive_industry_price_analysis_6:
    'Mystery Shopping ыкмасы — бул чыныгы кардар тажрыйбасын так чагылдырган жана ишенимдүү сереп берген жалгыз ыкма.',
  automotive_industry_price_analysis_7:
    'Биз так көрсөткүчтөрдү жана ишенимдүү көп тараптуу маалыматтарды сунуштайбыз',
  automotive_industry_price_analysis_8:
    'Биз дүйнөнүн бардык өлкөлөрүн камтыган глобалдык камтууга ээбиз',
  automotive_industry_price_analysis_9:
    'Биздин ички ресурстарыбызга жашыруун сатып алуучулар жана аудиторлор кирет',
  automotive_industry_price_analysis_10:
    'Биз маалыматтарыбыздын сапатын текшеребиз',
  automotive_industry_price_analysis_11: 'Биздин артыкчылыктар:',
  automotive_industry_price_analysis_12:
    'Белгилүү атаандаш моделдер үчүн баа мониторинги (B2B жана B2C)',
  automotive_industry_price_analysis_13: 'Жеңилдик деңгээлин мониторинг кылуу',
  automotive_industry_price_analysis_14:
    'Сиздин бренд жана атаандаштар үчүн дилердик кампаларды мониторинг кылуу',
  automotive_industry_price_analysis_15:
    'Онлайн автоунаа бааларын мониторинг кылуу',
  automotive_industry_price_analysis_16: 'Баалык коммуникацияны талдоо',
  automotive_industry_price_analysis_17:
    'Дилерлердин жеткирүү чыгымдарын көзөмөлдөө',
  automotive_industry_price_analysis_18:
    'Дилерлердеги акцияларды жана сатууларды мониторинг кылуу',
  automotive_industry_price_analysis_19: 'Айлык төлөмдөрдүн көлөмүн аныктоо',
  automotive_industry_price_analysis_20: 'Лизинг төлөмдөрүн эсептөө',
  automotive_industry_price_analysis_21:
    'Электр унаалары (EV) үчүн атайын баа факторлорун талдоо',
  automotive_industry_price_analysis_22:
    'Түз кардарга сатуу менен дилердик бааларды салыштыруу',
  automotive_industry_price_analysis_23:
    'Жазылуу негизиндеги баа моделдерин иштеп чыгуу',
  automotive_industry_price_analysis_24:
    '4Service — 20 жылдан ашык тажрыйбасы бар глобалдык кардар тажрыйбасы (CX) холдинги',
  automotive_industry_price_analysis_25:
    'Сиз ар кандай функциялар үчүн кардарлардын төлөөгө даярдыгы тууралуу маалыматтарды колдонуп, сунушуңузду оптималдаштырып жана максаттуу кардарларыңыз үчүн эң маанилүү функцияларды аныктайсыз.',
  automotive_industry_price_analysis_26:
    '4Service компаниясынын автоунаа тармагындагы бааларды талдоосу төмөнкүлөрдү камтыйт:',
  automotive_industry_price_analysis_27:
    'Эң төмөн баалар ар дайым авто бренддер үчүн атаандаштыкка жөндөмдүүлүктүн негизги фактору боло бербейт. Узак мөөнөттүү баа стратегиясын түзүүгө жардам берели',
  automotive_industry_price_analysis_28:
    'кардарлар бардык бренддерде баалар өсүп жатканын түшүнүшөт',
  automotive_industry_price_analysis_29: '29',
  automotive_industry_price_analysis_30:
    'кардарлардын айтымында, бренд жакында боло турган баа жогорулашын билдирсе да, алар жактырган унааны сатып алышмак',
  automotive_industry_price_analysis_31: '31',
  automotive_industry_price_analysis_32:
    'адамдардын пикиринде, лизинг жана ай сайынкы төлөмдөр автоунаа сатып алуунун эң ыңгайлуу модели болуп саналат',
  automotive_industry_price_analysis_33: '48',
  automotive_industry_price_analysis_34:
    'дилерлер байланыш/сатуу процессинде баалардын өсүшү мүмкүн экенин айтышкан',
  automotive_industry_price_analysis_35: '47.6',
  automotive_industry_price_analysis_36: 'Негизги көрсөткүчтөр',
  automotive_industry_price_analysis_37:
    'Сиз өз продуктыңыздын баасын линейкадагы башка унааларга салыштырмалуу кантип коюуну түшүнөсүз.',
  automotive_industry_price_analysis_38:
    'Сиз ар кандай функциялар үчүн кардарлардын төлөөгө даярдыгы тууралуу маалыматтарды колдонуп, сунушуңузду оптималдаштырып жана максаттуу кардарларыңыз үчүн эң маанилүү функцияларды аныктайсыз.',
  automotive_industry_price_analysis_39:
    'кардарлардын айтымында, бренд жакында боло турган баа жогорулашын билдирсе да, алар жактырган унааны сатып алышмак',
  automotive_industry_price_analysis_40:
    'Сиз ылайыктуу ай сайынкы төлөмдөрдү жана лизинг ставкаларын аныктай аласыз.',
  automotive_industry_price_analysis_41:
    'Сиздин бренд же дилер үчүн кандай артыкчылыктар болот:',
  automotive_industry_price_analysis_42: 'Сиз арыз жөнөтөсүз',
  automotive_industry_price_analysis_43:
    'Биздин менеджер негизги максаттарды аныктоо үчүн сиз менен байланышат',
  automotive_industry_price_analysis_44: 'Биз маркетингдик изилдөө жүргүзөбүз',
  automotive_industry_price_analysis_45:
    'Биз сизге үзгүлтүксүз онлайн форматта отчетторду жана сунуштарды берип турабыз',
  automotive_industry_price_analysis_46: 'Сатуу стикери бар унаа',
  automotive_industry_price_analysis_47:
    'Биз долбоорду 1 күндө ишке киргизебиз!',
  automotive_industry_price_analysis_48:
    'Биз жергиликтүүлүктүн түрү боюнча бөлүнгөн фото отчетторду, PPT отчетторду жана Excel отчетторду камтыган комплекстүү отчеттор топтомун сунуштайбыз',
  retail_audit_1: 'FIELD MARKETING AUDIT/чекене аудит',
  retail_audit_2:
    'Дүкөнүңүз же брендиңиз тууралуу деталдуу маалыматтарды чогултуп, өсүү тоскоолдуктарын талдап жана аларды жеңүү үчүн натыйжалуу стратегияларды түзүңүз',
  retail_audit_3: 'Баа сунушун сураңыз',
  retail_audit_4:
    '4Service бренддердин атынан алардын жарнамалык стратегияларынын, талаа аткаруу командаларынын жана маркетингдик тактикаларынын максаттуу аудиторияга жетүүдөгү натыйжалуулугун баалоо үчүн жеринде дүкөн аудиттерин жүргүзөт.',
  retail_audit_5:
    'Биз жарнамалык кампаниялардын аткарылышын кылдат байкап, жарнамалык көрсөтмөлөрдүн сакталышын камсыздайбыз.',
  retail_audit_6: 'Топ 10',
  retail_audit_7: 'Европадагы CX агенттиктери',
  retail_audit_8: 'жылдык тажрыйба',
  retail_audit_9: 'өлкөлөрдү камтуу',
  retail_audit_10: '1,6 миллион',
  retail_audit_11: 'жылына баалоо',
  retail_audit_12: 'Биз эмнени көзөмөлдөйбүз?',
  retail_audit_13: 'Сатуу чекитиндеги (POS) материалдардын болушу',
  retail_audit_14:
    'Бренд элчилеринин катышуусу жана активдүүлүгү, пландаштырылган графикке ылайык келүүсүн камсыз кылуу',
  retail_audit_15:
    'Бренд элчилеринин жарнамалык кампанияларга катышуусун баалоо',
  retail_audit_16:
    'Керектөөчүлөр менен өз ара аракеттенүүнү баалоо, жарнамалык көрсөтмөлөргө жана бренд билдирүүлөрүнө шайкештигин камсыз кылуу',
  retail_audit_17: 'Алдамчылыктын алдын алуу чаралары',
  retail_audit_18:
    'Сиздин бизнес талаа маркетинг аудитинин жыйынтыктарын төмөнкүлөр үчүн колдоно алат:',
  retail_audit_19: 'Бюджетке жана процесстерге шайкештикти баалоо',
  retail_audit_20:
    'Чыныгы натыйжаларды пландаштырылган максаттар менен салыштыруу',
  retail_audit_21: 'Маркетинг кампанияларынын натыйжалуулугун жогорулатуу',
  retail_audit_22: 'Келечек үчүн стратегиялык пландоо',
  retail_audit_23: 'Чыгымдарды кыскартуу мүмкүнчүлүктөрүн аныктоо',
  retail_audit_24: 'Сатууларды жана конверсия деңгээлин жакшыртуу',
  retail_audit_25: 'Инвестициялардын кайтарымдуулугун (ROI) оптималдаштыруу',
  retail_audit_26:
    'АЛАР 4SERVICE’ТИ ӨЗДӨРҮНҮН TRADE INVESTMENT ӨНӨГҮ БОЮНЧА ӨНӨКТӨШҮ КАТАРЫ ТАНДАШТЫ',
  retail_audit_27:
    'Эл аралык алдыңкы тамеки өндүрүүчүсү өз бренддерин өнүктүрүү жана дүкөн ичиндеги көрсөткүчтөрүн жакшыртуу үчүн 4Service менен кызматташкан. Биздин командалар талаа маркетинг аудитин жана керектөөчү тажрыйбасы боюнча түз отчеттуулукту камсыз кылышкан.',
  retail_audit_28:
    'талаа маркетинг агенттигинин пландаштыруу тактыгын жогорулатуу',
  retail_audit_29: 'бренд билдирүүлөрүн жеткирүүнү жакшыртуу',
  retail_audit_30: 'BA катышуусун жогорулатуу (керектөөчүнү активдештирүү)',
  retail_audit_31:
    'маалыматтарды чогултуу тактыгын жана GDPR талаптарына шайкештикти жогорулатуу',
  retail_audit_32: 'Биз адатта кандай баалуу маалыматтарды табабыз:',
  retail_audit_33:
    'SLA шарттарынын шайкеш эместиги же карама-каршылыгы кардарга олуттуу макулдашылбаган чыгымдардын жүктөлүшүнө алып келет',
  retail_audit_34:
    'Көрсөтүлүп жаткан кызмат түрлөрүн аралаштыруудан улам төлөмдөрдүн туура эмес эсептелиши',
  retail_audit_35:
    'Талаа кызматы аткарылбай калышы, анын ичинде кызматкерлердин пландаштырылган жерге дайындалбашы | POS',
  retail_audit_36:
    'Чыныгы маалыматтардын ордуна болжолдуу эсептер боюнча төлөмдөрдүн алынуусу жана салыштырылбашы',
  retail_audit_37:
    'Жарнамалык көрсөтмөлөрдү туура эмес колдонуу жана жалган маалымат берүү',
  retail_audit_38: 'Биз кандай иштейбиз?',
  retail_audit_39:
    'Биздин аудитор агенттиктин активдештирүү планынын негизинде белгиленген сатуу чекиттерине (POS) барат.',
  retail_audit_40:
    'Алар POS материалдарынын болушу, бренд элчилеринин катышуусу, жарнамалык көрсөтмөлөргө шайкештик жана алдамчылыктын алдын алуу чаралары сыяктуу брифте көрсөтүлгөн негизги көрсөткүчтөрдү (KPI) баалашат.',
  retail_audit_41: 'Текшерүү:',
  retail_audit_42: 'Биз алынган маалыматтарды чогултуп жана бириктиребиз.',
  retail_audit_43: 'Толук отчет даярдалат.',
  retail_audit_44:
    'Биздин текшерүү командасы бардык сурамжылоолорду тактыкка, анын ичинде долбоордун брифине жана кошумча комментарийлерге шайкештигин кылдат текшерет.',
  retail_audit_45: 'Онлайн отчет берүү системасы:',
  retail_audit_46:
    'Толтурулган жана текшерилген анкеталар 36 сааттын ичинде биздин онлайн порталга жүктөлөт.',
  retail_audit_47:
    'Кардарлар каалаган убакта прогрессти көзөмөлдөөгө мүмкүнчүлүк берген жеке аккаунт порталына кире алышат.',
  retail_audit_48: 'Жыйынтыктар жана сунуштар камтылган акыркы отчет берилет.',
  retail_audit_49: 'Эксперт менен сүйлөшүңүз',
  retail_audit_50: 'Биздин күчтүү жактарыбыз:',
  facility_check_audit_1: 'Facility',
  facility_check_audit_2: 'Check Audit',
  facility_check_audit_3:
    'Ар бир детал аркылуу бренд тажрыйбасын жогорулатыңыз',
  facility_check_audit_4: 'Биздин ыкманы изилдеңиз',
  facility_check_audit_5: 'Жөнүндө',
  facility_check_audit_6: 'Биз кимбиз',
  facility_check_audit_7:
    'Кардар тажрыйбасы боюнча глобалдык холдинг катары, 4Service бренддерге кардарлары үчүн өзгөчө тажрыйбаларды түзүүгө жана жеткирүүгө жардам берген кызматтардын толук топтомун сунуштайт.',
  facility_check_audit_8: 'Биздин Facility Check Audit кызматы',
  facility_check_audit_9:
    'сиздин физикалык жайларыңыз жана чекене дүкөндөрдөгү бренд катышуусуңуз бренд стандарттарына жооп берип, кардарларда оң таасир жаратып жатканын камсыз кылууга жардам берүү үчүн иштелип чыккан.',
  facility_check_audit_10: 'Чечимдер 1',
  facility_check_audit_11: 'Facility Check Audit',
  facility_check_audit_12:
    'бул сиздин чекене соода түйүндөрүңүздүн же стенддериңиздин бренд стандарттарына шайкештигин баалаган кылдат текшерүү. Биз физикалык мүнөздөмөлөрдү гана текшербестен, бул элементтер кардарлардын брендиңизди кабыл алышына кандай таасир этерин да баалайбыз.',
  facility_check_audit_13: 'Эки чечим',
  facility_check_audit_14: 'Ишке ашыруунун эки ыкмасы',
  facility_check_audit_15: 'Метод',
  facility_check_audit_16: 'Эксперт-аудиторлор тарабынан Facility Check Audit',
  facility_check_audit_17: 'Facility Check текшерүүсү',
  facility_check_audit_18: 'Отчеттор',
  facility_check_audit_19:
    'Сиз 48 сааттын ичинде визуалдык далилдер жана статистика менен толукталган отчетторду аласыз',
  facility_check_audit_20:
    'Туура жүргүзүлгөн Facility Check Audit брендиңиз үчүн бир катар артыкчылыктарды бере алат, анын ичинде:',
  facility_check_audit_21: 'Кардар конверсиясын жакшыртуу:',
  facility_check_audit_22:
    'Оң кардар тажрыйбасы сатуулардын көбөйүшүнө жана кайталап сатып алууларга алып келиши мүмкүн. Биздин аудиттер кардарлардын канааттануусуна терс таасир эткен аймактарды аныктоого жана оңдоого жардам берет.',
  facility_check_audit_23: 'Бренд имиджин жакшыртуу:',
  facility_check_audit_24:
    'Сиздин физикалык жайларыңыз кардарлар үчүн негизги байланыш чекити болуп саналат жана бренд имиджин калыптандырууда чоң роль ойнойт. Биздин аудиттер жайларыңыз бренд баалуулуктарына шайкеш келип, кардарларда оң таасир жаратып жатканын камсыз кылууга жардам берет.',
  facility_check_audit_25: 'Эмне үчүн биз?',
  facility_check_audit_26: 'Facility Check Audit эмне үчүн маанилүү?',
  facility_check_audit_27:
    'Туура жүргүзүлгөн Facility Check Audit брендиңиз үчүн бир катар артыкчылыктарды бере алат, анын ичинде:',
  facility_check_audit_28: 'Бренд имиджин жакшыртуу:',
  facility_check_audit_29:
    'Сиздин физикалык жайларыңыз кардарлар үчүн негизги байланыш чекити болуп саналат жана бренд имиджин калыптандырууда чоң роль ойнойт. Биздин аудиттер жайларыңыз бренд баалуулуктарына шайкеш келип, кардарларда оң таасир жаратып жатканын камсыз кылууга жардам берет.',
  facility_check_audit_30: 'Кардар конверсиясын жакшыртуу:',
  facility_check_audit_31:
    'Оң кардар тажрыйбасы сатуулардын көбөйүшүнө жана кайталап сатып алууларга алып келиши мүмкүн. Биздин аудиттер кардарлардын канааттануусуна терс таасир эткен аймактарды аныктоого жана оңдоого жардам берет.',
  facility_check_audit_32: 'Кимге керек',
  facility_check_audit_33: 'Facility Check Audit кимге керек?',
  facility_check_audit_34:
    'Facility Check Audit физикалык жайлары жана физикалык катышуусу бар ар бир бренд үчүн баалуу кызмат. Бул өзгөчө төмөнкүлөрдү каалаган бренддер үчүн маанилүү:',
  facility_check_audit_35: 'Бренд стандарттарына шайкештикти камсыз кылуу:',
  facility_check_audit_36:
    'Биздин аудиттер жайларыңыз бренд стандарттарынан кайсы жерлерде четтеп жатканын аныктоого жардам берет.',
  facility_check_audit_37: 'Кардар тажрыйбасын жакшыртуу:',
  facility_check_audit_38:
    'Биздин аудиттер жайларыңыздагы кардар тажрыйбасын жакшыртуу мүмкүнчүлүктөрүн аныктоого жардам берет.',
  facility_check_audit_39: 'Күчтүү бренд түзүү:',
  facility_check_audit_40:
    'Биздин аудиттер физикалык жайларыңыз кардарларда оң таасир жаратып жатканын камсыз кылууга жардам берет.',
  facility_check_audit_41:
    'Сиздин кызматкер же жашыруун сатып алуучу жайдын сүрөтүн тартат.',
  facility_check_audit_42:
    'Андан кийин алар анкета толтуруп, сүрөттү тиркешет.',
  facility_check_audit_43:
    'Текшерүүчү сүрөттү алып, аны стандарттарга шайкештигин текшерет.',
  facility_check_audit_44: 'Эксперт-аудиторлор тарабынан Facility Check Audit',
  facility_check_audit_45: 'Даярдык этабы:',
  facility_check_audit_46: 'Аудит графигин биргелешип бекитүү',
  facility_check_audit_47:
    'Дилерлер алдыдагы аудит тууралуу алдын ала даярдалып жана маалымдалат',
  facility_check_audit_48: 'Аудиторлорду окутуу:',
  facility_check_audit_49:
    'Биздин тажрыйбалуу 4Service тренерлери аудиторлорду бренд көрсөтмөлөрү менен камсыз кылышат',
  facility_check_audit_50: 'Facility Audit этабы:',
  facility_check_audit_51:
    'Атайын уруксат каттары менен жабдылган аудиторлор жайларга барышат',
  facility_check_audit_52:
    'Ар бир чекитти көрсөтмөлөрдү так сактоо менен кылдат текшерүү',
  facility_check_audit_53:
    'Визуалдык документтештирүү жана HQ талаптарына ылайык баалоо',
  facility_check_audit_54: 'Жыйынтыктоочу PPT отчет',
  facility_check_audit_55:
    'Жыйынтыктарды кеңири түшүндүргөн толук PowerPoint отчету',
  facility_check_audit_56:
    'Текшерилген жыйынтыктардын онлайн/офлайн презентациясы',
  facility_check_audit_57: 'Facility Check текшерүүсү',
  facility_check_audit_58: 'Кадамдар:',
  facility_check_audit_59: 'Facility Audit Stage:',
  facility_check_audit_60:
    'Бренд өкүлдөрү 4Service тиркемесин колдонуп, жеринде сүрөттөрдү тартып алышат',
  facility_check_audit_61:
    'Катуу визуалдык жана сүрөттөмө критерийлерине шайкештик',
  facility_check_audit_62: 'Текшерүү этабы:',
  facility_check_audit_63:
    'Кылдат валидаторлор ар бир отчетту дыкат текшеришет',
  facility_check_audit_64:
    'Сүрөттөрдү бренд стандарттары менен ар тараптуу салыштыруу',
  facility_check_audit_65:
    'Тактык үчүн отчетко белгилер жана түшүндүрмөлөр кошулат',
  facility_check_audit_66:
    'Зарыл болсо, тактоо үчүн дилерлер менен түз байланыш',
  facility_check_audit_67: 'Отчет берүү этабы:',
  facility_check_audit_68:
    'Визуалдык далилдер жана статистика менен толукталган отчеттор эки күндүн ичинде жеткиликтүү болот',
  facility_check_audit_69: 'Бүгүн биз менен байланышыңыз',
  cx_solution_1: 'Биз жөн гана инсайттарды таппайбыз,',
  cx_solution_2: 'Биз сиздин бизнесиңизди жаңы бийиктиктерге чыгарабыз',
  cx_solution_3:
    '20 жылдан ашык кардар тажрыйбасына ээ эксперттер татаал чечимдерди таап, өсүшүңүзгө жардам бере турган так аракеттер планын сунушташат',
  cx_solution_4:
    'Келечекке ылайыкташкан бирдиктүү чечимдеги уникалдуу кызматтар топтомун ачыңыз',
  cx_solution_5: 'Баары бир жерде болгон CX чечими',
  cx_solution_6: 'Жарнаманы тестирлөө',
  cx_solution_7: 'AI жана нейромаркетинг',
  cx_solution_8: 'Кардардын үнү',
  cx_solution_9: 'Desk research',
  cx_solution_10: 'CJM',
  cx_solution_11: 'Mystery shopping',
  cx_solution_12: 'CX консалтинги',
  cx_solution_13: 'Социалдык медианы угуу',
  cx_solution_14: 'Сапаттык жана сандык изилдөөлөр',
  cx_solution_15: 'Кызмат дизайны',
  cx_solution_16: 'Маркетинг стратегиясы',
  cx_solution_17: 'UX/UI тестирлөө',
  cx_solution_18: 'Аудитория инсайттары',
  cx_solution_19: 'Сиздин ийгилигиңизге салым кошуу биз үчүн сыймык',
  cx_solution_20:
    'Биз бизнесиңиздин максаттарына жараша куралдарды жана кызматтарды ыңгайлаштырып айкалыштырабыз, натыйжада сизге ылайыкташтырылган жыйынтыктарды сунуштайбыз',
  cx_solution_21: 'Комплекстүү изилдөө',
  cx_solution_22:
    'Маалыматка негизделген рынокто атаандаштык артыкчылыгын берип, чечим кабыл алууну күчөтөт.',
  cx_solution_23:
    'Сапаттык изилдөө — түшүнүктөрдү, пикирлерди жана тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултуу жана талдоо',
  cx_solution_24:
    'Сандык изилдөө ыкмалары — сурамжылоолор, анкеталар жана изилдөөлөр аркылуу алынган маалыматтарды объективдүү өлчөө жана сандык талдоо',
  cx_solution_25:
    'Биз сиздин конкреттүү муктаждыктарыңызга жараша өзгөчө куралдар топтомун колдонобуз',
  cx_solution_26: 'Куралдар',
  cx_solution_27: 'CAWI',
  cx_solution_28:
    'Computer-Assisted Web Interviewing биздин негизги куралдарыбыздын бири болуп саналат, ал онлайн платформалар аркылуу атайын программалык камсыздоонун жардамы менен сурамжылоолорду жүргүзүүгө жана маалыматтарды чогултууга мүмкүндүк берет, кардарларыбыздын рыноктук изилдөө муктаждыктары үчүн натыйжалуу жана так маалымат чогултууну камсыздайт',
  cx_solution_29: 'CATI',
  cx_solution_30:
    'Computer-Assisted Telephone Interviewing — бул телефон аркылуу сурамжылоолорду өткөрүү жана баалуу маалыматтарды чогултуу үчүн колдонулган ыкма, анда атайын программалык камсыздоо процессин жөнөкөйлөтүп, рыноктук изилдөөлөрдүн тактыгын камсыз кылат',
  cx_solution_31: 'F2F',
  cx_solution_32:
    'Face-to-Face биздин ыкмабыздын маанилүү бөлүгү болуп саналат, ал кардарлар жана керектөөчүлөр менен түз байланыштарды жана жекелештирилген өз ара аракеттенүүнү камсыздап, ишенимди, түшүнүүнү жана натыйжалуу коммуникацияны өнүктүрөт',
  cx_solution_33: 'Desk research',
  cx_solution_34:
    'Desk research маалыматтарды кеңири чогултууну жана талдоону камтыйт жана кардарларыбыз үчүн стратегиялык чечимдерди кабыл алууда негизги этап болуп саналат',
  cx_solution_35: 'SWOT-талдоо',
  cx_solution_36:
    'SWOT талдоо — бул биздин кардарларга ички күчтүү жана алсыз жактарды, ошондой эле тышкы мүмкүнчүлүктөрдү жана коркунучтарды аныктоого жардам берген стратегиялык баалоо куралы',
  cx_solution_37: 'Этнографиялык изилдөө',
  cx_solution_38:
    'Адамдарды жана маданияттарды алардын табигый чөйрөсүндө байкоо жана аралашуу аркылуу изилдөө, бул жүрүм-турум, ишенимдер жана социалдык динамика боюнча терең түшүнүктөрдү берет',
  cx_solution_39: 'Тереңдетилген интервьюлар',
  cx_solution_40:
    'Тереңдетилген интервьюлар — бул биз колдонгон сапаттык изилдөө ыкмасы, анда катышуучулар менен жекече жана кеңири маектер жүргүзүлөт',
  cx_solution_41: 'Идея жаратуу сессиялары',
  cx_solution_42:
    'Идея жаратуу сессиялары — бул биз уюштурган биргелешкен brainstorming сессиялары, анда ар түрдүү көз караштар жана тажрыйбалар бириктирилип, чыгармачыл идеялар жана чечимдер иштелип чыгат',
  cx_solution_43: 'Buyer personas',
  cx_solution_44:
    'Buyer personas — бул биздин кардарлардын максаттуу аудиториясынын деталдуу профилдери, аларды изилдөө жана маалыматтарды талдоо негизинде түзөбүз',
  cx_solution_45: 'Mystery Shopping',
  cx_solution_46:
    'Mystery Shopping — бул алдын ала аныкталган сценарий боюнча кардар менен компаниянын өз ара аракеттенүүсүн өлчөө жана көзөмөлдөөчү стратегиялык кызмат',
  cx_solution_47: 'Accompany checking',
  cx_solution_48:
    'Accompany checking — бул mystery shopping’дин атайын түрү, анда биздин баалоочулар кардарды кызмат көрсөтүү процессинин бүтүндөй жүрүшүндө коштоп жүрүшөт',
  cx_solution_49: 'Пикирлерди чогултуу жана талдоо',
  cx_solution_50:
    'Пикирлерди чогултуу жана талдоо — бул сурамжылоолордон, сын-пикирлерден жана социалдык медиадан алынган кардар пикирлерин системалуу түрдө чогултуу жана талдоо процесси',
  cx_solution_51: 'Фокус-топтор',
  cx_solution_52:
    'Фокус-топтор — бул белгилүү бир темаларды же өнүмдөрдү терең талкуулоо үчүн ар түрдүү катышуучуларды чогулткан динамикалык изилдөө сессиялары',
  cx_solution_53: '20 жыл бою өзгөчө кардар тажрыйбасын жаратуу',
  cx_solution_54:
    'Сиздин билдирүү аудиторияңызды кызыктырып жана таасир калтырганына ишениңиз.',
  cx_solution_55: 'Биз күткөндөн да ашкан натыйжаларды берүүгө умтулабыз',
  cx_solution_56: 'Биз өсүшүңүзгө салым кошо турган татаал чечимдерди табабыз',
  cx_solution_57: 'Биздин методология менен кардар тажрыйбаңызды жакшыртыңыз',
  cx_solution_58:
    'Customer Journey Mapping — максаттуу аудиторияны аныктоо, алардын муктаждыктарын түшүнүү жана кызыктуу тажрыйба жаратуу үчүн план түзүү процесси',
  cx_solution_59: 'BHT',
  cx_solution_60:
    'Brand Health Tracking изилдөөсү бренддин маалымдуулугу, колдонулушу, позицияланышы жана натыйжалуулугу боюнча көрсөткүчтөрдү өлчөөгө жардам берет',
  cx_solution_61: 'CSI',
  cx_solution_62:
    'Customer Satisfaction Index — бул кардарлардын компаниянын өнүмдөрүнө жана кызматтарына канчалык канааттанганын көрсөткөн индекс.',
  cx_solution_63:
    'Бааларды мониторингдөө — атаандаштардын бааларын чогултуу, иштетүү жана талдоо процесси',
  cx_solution_64: 'NPS',
  cx_solution_65:
    'Net Promoter Score — кардар тажрыйбасын баалоонун алтын стандарты, бир суроого негизделген: Уюмду/Өнүмдү/Кызматты сунуштоо ыктымалдыгы кандай?',
  cx_solution_66: 'HR изилдөө',
  cx_solution_67:
    'Human Resource Research HR практикасын жана натыйжалуулугун баалоо үчүн колдонулат жана учурдагы өнүгүү менен башкаруу боюнча кеңири талдоо берет',
  cx_solution_68:
    'Usability testing — бул чыныгы адамдардын вебсайт, тиркеме же башка өнүм менен кантип өз ара аракеттенерин жана алардын жүрүм-туруму менен реакцияларын байкоо',
  cx_solution_69: 'Башка',
  cx_solution_70:
    'Эксперттер сиздин бизнес үчүн эң мыкты методологияны тандашат',
  cx_solution_71: 'Баштайлы',
  cx_solution_72: '1 - KICK OFF ЖОЛУГУШУУСУ',
  cx_solution_73:
    'Kickoff жолугушуусунда биз негизги тапшырмаларды аныктап, аларга көңүл бурабыз. Натыйжа: максаттарды, изилдөө тапшырмаларын, мөөнөттөрдү, ыкмаларды жана жоопкерчилик аймактарын түшүнүү.',
  cx_solution_74: '2 - КОНЦЕПЦИЯНЫ ИШТЕП ЧЫГУУ',
  cx_solution_75:
    '4Service аналитика бөлүмү маалыматтарды топтоп, отчеттун түзүмүн координациялайт. Андан кийин биз натыйжаларды инсайттар жана сунуштар менен бирге кардарга сунуштайбыз.',
  cx_solution_76: '3 - ТАЛАА ИШТЕРИ',
  cx_solution_77:
    'Изилдөө жүргүзүү үчүн биз катышуучуларды тандап, интервьюларды жана башка негизги этаптарды өткөрөбүз. Кардар аудио-видео интервьюлардын транскрипцияларын жана кыскача жыйынтыктарды алат.',
  cx_solution_78: '4 - АНАЛИТИКА',
  cx_solution_79:
    '4Service аналитика бөлүмү маалыматтарды топтоп, отчеттун түзүмүн координациялайт. Андан кийин биз натыйжаларды инсайттар жана ишке ашыруу боюнча сунуштар менен бирге сунуштайбыз.',
  cx_solution_80: '5 - WORKSHOP',
  cx_solution_81: 'Кардар менен ишке ашыруу планы боюнча талкуу өткөрүү',
  cx_solution_82: 'Биздин мыкты практикалар жөнүндө көбүрөөк билиңиз',
  cx_solution_83:
    'Customer Journey Map бардык байланыш каналдарын тез карап чыгууга, маанилүү чекиттердеги кемчиликтерди аныктоого жана пландан четтөөлөрдү түшүнүүгө жардам берет.',
  cx_solution_84: 'Качан колдонуу керек?',
  cx_solution_85:
    'Аудитория топтору боюнча реалдуу маалыматтарга негизделген жекелештирилген жарнамалык кампания түзүңүз',
  cx_solution_86:
    'Ар кандай максаттуу аудитория сегменттеринин триггерлерин аныктап, алардын муктаждыктарын канааттандырыңыз',
  cx_solution_87: 'Ар бир топко так багытталып, максималдуу конверсия алыңыз',
  cx_solution_88:
    'Accompany Checking ыкмасы максаттарга жетүүнүн оптималдуу жолдорун баалоого мүмкүндүк берет.',
  cx_solution_89: 'Жаңы вебсайтты же өнүмдү ишке киргизүүдөн мурун тестирлөө',
  cx_solution_90:
    'Өзгөртүүлөрдү киргизүүдөн мурун иштелип чыккан процесстерди текшерүү',
  cx_solution_91: 'Сатуулар төмөндөп жаткан учурда вебсайтты же өнүмдү баалоо',
  cx_solution_92: 'Кардарлардын каалоолоруна ылайык жаңы өнүмдү ишке киргизүү',
  cx_solution_93:
    'Рынокто лидерлик позицияны камсыз кылуу үчүн атаандаш компанияларды изилдөө',
  cx_solution_94:
    'Биз кардарга багытталган кызмат моделин түзүү үчүн комплекстүү 360° ыкмасын сунуштайбыз.',
  cx_solution_95: 'Кызматкерлерди окутуу жана өнүктүрүү',
  cx_solution_96: 'Кызмат көрсөтүү стандарттарын жакшыртуу',
  cx_solution_97: 'Кардарлардын агымын жана сатууларды көбөйтүү',
  cx_solution_98: 'Кызматкерлер үчүн KPI жана мотивация системасын түзүү',
  cx_solution_99: 'Биздин ийгилик окуяларыбыз менен таанышыңыз',
  cx_solution_100: 'Автомобиль тармагы',
  cx_solution_101: 'Тамеки индустриясы',
  cx_solution_102: 'Retail',
  cx_solution_103: 'Сапаттык этап',
  cx_solution_104: 'Сандык этап (сегментация)',
  cx_solution_105: 'Фокус-топтор',
  cx_solution_106: 'Онлайн дүйнөлүк аудиторияны камтуу',
  cx_solution_107: 'Интервью учурунда ар кандай ыкмаларды айкалыштыруу',
  cx_solution_108: 'Ачык суроолор гана',
  cx_solution_109: 'Респонденттерди 24/7 колдоо',
  cx_solution_110: 'Маанилүү деталдарды жана жолдун чыныгы көрүнүшүн сактоо',
  cx_solution_111: 'Рыноктук изилдөө',
  cx_solution_112: 'Компанияны жана атаандаштарды диагностикалоо',
  cx_solution_113: 'Жаңыланган кызмат моделдери жана жаңы бизнес процесстер',
  cx_solution_114: 'Кардарга багытталган кызматты өнүктүрүү',
  cx_solution_115:
    'Өзгөртүүлөрдү ишке ашыруу жана кызмат стратегияларынын өнүгүшүн көзөмөлдөө',
  usage_attitude_1: 'Колдонуу жана\n мамиле (U&A)',
  usage_attitude_2:
    'Максаттуу аудитория сиздин брендиңизди кандай кабыл алып, колдонуп жана өз ара аракеттенерин толук түшүнүңүз.',
  usage_attitude_3: 'Эксперт менен сүйлөшүңүз',
  usage_attitude_4: 'Жөнүндө',
  usage_attitude_5:
    '<b>Керектөөчүлөрдүн</b> адаттарын изилдеп, алардын каалоолорун жана таасир этүүчү факторлорун терең түшүнүңүз',
  usage_attitude_6:
    "<b>Керектөөчүлөрдүн тандоосунун 'эмне үчүн'</b> экенин биздин деталдуу талдообуз аркылуу билиңиз",
  usage_attitude_7:
    '<b>Кардарлардын</b> өнүмдөрүңүз менен кандай өз ара аракеттенерин түшүнүп, стратегиялык инсайттарды алыңыз',
  usage_attitude_8:
    '<b>Керектөөчүлөрдүн</b> жүрүм-туруму, адаттары жана каалоолору жөнүндө маалымат алып, негизделген чечимдерди кабыл алыңыз',
  usage_attitude_9: 'Тажрыйба',
  usage_attitude_10:
    '20 жылдан ашык кардар тажрыйбасына ээ 4Service эксперттери бизнесиңизди өнүктүрүүгө жардам берген уникалдуу чечимдерди жаратышат',
  usage_attitude_11: 'Биз менен байланышыңыз',
  usage_attitude_12: 'Ким үчүн',
  usage_attitude_13: 'Brand Usage and Attitude кимге пайдалуу?',
  usage_attitude_14:
    'Ар кандай тармактар жана кызмат көрсөтүү секторлору төмөнкүлөргө кызыкдар:',
  usage_attitude_15:
    '<b>Кардарлардын</b> муктаждыктарын жана ооруткан чекиттерин аныктоо',
  usage_attitude_16: '<b>Керектөөнү</b> көбөйтүү мүмкүнчүлүктөрүн аныктоо',
  usage_attitude_17:
    '<b>Жаңы</b> өнүм категорияларын же маркетинг стратегияларын иштеп чыгуу',
  usage_attitude_18: '<b>Атаандаштык</b> чөйрөсүн терең түшүнүү',
  usage_attitude_19:
    'Методология кардардын суроо-талабына жараша өзүнчө тандалат',
  usage_attitude_20:
    '<b>Сапаттык изилдөө</b> түшүнүктөрдү, пикирлерди жана тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултууну жана талдоону камтыйт.',
  usage_attitude_21:
    '<b>Сандык изилдөө</b> ыкмалары сурамжылоолордон жана анкеталардан алынган маалыматтарды объективдүү өлчөөнү жана сандык талдоону камтыйт.',
  usage_attitude_22:
    '<b>Маалыматтарды чогулткандан кийин</b>, эксперттер маалыматты талдап, сизге эң мыкты сунуштарды берүү үчүн жыйынтык чыгарышат.',
  usage_attitude_23: 'Кимге керек',
  usage_attitude_24: 'Сиздин ийгилик окуяңыз ушул жерден башталат',
  usage_attitude_25:
    '<b>Сиз стратегиялык чечимдерди кабыл алууга жардам берген</b> баалуу инсайттар менен изилдөө аласыз.',
  usage_attitude_26:
    '<b>Изилдөө бренд стратегияларын тактоого</b> жана аларды керектөөчүлөрдүн каалоолору менен жакшыраак шайкеш келтирүүгө бекем негиз түзөт.',
  usage_attitude_27: 'Чечимдер',
  usage_attitude_28: 'Биздин чечимдер менен көптөгөн мүмкүнчүлүктөрдү ачыңыз',
  usage_attitude_29: 'Категория ичиндеги өнүм артыкчылыгы',
  usage_attitude_30:
    'Тамак-аш, суусундук, кийим-кече, электроника жана башка категорияларда керектөөчүлөрдүн эң жогорку артыкчылыктарын аныктаңыз.',
  usage_attitude_31: 'Керектөө / колдонуу жүрүм-туруму',
  usage_attitude_32:
    'Белгилүү өнүмдөрдү/кызматтарды колдонуу жыштыгын талдап, алар колдонулган учурларды аныктаңыз.',
  usage_attitude_33: 'Сатып алуу жүрүм-туруму',
  usage_attitude_34:
    'Кардарлар сатып алуу үчүн кайсы каналдарды колдонорун жана маалыматты кайдан аларын изилдеңиз.',
  usage_attitude_35: 'Керектөөчүлөрдүн мотивациясы жана муктаждыктары',
  usage_attitude_36:
    'Керектөөгө таасир этүүчү мотивацияларды жана тоскоолдуктарды изилдеңиз. Баага болгон кабылдоону талдаңыз.',
  usage_attitude_37: 'Биздин ыкма',
  usage_attitude_38: 'Брендди колдонуу жана мамиле изилдөөсү',
  usage_attitude_39: 'Маалымат',
  usage_attitude_40:
    'Сандык жана сапаттык ыкмалар менен сурамжылоолорду жүргүзүү',
  usage_attitude_41: 'Баштоо',
  usage_attitude_42:
    'Максаттарды коюу жана жеке суроо-талаптардын негизинде ыкмаларды аныктоо',
  usage_attitude_43: 'Талдоо',
  usage_attitude_44: 'Биздин эксперттер колдонгон татаал ыкмалар',
  usage_attitude_45:
    'Биз сиздин конкреттүү талаптарыңызга жараша өзгөчө куралдар топтомун колдонобуз',
  usage_attitude_46: 'СATI',
  usage_attitude_47:
    'Computer-Assisted Telephone Interviewing — бул телефон аркылуу сурамжылоолорду жүргүзүү жана баалуу маалыматтарды чогултуу үчүн колдонулган ыкма.',
  usage_attitude_48: 'CAWI',
  usage_attitude_49:
    'Computer-Assisted Web Interviewing биздин негизги куралдарыбыздын бири болуп саналат жана онлайн платформалар аркылуу маалыматтарды натыйжалуу чогултууга мүмкүндүк берет.',
  usage_attitude_50: 'CAPI',
  usage_attitude_51:
    'Computer-Assisted Personal Interviewing — бул маалымат чогултуу процесстерин оптималдаштыруу жана так натыйжаларды камсыз кылуу үчүн колдонулган ыкма.',
  usage_attitude_52: 'Фокус-топтор',
  usage_attitude_53:
    'Фокус-топтор — белгилүү бир темаларды же өнүмдөрдү терең талкуулоо үчүн ар түрдүү катышуучуларды бириктирген динамикалык изилдөө сессиялары.',
  usage_attitude_54: 'F2F',
  usage_attitude_55:
    'Face-to-Face биздин ыкмабыздын маанилүү бөлүгү болуп саналат жана түз байланыштар аркылуу ишенимди жана эффективдүү коммуникацияны өнүктүрөт.',
  usage_attitude_56: 'Этнографиялык изилдөө',
  usage_attitude_57:
    'Адамдарды жана маданияттарды алардын табигый чөйрөсүндө байкоо аркылуу изилдөө, бул жүрүм-турум жана социалдык динамика боюнча терең түшүнүк берет.',
  thank_you_page:
    'Убактыңыз үчүн рахмат! Биздин менеджер жакында сиз менен байланышат.',
  back_main: 'Башкы бетке кайтуу',
  opportunities_1: 'Биздин кейстер жөнүндө көбүрөөк билиңиз',
  opportunities_2: 'Ачыңыз',
  opportunities_3: 'өзүңүз үчүн',
  opportunities_4: 'мүмкүнчүлүктөр',
  opportunities_5:
    '4Service изилдөө холдинги менен бирге эл аралык бизнес мүмкүнчүлүктөрүн',
  opportunities_6:
    'Кайсы <span>өнүмдөр</span> менен бизнесиңизди күчтөндүрө алабыз?',
  opportunities_7: 'CX',
  opportunities_8: 'Бизнес үчүн комплекстүү ылайыкташтырылган чечимдер',
  opportunities_9: 'Mystery Shopping бардык түрлөрү',
  opportunities_10:
    'Биз mystery employee, mystery caller, luxury mystery shopper, automotive mystery shopper жана башка түрлөрүн ишке ашырабыз',
  opportunities_11: 'Бизнес үчүн ылайыкташтырылган IT чечимдер',
  opportunities_12:
    'AI менен өз IT чечимдерибиз, пикирлер аналитикасы жана чалууларды транскрипциялоо платформалары',
  opportunities_13: 'Рыноктук изилдөө',
  opportunities_14:
    'Ар кандай бизнес суроо-талаптары үчүн (Brand Health Tracking, Segmentation, NPS, eNPS, CJM, өнүм жана жарнама тестирлөөсү ж.б.)',
  opportunities_15: 'Аудиттер',
  opportunities_16:
    'Биз ар кандай сервис аудиттерин, ошондой эле баа мониторингин жүргүзөбүз (офлайн, белгилүү нишалар үчүн ж.б.)',
  opportunities_17: 'Кызмат дизайны',
  opportunities_18:
    '4Service - DesignThinkers Academyнин сертификатталган өнөктөштөрү, командалар үчүн корпоративдик окутууларды өткөрүп, бизнес үчүн үзгүлтүксүз воркшопторду уюштурат',
  opportunities_19:
    'Биз тажрыйбабыз менен бөлүшөбүз, бирок сиздин бизнес процессиңизди <span>урматтайбыз жана бузбайбыз</span>.',
  opportunities_20:
    'Бизнестин өнүгүү жолунда кандай кыйынчылыктарга туш болорун билебиз жана эл аралык ийгиликтүү тажрыйбанын негизинде бул тоскоолдуктарды кантип жеңүүнү да билебиз. Сиз тажрыйбаны гана эмес, ресурстарды да аласыз.',
  opportunities_21: 'Сизди кызматташууга чакырабыз!',
  opportunities_22:
    'Биз сиздин бизнес үчүн <span>өнөктөштүк программасын</span> сунуштайбыз',
  opportunities_23:
    '4Service эл аралык таанылган брендинин алдында сиз жаңы кардарларды тартууга оң таасир бере аласыз.',
  opportunities_24:
    'Биздин өнөктөштөр окутуу, маркетинг материалдары жана операциялык колдоо сыяктуу ар тараптуу жардам алышат.',
  opportunities_25:
    'Биз менен өнөктөштүк учурдагы бизнес процессиңизди бузбастан пландарыңызды ишке ашырууга жардам берет.',
  opportunities_26: 'Биздин <span>офистер</span>',
  opportunities_27: 'Биздин кардарлар',
  opportunities_28: 'Бизде CX тармагында 20 жылдан ашуун тажрыйба бар',
  opportunities_29: 'Камтылган өлкөлөр',
  opportunities_30: 'миң',
  opportunities_31: 'Уникалдуу долбоорлор',
  opportunities_32: 'миллион',
  opportunities_33: 'Табышмактуу сатып алуучулардын сапарлары',
  opportunities_34: 'Европанын ТОП 10 CX агенттиктеринин катарына кирет',
  opportunities_35: '4Service менен сиздин мүмкүнчүлүктөрүңүз',
  opportunities_36: 'Пайданын өсүшү',
  opportunities_37: 'Сиз эл аралык заказдарга жеткиликтүүлүк аласыз',
  opportunities_38: 'Уникалдуу CX ыкмасы',
  opportunities_39: '20 жылдык тажрыйбасы бар эксперттердин колдоосу',
  opportunities_40: 'Колдоо',
  opportunities_41: 'Биздин команда натыйжага жетүүгө жардам берет',
  opportunities_42: 'Сатуу',
  opportunities_43: 'Биз сизге сатуу системасын түзүүгө жардам беребиз',
  opportunities_44: 'Программалык камсыздоого жеткиликтүүлүк',
  opportunities_45:
    'Сиз бардык сертификатталган IT куралдарына жеткиликтүүлүк аласыз',
  opportunities_46: 'Окутуу',
  opportunities_47:
    'Биз кызматкерлериңизди окутуп гана тим болбостон, консультациялык кызматтарды да көрсөтүүнү улантабыз',
  opportunities_48: 'Өнөктөштүк кимге ылайыктуу?',
  opportunities_49:
    'Сиздин бизнес маркетингдик изилдөөлөр менен байланыштуубу?',
  opportunities_50: 'Же өзүңүздү жаңы тармакта сынап көрүүнү пландап жатасызбы',
  opportunities_51: 'Сиз төмөнкүлөрдү пландап жатасызбы:',
  opportunities_52: 'Инновацияларды киргизүү',
  opportunities_53: 'Эл аралык бренддер менен иштөө',
  opportunities_54: 'Продукт портфелиңизди кеңейтүү',
  opportunities_55: 'Рыноктогу позицияңызды бекемдөө?',
  opportunities_56: 'Кызматкерлериңизди окутуу',
  opportunities_57: 'Бизнесиңизди масштабдоо',
  opportunities_58: 'Биздин ресурстар = Сиздин ресурстар',
  opportunities_59:
    'Кеңири тажрыйбабызды эске алуу менен, кызматташуунун биринчи этабында аны сиз менен бөлүшүүгө даярбыз',
  opportunities_60: 'Маалыматтарды талдоо:',
  opportunities_61: 'Эл аралык аналитикалык команда',
  opportunities_62: 'Маалыматтарды иштетүү ыкмалары - SPSS, Power BI',
  opportunities_63: 'Инновациялык методологиялар жана кеңири методдор топтому',
  opportunities_64: 'Каалаган форматтагы отчеттор',
  opportunities_65: 'Программалык камсыздоо:',
  opportunities_66: 'Өзүбүздүн ыңгайлаштырылган IT иштеп чыгууларыбыз',
  opportunities_67: 'CAPI үчүн DigSee Sure',
  opportunities_68: 'CAWI үчүн SurveyMonkey',
  opportunities_69: 'Shopmetrics',
  opportunities_70: 'VoIPTime (колл-борбор)',
  opportunities_71: 'Маркетингдик колдоо:',
  opportunities_72: 'PR колдоо',
  opportunities_73: 'Илгерилетүү жана контент түзүү боюнча колдоо',
  opportunities_74: 'Лид генерация процесстерин түзүү',
  opportunities_75: 'IT колдоо:',
  opportunities_76:
    'Биздин программалык камсыздоону орнотуу, конфигурациялоо жана колдонуу боюнча техникалык колдоо.',
  opportunities_77: 'Алыстан жардам көрсөтүү',
  opportunities_78: 'Коопсуздукту көзөмөлдөө',
  opportunities_79: 'Операциялык колдоо:',
  opportunities_80: 'Талаа процесстерин түзүүдө колдоо',
  opportunities_81: 'Антифрод системасы',
  opportunities_82: 'Каалаган татаалдыктагы рекрутинг',
  opportunities_83:
    'Долбоорду жана талаа бөлүмдөрүнүн командасын операциялык башкаруу',
  opportunities_84: 'Рекрутингдин сапатын көзөмөлдөө',
  opportunities_85: 'UpWork',
  opportunities_86: 'Кандай бонустарды аласыз?',
  opportunities_87: 'Кардарлар базасынын өсүшү',
  opportunities_88: 'Рыноктогу имиджди бекемдөө',
  opportunities_89: 'Кардарларды жоготуу тобокелдиктерин диверсификациялоо',
  opportunities_90: 'Технологиялык процесстерди оптималдаштыруу',
  opportunities_91: 'Эл аралык тажрыйба',
  opportunities_92: 'Учурдагы кардарларга көбүрөөк сатуу',
  main_67:
    'Атаандаштык баа анализи сунуштарды оптималдаштырып, кирешени көбөйтүп жана рынок үлүшүн кеңейтет, керектөөчүлөрдүн төлөөгө даярдыгы тууралуу маалыматтарды колдонуу менен негизги өзгөчөлүктөрдү аныктайт',
  main_68:
    'Сиздин соода түйүндөрүңүз бренд стандарттарына шайкеш келерин камсыздап, физикалык өзгөчөлүктөрдү жана алардын кардарлардын кабыл алуусуна тийгизген таасирин баалайт',
  main_69: 'CX чечими',
  main_70:
    'Биздин уникалдуу 360 градус CX чечимибизди ачыңыз: биз инструменттерди жана кызматтарды максаттарыңызга ылайыкташтырып, бизнесиңиздин өнүгүшүнө көмөктөшөбүз',
  main_71: 'Сүйлөө аналитикасы',
  main_72:
    'Биздин өнүккөн сүйлөө аналитикасы куралы оозеки сүйлөөнү текстке айландырып, бизнеске кардарлардын тажрыйбасын жакшыртуу, натыйжалуулукту көзөмөлдөө, шайкештикти камсыздоо жана өсүштү камсыз кылуу үчүн баалуу маалыматтарды берет',
  parthership: 'Өнөктөштүк',
  banner_1: 'CX консалтинги жана кызматтары — бизнесиңизге 360° көз караш',
  banner_2: 'Акыркы изилдөөлөрдөн кабардар болуп туруңуз!',
  banner_3:
    'Мен Купуялык саясатына ылайык жеке маалыматтарды иштетүүгө макулдугумду берем',
  banner_4: '*Рынокту тандаңыз',
  banner_5: 'Жазылганыңыз үчүн рахмат!',
  banner_6: 'Биз сиз менен эң кызыктуу контентти гана бөлүшөбүз!',
  banner_7: 'Жөнөтүү',
  banner_8: 'Украинча',
  banner_9: 'Казакстан',
  brand_awareness_1: 'Бренд маалымдуулугу',
  brand_awareness_2: 'жана колдонуу',
  brand_awareness_3:
    'Бизнес ийгилиги үчүн бренд маалымдуулугуңуздун жана колдонууңуздун потенциалын ачыңыз',
  brand_awareness_4: 'Эксперт менен сүйлөшүңүз',
  brand_awareness_5: 'Жөнүндө',
  brand_awareness_6:
    '<b>Брендиңиздин таанылыш жана</b> тааныштык деңгээлин баалаңыз',
  brand_awareness_7:
    '<b>Максаттуу рыногуңуздагы бренд</b> маалымдуулугунун деңгээлин аныктаңыз',
  brand_awareness_8:
    '<b>Кармап калуу жана берилгендик көрсөткүчтөрүн</b> кылдат көзөмөлдөңүз',
  brand_awareness_9:
    '<b>Керектүү көрсөткүчтөрдү жакшыртуу үчүн</b> оптималдуу стратегияны тандаңыз',
  brand_awareness_10: 'Биздин чечимдер менен көптөгөн мүмкүнчүлүктөрдү ачыңыз',
  brand_awareness_11: 'Бренд маалымдуулугу',
  brand_awareness_12: 'Брендди колдонуу',
  brand_awareness_13:
    '<b>Ачыңыз</b> — керектөөчү сегменттер арасында брендиңиз канчалык тааныларын',
  brand_awareness_14:
    '<b>Көзөмөлдөңүз</b> — аудиторияңыздын маалымдуулук деңгээлин',
  brand_awareness_15:
    '<b>Изилдеңиз</b> — сатып алуу алдында керектөөчүлөрдүн өзүнөн-өзү пайда болгон ойлорун',
  brand_awareness_16:
    '<b>Түшүнүңүз</b> — брендиңиз тууралуу маалымдуулукту түзгөн негизги булактарды',
  brand_awareness_17:
    '<b>Эске алыңыз</b> — брендиңиздин өнүмдөрүн же кызматтарын колдонуп көргөн керектөөчүлөрдүн санын',
  brand_awareness_18:
    '<b>Аныктаңыз</b> — алгач колдонуп көргөндөн кийин брендиңизге берилген бойдон калган керектөөчүлөрдү',
  brand_awareness_19: '<b>Ачыңыз</b> — брендиңизди сунуштоо ыктымалдыгын',
  brand_awareness_20:
    '<b>Билиңиз</b> — келечекте брендиңизди колдонууну ойлогон керектөөчүлөрдүн үлүшүн',
  brand_awareness_21: 'Brand Awareness жана Usage кимге пайдалуу?',
  brand_awareness_22: 'Жаңы өнүмдү ишке киргизген компаниялар',
  brand_awareness_23: 'Белгилүү брендди кайра жандандырган компаниялар',
  brand_awareness_24:
    'Керектөөчүлөр брендин кандай таанып жана колдонуп жатканын түшүнүүнү жана жакшыртууну каалаган ар кандай бизнес',
  brand_awareness_25:
    'Биздин методологиялар бренд маалымдуулугун жана колдонулушун оптималдаштыруу үчүн баалуу маалыматтарды берет',
  brand_awareness_26: 'Методология кардардын суроосуна жараша жекече тандалат',
  brand_awareness_27: 'Брендди колдонуу воронкасынын методологиясы',
  brand_awareness_28:
    'Сыноо көрсөткүчү бренд тууралуу билген жана анын өнүмдөрүн же кызматтарын колдонуп көргөн аудиториянын үлүшүн көрсөтөт.',
  brand_awareness_29:
    'Кайра колдонуу көрсөткүчү брендди билген жана анын өнүмдөрүн же кызматтарын колдонуп көргөн аудиториянын акыркы 12 ай ичинде сатып алууларды же колдонууну уланткан пайызын көрсөтөт.',
  brand_awareness_30:
    'Кармап калуу көрсөткүчү бренддин өнүмдөрүн же кызматтарын туруктуу колдонгон адамдардын үлүшүн көрсөтөт жана акыркы 6 ай ичинде бул сунуштарды колдонгондордун пайызын аныктайт.',
  brand_awareness_31:
    'Кармап калуу көрсөткүчү акыркы 6 ай ичинде бренддин өнүмдөрүн/кызматтарын колдонгон кардарлардын канчасы брендди тандап, убакыт өткөн сайын ага берилген бойдон каларын көрсөтөт.',
  brand_awareness_32: 'Brand Awareness методологиясы',
  brand_awareness_33:
    'Top of Mind (TOM) — бул респондент биринчи болуп өз алдынча атаган бренд.',
  brand_awareness_34:
    'Жалпы өз алдынча маалымдуулук TOMду кошкондо бардык өз алдынча эскерүүлөрдүн жыйындысын билдирет.',
  brand_awareness_35:
    'Aided Awareness колдонуучуларга эскертүү берилгенде брендиңиз канчалык тааныларын көрсөтөт.',
  brand_awareness_36: 'Бренд атрибуттарынын натыйжалуулук картасы',
  brand_awareness_37:
    'Бул курал бренддин ар кандай атрибуттарынын маанилүүлүгүн баалап жана визуалдаштырып, алардын ар бири бренддин жалпы натыйжалуулугуна жана керектөөчүлөрдүн кабыл алуусуна кандай салым кошорун көрсөтөт.',
  brand_awareness_38:
    'Биздин кеңири анализ аркылуу брендиңиздин таасирин күчөтүүнүн ачкычтарын табыңыз.',
  brand_awareness_39: 'Бренддердин кабыл алуу картасы',
  brand_awareness_40:
    'Бул курал атаандаштык рыноктогу керектөөчүлөрдүн кабыл алуусунун визуалдык көрүнүшүн берет. Бул ыкма бренддердин айырмачылыктарын так көрсөтүп, рыноктун негизги атрибуттарын баса белгилөөгө жардам берет.',
  brand_awareness_41:
    'Ал бренддер менен бул аныктоочу мүнөздөмөлөрдүн ортосундагы байланыштарды байкоону жана түшүндүрүүнү жеңилдетет.',
  brand_awareness_42:
    'Белгилүү бир бренддин айрым атрибуттарга жакындыгы анын ошол мүнөздөмөлөр менен күчтүү байланышын көрсөтөт. Ошондой эле эки бренддин жакындыгы алардын окшоштугун, жалпы образын жана бир эле рынок сегментине таандык экенин билдирет.',
  consumer_journey_map_1: 'Керектөөчүнүн саякат картасы',
  consumer_journey_map_2:
    'Биздин Consumer Journey Map менен бизнесиңиздеги тоскоолдуктарды аныктап жана жеңиңиз',
  consumer_journey_map_3: 'ИШЕНИМ БИЛДИРГЕНДЕР',
  consumer_journey_map_4: '4Service',
  consumer_journey_map_5:
    'Керектөөчүлөрүңүз менен брендиңиздин ортосундагы өз ара аракеттерди оптималдаштыруу үчүн CJM мүмкүнчүлүктөрүн ачыңыз',
  consumer_journey_map_6:
    'Керектөөчү өнүмдү сатып алардан мурун кандай кадамдарды жасай турганын аныктаңыз',
  consumer_journey_map_7:
    'Ойлоп табылган эмес, чыныгы кардарларыңыздан маалымат алыңыз',
  consumer_journey_map_8: 'Кардарларыңыздын тажрыйбасын толук түшүнүңүз',
  consumer_journey_map_9:
    'Жоголгон мүмкүнчүлүктөрдү аныктап, атаандаштарыңыз менен салыштырыңыз',
  consumer_journey_map_10: 'Биздин CJM ыкмасы менен таанышыңыз',
  consumer_journey_map_11:
    'Биз ар кандай каналдар аркылуу жана белгилүү бир убакыт аралыгында керектөөчүнүн өнүм, кызмат, компания же бренд менен болгон өз ара аракетинин жолун түзөбүз.',
  consumer_journey_map_12:
    'Биз сатып алуу аяктаганга чейин керектөөчүлөр басып өткөн этаптарды, ар бир этаптагы күтүүлөрдү, эмоцияларды жана мотивацияларды сүрөттөйбүз.',
  consumer_journey_map_13: 'Биз менен пайда алыңыз',
  consumer_journey_map_14:
    'Биз глобалдык бизнестин ийгилигинин татаалдыктарын түшүнгөн тажрыйбалуу адистердин командасын сунуштайбыз',
  consumer_journey_map_15:
    'Биз күткөнүңүздөн ашкан натыйжаларды берүүгө умтулабыз',
  consumer_journey_map_16:
    'Биз сиздин өсүшүңүзгө салым кошкон комплекстүү чечимдерди табабыз',
  consumer_journey_map_17: 'Биз жекече CJM чечимдерин сунуштоого адистешкенбиз',
  consumer_journey_map_18: 'Консультацияга жазылыңыз',
  consumer_journey_map_19: 'Маалыматтарга негизделген чечимдер',
  consumer_journey_map_20:
    'Чечимдериңизди божомолдорго эмес, реалдуу маалыматтарга негиздеңиз',
  consumer_journey_map_21: 'CJMди оптималдаштырыңыз',
  consumer_journey_map_22:
    'Кардарлардын сапарынын ар бир этабында алардын муктаждыктарын жана күтүүлөрүн канааттандыруу менен бекем мамилелерди түзүңүз',
  consumer_journey_map_23: 'Алдыңкы орунда болуңуз',
  consumer_journey_map_24:
    'Өзүңүздү атаандаштарыңыз менен салыштырып, рыноктон алдыда болуңуз',
  consumer_journey_map_25: 'Сунуштар',
  consumer_journey_map_26:
    'Ийгиликке жетүү, кардарлардын берилгендигин күчөтүү, сатууну көбөйтүү жана бизнес потенциалыңызды толук ачуу үчүн биздин CJM сунуштарын ишке ашырыңыз',
  consumer_journey_map_27:
    'Биздин Consumer Journey Map аркылуу чыныгы керектөөчү жолун ачыңыз',
  consumer_journey_map_28:
    '20 жылдан ашык тажрыйбасы бар эксперттер кеңири изилдөө жүргүзүшөт',
  consumer_journey_map_29:
    'Сапаттык изилдөө түшүнүктөрдү, пикирлерди жана тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултууну жана талдоону камтыйт.',
  consumer_journey_map_30:
    'Сандык изилдөө ыкмалары сурамжылоолордон, анкеталардан жана изилдөөлөрдөн алынган маалыматтарды объективдүү өлчөөнү жана сандык талдоону камтыйт.',
  consumer_journey_map_31:
    'Маалыматтар чогултулгандан кийин эксперттер аларды талдап, сизге эң мыкты сунуштарды берүү үчүн жыйынтык чыгарышат.',
  boarding_1: 'Кардардын саякат картасы',
  boarding_2:
    'Customer Journey Mapping (CJM) — бул максаттуу аудиторияны аныктоо, алардын муктаждыктарын жана чөйрөсүн түшүнүү, андан соң кызыктуу тажрыйбаны камсыз кылуучу план түзүү',
  boarding_3: 'Net Promotion Score',
  boarding_4:
    'Net Promoter Score (NPS) — кардар тажрыйбасын өлчөөнүн алтын стандарты, бир суроого негизделет: Уюмду/Өнүмдү/Кызматты сунуштоо ыктымалдыгыңыз канчалык?',
  boarding_5: 'Бренддин саламаттыгын көзөмөлдөө',
  boarding_6:
    'Brand Health Tracking (BHT) изилдөөсү брендиңиздин маалымдуулук, колдонуу, позициялоо жана жалпы натыйжалуулук көрсөткүчтөрүн өлчөөгө жардам берет',
  boarding_7: 'Адам ресурстары боюнча изилдөө',
  boarding_8:
    'Human Resource Research HR практикаларын жана натыйжалуулугун баалоо үчүн колдонулат жана учурдагы өнүгүү менен башкаруунун деталдуу анализин сунуштайт',
  boarding_9: 'UX тестирлөө',
  boarding_10:
    'Usability (UX) тестирлөө — бул чыныгы адамдардын веб-сайт, тиркеме же башка өнүм менен кантип өз ара аракеттенерин жана алардын жүрүм-туруму менен реакцияларын байкоо',
  boarding_11: 'Кардарлардын канааттануу индекси',
  boarding_12:
    'Кардарлардын канааттануусу сиздин компания сунуштаган өнүмдү же кызматты сатып алууда кардардын күтүүлөрү канчалык деңгээлде аткарылганын көрсөтөт',
  boarding_13: 'Жарнаманы тестирлөө',
  boarding_14:
    'Жарнамалык кампания — чоң инвестиция. Жарнамаларыңыз күчтүү болуп, максималдуу ROI алып келерине ынаныңыз',
  boarding_15: 'Талаа аудит / Retail аудит',
  boarding_16:
    'Дүкөнүңүз же брендиңиз боюнча кеңири маалымат чогултуп, өсүү тоскоолдуктарын талдап жана аларды жеңүү үчүн натыйжалуу стратегияларды түзүңүз',
  boarding_17: 'Play4Sales',
  boarding_18:
    'Натыйжалуулукту башкаруу программасы. Сатууну көбөйтүү үчүн оюндаштырылган тиркеме',
  boarding_19: 'Voicer',
  boarding_20:
    'Пикирлерди башкаруу системасы. Кардарыңыздын үнү бир системада. Кардарлардын пикирлерин башкаруу системасы',
  boarding_21: 'Сапаттык изилдөө',
  boarding_22:
    'Сапаттык изилдөө түшүнүктөрдү, пикирлерди же тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултуу жана талдоо болуп саналат',
  boarding_23: 'Сандык изилдөө',
  boarding_24:
    'Сандык изилдөө ыкмалары сурамжылоолор, анкеталар жана изилдөөлөр аркылуу алынган маалыматтарды объективдүү өлчөөнү жана сандык талдоону камтыйт',
  boarding_25: 'Mystery Shopping',
  boarding_26:
    'Mystery Shopping — алдын ала аныкталган сценарий боюнча кардар менен компаниянын же уюмдун ортосундагы өз ара аракеттерди өлчөө жана көзөмөлдөө үчүн колдонулган рыноктук изилдөө ыкмасы',
  boarding_27: 'Wantent',
  boarding_28:
    'Аудиториядан алынган маалыматтарды сунуштаган AI менен иштеген контент аналитика платформасы',
  boarding_29: 'Бааларды мониторингдөө',
  boarding_30:
    'Бааларды мониторингдөө — атаандаштардын бааларын чогултуу, иштетүү жана талдоо процесси',
  boarding_31: 'Кызмат дизайны',
  boarding_32:
    'Кызмат дизайны — өнүмдү же кызматты колдоно турган адамдар менен убакыт өткөрүү аркылуу алардын муктаждыктарын жана каалоолорун түшүнүү жолу',
  boarding_33: 'Автомобиль тармагындагы бааларды талдоо',
  boarding_34:
    'Атаандаштык баа талдоосу негизги өзгөчөлүктөрдү аныктоо үчүн керектөөчүлөрдүн төлөөгө даярдыгы тууралуу маалыматтарды колдонуп, сунуштарды оптималдаштырат, кирешени көбөйтөт жана рыноктук үлүштү жогорулатат',
  boarding_35: 'Facility Check Аудити',
  boarding_36:
    'Соода түйүндөрүңүздүн бренд стандарттарына шайкеш келишин камсыздап, физикалык мүнөздөмөлөрдү жана алардын кардарлардын кабыл алуусуна тийгизген таасирин баалайт',
  boarding_37: 'CX чечими',
  boarding_38:
    'Биздин уникалдуу 360 даражалык CX чечимибизди тааныңыз: биз бизнесиңизди өнүктүрүү үчүн максаттарыңызга ылайык куралдарды жана кызматтарды ыңгайлаштырабыз',
  boarding_39: 'Сүйлөө аналитикасы',
  boarding_40:
    'Биздин өнүккөн сүйлөө аналитикасы куралы сүйлөгөн сөздү текстке айлантып, кардарлардын тажрыйбасын жакшыртуу, көрсөткүчтөрдү көзөмөлдөө, талаптарга шайкештикти камсыз кылуу жана өсүштү камсыздоо үчүн бизнеске баалуу маалыматтарды берет',
  boarding_41: 'Колдонуу жана мамиле',
  boarding_42:
    'Колдонуу жана мамиле — бул аудиториянын практикалык колдонуу үлгүлөрүн жана психологиялык көз караштарын талдоо аркылуу брендиңиз менен кандайча өз ара аракеттенерин түшүнүүгө жардам берген ыкма, ал маркетингдик жана продукт стратегияларын ыңгайлаштырууга мүмкүндүк берет',
  boarding_43: 'Бренддин таанымалдуулугу жана колдонулушу',
  boarding_44:
    'Бренддин таанымалдуулугу жана колдонулушу бренддин көрүнүктүүлүгүн жана аудиториянын катышуусун жогорулатуу үчүн максаттуу рыноктогу таанууну, тааныштыкты, өз ара аракеттенүү жыштыгын жана кармап калууну баалоону камтыйт',
  boarding_45: 'Бренддин иденттүүлүгү жана позицияланышы',
  boarding_46:
    'Бренддин иденттүүлүгү жана позицияланышы керектөөчүлөрдүн кабыл алуусун, ар түрдүү аудиториялардын көз караштарын жана брендиңиз кандай кабыл алынарын ачып көрсөткөн комплекстүү талдоо болуп саналат',
  boarding_47: 'Кардарларды профилдөө жана сегментациялоо',
  boarding_48:
    'Кардарларды профилдөө жана сегментациялоо максаттуу рынокту жалпы мүнөздөмөлөрүнө жараша өзүнчө топторго бөлүүнү камтыйт, бул белгилүү аудитория сегменттерине ылайыкташтырылган стратегияларды түзүүгө мүмкүндүк берет',
  boarding_49: 'Керектөөчүнүн саякат картасы',
  boarding_50:
    'Керектөөчүнүн саякат картасы — бул керектөөчүнүн продуктуңуз же брендиңиз менен өз ара аракеттенүүсү учурунда башынан өткөргөн этаптарды, байланыш чекиттерин, эмоцияларды жана мотивацияларды визуалдык түрдө чагылдыруу',
  boarding_51:
    'Бизнесиңиз үчүн практикалык сунуштарды жана натыйжалуу жыйынтыктарды камсыз кылууга болгон умтулуубуздун негизин түзгөн инновациялык ыкмалар тууралуу билиңиз',
  boarding_52:
    'Тармагыңызга ылайыкташтырылган маалыматтык интеллектке бай продукттарыбыз менен таанышып, негиздүү чечимдерди кабыл алып, атаандаштардан алдыда болуңуз',
  boarding_53:
    'Биздин комплекстүү рыноктук изилдөө чечимдерибиз менен рынок тенденцияларына, керектөөчүлөрдүн жүрүм-турумуна жана атаандаштык чөйрөгө терең сүңгүңүз',
  boarding_54: 'Ad Hoc изилдөө',
  boarding_55:
    'Ad Hoc изилдөө — бул белгилүү бир маселени чечүүгө багытталган, учурдагы методологиялардын айкалышын же жаңы ыкманы колдонуу аркылуу ылайыкташтырылган чечим түзгөн өзгөчө ыкма',
  boarding_56: 'Социологиялык изилдөө',
  boarding_57:
    'Социологиялык изилдөө адамдардын жүрүм-турумунун жана социалдык өз ара аракеттенүүлөрүнүн мыйзам ченемдүүлүктөрүн ачып, инновациялык стратегияларды иштеп чыгууга жана максаттуу аудитория менен маанилүү байланыштарды түзүүгө жардам берген баалуу маалыматтарды берет',
  not_found_1: 'Ой! Биз бул баракты таба алган жокпуз.',
  not_found_2: 'Биздин продукттарды карап көрбөйсүзбү?',
  not_found_3: 'Консультацияга жазылуу',
  customer_profiling_segmentation_1:
    'Кардарларды профилдөө жана сегментациялоо',
  customer_profiling_segmentation_2:
    'Биз сизге максаттуу аудиторияңызды так аныктоого жардам берип, стратегияңызды натыйжалуураак кылабыз',
  customer_profiling_segmentation_3:
    'Билдирүүлөрүңүз ар дайым максаттуу керектөөчү топторго натыйжалуу жетиши үчүн рыноктук сегментациянын күчүн колдонуңуз',
  customer_profiling_segmentation_4: 'Керектөөчүлөрдү тереңирээк түшүнүңүз',
  customer_profiling_segmentation_5:
    'Продуктуңуз үчүн эң ылайыктуу максаттуу аудиторияны табыңыз',
  customer_profiling_segmentation_6: 'Тартуу үчүн жаңы сегменттерди изилдеңиз',
  customer_profiling_segmentation_7:
    'Сатып алууга тоскоол болгон факторлорду аныктаңыз',
  customer_profiling_segmentation_8:
    'Биз ылайыкташтырылган сегментациялык чечимдерди сунуштоого адистешкенбиз',
  customer_profiling_segmentation_9: 'Уникалдуу ыкма',
  customer_profiling_segmentation_10:
    'Сиздин муктаждыктарыңыз үчүн атайын түзүлгөн уникалдуу жана жекелештирилген сегментация чечимин алыңыз',
  customer_profiling_segmentation_11: 'Максаттуу персонаждар',
  customer_profiling_segmentation_12:
    'Терең рыноктук талдоо жана комплекстүү изилдөөлөрдүн негизинде түзүлгөн максаттуу персонаждар',
  customer_profiling_segmentation_13: 'Жаңы сегменттер',
  customer_profiling_segmentation_14:
    'Эң баалуу аудитория сегменттериңизди аныктап, максаттуу багыттоонун артыкчылыктарын ачыңыз',
  customer_profiling_segmentation_15: 'Сунуштар',
  customer_profiling_segmentation_16:
    'Биздин сунуштарды ишке ашырып, ийгиликке жетишиңиз, кардарлардын берилгендигин арттырыңыз, сатууну көбөйтүңүз жана бизнесиңиздин мүмкүнчүлүктөрүн толук пайдаланыңыз',
  customer_profiling_segmentation_17:
    '20 жылдан ашуун тажрыйбасы бар эксперттер комплекстүү изилдөө жүргүзүшөт',
  customer_profiling_segmentation_18:
    'Сапаттык изилдөө түшүнүктөрдү, пикирлерди жана тажрыйбаларды түшүнүү үчүн сандык эмес маалыматтарды чогултууну жана талдоону камтыйт.',
  customer_profiling_segmentation_19:
    'Сандык изилдөө ыкмалары сурамжылоолордон, анкеталардан жана изилдөөлөрдөн алынган маалыматтарды объективдүү өлчөөнү жана сандык талдоону камтыйт.',
  customer_profiling_segmentation_20:
    'Маалыматтарды чогулткандан кийин эксперттер аларды талдап, сизге эң мыкты сунуштарды берүү үчүн жыйынтык чыгарышат.',
  customer_profiling_segmentation_21:
    'Биз жөн гана өлчөө жүргүзбөстөн, сизге так кадам-кадам аракеттер планы менен камсыздайбыз',
  customer_profiling_segmentation_22: 'Биздин методология',
  customer_profiling_segmentation_23: 'Жаккард индекси',
  customer_profiling_segmentation_24:
    'Респонденттерге түз суроо берилгенде, алардын компанияларга болгон артыкчылыктары тууралуу жооптору чыныгы жүрүм-турумуна дал келбеши мүмкүн. Түз суроолордун ордуна биз компаниянын өзгөчөлүктөрү менен керектөөчүнүн тандоосунун ортосундагы байланышты түшүнүү үчүн статистикалык Жаккард талдоосун колдонобуз.',
  customer_profiling_segmentation_25: 'Драйверлер',
  customer_profiling_segmentation_26:
    'Биз драйверлерди (белгилүү бир натыйжага таасир этүүчү факторлорду) аныктап, алардын маанилүүлүгүнө жараша негизги, орточо жана маанисиз драйверлерге бөлөбүз.',
  customer_profiling_segmentation_27: 'Сегментация',
  customer_profiling_segmentation_28:
    'Сиз кардарлардын тандоосунун так мүнөздөмөлөрү менен сегментация аласыз.',
  customer_profiling_segmentation_29: 'Сегментацияга болгон биздин ыкма',
  customer_profiling_segmentation_30: 'Демографиялык',
  customer_profiling_segmentation_31: 'жаш',
  customer_profiling_segmentation_32: 'жыныс',
  customer_profiling_segmentation_33: 'киреше',
  customer_profiling_segmentation_34:
    'Бул продукттарды, кызматтарды жана маркетингди белгилүү топторго ылайыкташтырууга жардам берип, алардын актуалдуулугун жана натыйжалуулугун жогорулатат',
  customer_profiling_segmentation_35: 'Психографиялык',
  customer_profiling_segmentation_36: 'жашоо образы',
  customer_profiling_segmentation_37: 'баалуулуктар',
  customer_profiling_segmentation_38: 'жүрүм-турум',
  customer_profiling_segmentation_39:
    'Бул жекелештирилген маркетингди, кардарлар менен терең байланыштарды жана компания үчүн берилгендик менен сатуунун өсүшүн камсыздайт',
  customer_profiling_segmentation_40: 'Жүрүм-турумдук',
  customer_profiling_segmentation_41: 'аракеттер',
  customer_profiling_segmentation_42: 'мотивация',
  customer_profiling_segmentation_43: 'сатып алуу жыштыгы',
  customer_profiling_segmentation_44:
    'Бул максаттуу маркетингди, кардарлардын канааттануусун жогорулатууну, кармап калууну жана компаниянын кирешелүүлүгүн арттырууну камсыз кылат',
  customer_profiling_segmentation_45: 'Географиялык',
  customer_profiling_segmentation_46: 'жайгашкан жер',
  customer_profiling_segmentation_47:
    ' Бул компания үчүн максаттуу маркетингди, ылайыкташтырылган продукттарды, натыйжалуу бөлүштүрүүнү жана рынокко терең кирүүнү камсыз кылат.',
  brands_identity_1: 'Бренддин иденттүүлүгү жана позицияланышы',
  brands_identity_2:
    'Керектөөчүлөрдүн кабыл алуусу тууралуу түшүнүктөрдү ачып берип жана стратегияңызды өркүндөтүү аркылуу брендиңизди биздин терең талдообуз менен өзгөртүңүз',
  brands_identity_3: 'Эксперт менен сүйлөшүңүз',
  brands_identity_4: '<b>Комплекстүү</b> бренд иденттүүлүгүн талдоону ачыңыз',
  brands_identity_5:
    '<b>Керектөөчүлөрдүн кабыл алуусунан алынган</b> түшүнүктөрдү изилдеңиз',
  brands_identity_6:
    '<b>Максаттуу аудиториянын ар түрдүү</b> көз караштарын түшүнүңүз',
  brands_identity_7:
    '<b>Негизделген чечимдер үчүн</b> керектөөчүлөрдүн жүрүм-туруму, адаттары жана артыкчылыктары тууралуу түшүнүк алыңыз',
  brands_identity_8:
    '20 жылдан ашуун кардар тажрыйбасына ээ 4Service эксперттери бизнесиңиздин өсүшүнө жардам берген уникалдуу чечимдерди түзүшөт',
  brands_identity_9:
    '<b>Сиз бардык маанилүү маалыматтар менен жабдылган изилдөө пакетине жеткиликтүү болосуз.</b> Ал күчтүү жактарды жана көңүл бурууну талап кылган тармактарды көрсөтүүчү диагностикалык курал катары кызмат кылат',
  brands_identity_10:
    '<b>Биздин кызматтар бизнеске керектүү куралдарды берет</b>, алар негизделген чечимдерди кабыл алууга, стратегияларды өркүндөтүүгө жана өз тармактарында ийгиликке жетүүгө жардам берет.',
  brands_identity_11: 'Брендиңиздин атаандаш рыноктогу позициясын чыңдоо үчүн',
  brands_identity_12: 'Рыноктогу катышуусун күчөтүүгө умтулган бизнес үчүн',
  brands_identity_13: 'Стратегиясын жогорулатууга умтулган бизнес үчүн',
  brands_identity_14: 'Бренд иденттүүлүгү',
  brands_identity_15: 'Брендди позициялоо',
  brands_identity_16:
    '<b>Брендиңиздин</b> керектөөчү сегменттериндеги кабыл алуусун аныктаңыз.',
  brands_identity_17:
    '<b>Брендиңизге жана атаандаштарыңызга таандык</b> сапаттарды аныктаңыз.',
  brands_identity_18:
    '<b>Стратегиялык жакшыртуу үчүн күчтүү жана алсыз жактарды</b> баалаңыз.',
  brands_identity_19:
    '<b>Бренд образыңыздын илгерилетилген баалуулуктарга шайкештигин</b> баалаңыз.',
  brands_identity_20:
    '<b>Брендиңиздин кабыл алынган ишенимдүүлүгүн</b> баалаңыз.',
  brands_identity_21:
    '<b>Брендиңиздин архетиптик жана символикалык</b> кабыл алуусун изилдеңиз.',
  brands_identity_22:
    '<b>Брендиңиздин</b> атаандаштарга салыштырмалуу уникалдуу артыкчылыктарын жана айырмалоочу өзгөчөлүктөрүн аныктаңыз.',
  brands_identity_23:
    '<b>Керектөөчүлөрдүн продукттарыңызды/кызматтарыңызды сатып алуу ыктымалдыгына таасир этүүчү негизги атрибуттарды</b> аныктаңыз.',
  brands_identity_24:
    '<b>Брендиңиз учурда керектөөчүлөрдүн аң-сезиминде кандай позицияда турганын аныктап</b>, каалаган рынок сегменттерин тартуу үчүн кандай аспекттерди коммуникациялоо керектигин белгилеңиз.',
  brands_identity_25:
    'Методология кардардын суроо-талабына жараша өзүнчө тандалат',
  brands_identity_26: 'Бренддин таанымалдуулугу жана колдонулушу',
  brands_identity_27:
    'Бренддин деңгээлин баалоо маалымдуулук жана колдонуу деңгээлин өлчөөнү камтыйт жана баалоонун негизги бөлүгү болуп саналат.',
  brands_identity_28: 'Брендди жеткирүү жана ишеним',
  brands_identity_29:
    'Бул көрсөткүч кардарлардын сунуштоо деңгээлин (recommendation) жана бренддин убадаларын туруктуу аткаруу, оң кардар тажрыйбасын түзүү жана ишенимди бекемдөө жөндөмүн өлчөйт.',
  brands_identity_30: 'Бренд имиджинин натыйжалуулугу',
  brands_identity_31:
    'Бренддин натыйжалуулугун баалоо анын алты маанилүү баалуулук (3 рационалдык жана 3 эмоционалдык) менен байланышын, категориядагы өзгөчөлүгүн жана керектөөчүлөрдө сыймык сезимин жаратуу жөндөмүн талдоону камтыйт.',
  brands_identity_32: 'Бренддин ден соолук көрсөткүчү',
  brands_identity_33:
    'Brand Health Score сизге атаандаштык чөйрөсүндө брендиңиздин кандай иштеп жатканын комплекстүү түшүнүүгө жардам берет.',
  sociological_research_1: 'Социологиялык изилдөө',
  sociological_research_2:
    'Биз социалдык кубулуштарды жана процесстерди терең талдайбыз, бул уникалдуу аналитикалык корутундулар жана сунуштар аркылуу негизделген чечимдерди кабыл алууга жардам берет',
  sociological_research_3: 'Биз менен байланышыңыз',
  sociological_research_4: 'Биздин кардарлар',
  sociological_research_5: 'CAWI',
  sociological_research_6:
    'CATI — компьютер аркылуу телефондук сурамжылоолорду жүргүзүү үчүн колдонулган маалымат чогултуу ыкмасы. CATI программасы маалымат чогултуу, жоопторду киргизүү жана сурамжылоону башкаруу процесстерин автоматташтырууга мүмкүндүк берет. CATI колдонуу сурамжылоону көзөмөлдөөнү жеңилдетет, маалыматтарды тез талдоого жана иштетүүгө шарт түзөт жана сурамжылоонун жогорку деңгээлде стандартташтырылышын камсыз кылат.',
  sociological_research_7: 'CATI',
  sociological_research_8:
    'CAWI — бул маалыматтарды чогултуу ыкмасы, анда респонденттер веб-интерфейс аркылуу анкета толтурушат же суроолорго жооп беришет, ал эми маалыматтар атайын программалык камсыздоо аркылуу автоматтык түрдө чогултулуп жана иштетилет. CAWI ыкмасы ири масштабдагы сурамжылоолорду өткөрүүгө, маалыматтарды тез чогултууга жана талдоого мүмкүндүк берет.',
  sociological_research_9: 'CAPI',
  sociological_research_10:
    'CAPI — бул бетме-бет сурамжылоолор үчүн маалымат чогултуу ыкмасы, анда изилдөөчү респонденттердин жоопторун планшетке же уюлдук телефонго киргизет. Бул маалыматтарды автоматташтырылган түрдө чогултууга, киргизүү каталарын азайтууга жана жыйынтыктарды талдоону жөнөкөйлөтүүгө мүмкүндүк берет.',
  sociological_research_11:
    'Биздин эксперттер ар кандай инструменттерди колдонушат',
  sociological_research_12: 'Тандалма',
  sociological_research_13:
    'Биз ар кандай татаалдыктагы тандалмаларды эсептеп чыгып колдонобуз',
  sociological_research_14:
    'Ишибизде жөнөкөй, системалуу, стратификацияланган жана кластердик тандалмаларды колдонобуз',
  sociological_research_15:
    'Улуттук деңгээлде өкүлчүлүктүү бетме-бет сурамжылоолор үчүн көп баскычтуу стратификацияланган тандоо процедураларын колдонобуз',
  sociological_research_16:
    'Аймактар боюнча калктуу конуштарды тандоо алардын көлөмүнө жана түрүнө жараша жүргүзүлөт, алардын саны ар бир аймактагы үлүшүнө пропорционалдуу аныкталат',
  sociological_research_17: 'Биз жүргүзөбүз',
  sociological_research_18: 'Коомдук пикирди изилдөө',
  sociological_research_19: 'Социалдык-экономикалык изилдөөлөр',
  sociological_research_20: 'Кабинеттик изилдөө',
  sociological_research_21: 'Социалдык кызматтардын сапатын баалоо',
  sociological_research_22: 'Кейс-стади',
  sociological_research_23: 'Персоналды изилдөө',
  sociological_research_24:
    'Белгилүү аудиторияларды изилдөө (аялуу топтор, анын ичинде ИЖКлар, аскер кызматкерлери, жаштар ж.б.)',
  sociological_research_25: 'Биз ар бир кардар менен жекече иштейбиз',
  sociological_research_26: 'Биздин кардарлар:',
  sociological_research_27: 'Кайрымдуулук фонддору',
  sociological_research_28: 'Коомдук уюмдар жана бирикмелер',
  sociological_research_29: 'Мамлекеттик түзүмдөр',
  sociological_research_30: 'Биздин ишке болгон мамиле',
  sociological_research_31:
    'Биз ишибизде илимий ыкманы жана учурдагы реалдуулукту терең түшүнүүнү колдонобуз, ошондой эле маалыматтарды чогултуу үчүн ар кандай изилдөө методдорун пайдаланабыз.',
  sociological_research_32:
    'Белгилүү бир суроо-талапты чечүү үчүн керектүү тажрыйбасы бар жогорку адистештирилген эксперттерди тартуу менен бирге, ар түрдүү тармактар боюнча эксперттер базасына ээбиз.',
  sociological_research_33:
    'Биздин ички аналитикалык бөлүм чогултулган маалыматтарды тапшырманын өзгөчөлүктөрүнө жараша уникалдуу инструменттердин жардамы менен талдайт.',
  sociological_research_34:
    'Биз максаттуу аудиторияңыздын муктаждыктарын жана күтүүлөрүн эске алуу менен деталдуу корутундулар жана сунуштар камтылган отчетторду даярдайбыз.',
  sociological_research_35:
    'Сунуштарды ишке ашыруу учурунда кеңеш берүү жана колдоо көрсөтүп, оң өзгөрүүлөрдү киргизүүгө жардам беребиз.',
  sociological_research_36: 'Биздин изилдөөлөр ТВда',
  sociological_research_37: 'Биздин отчеттор менен таанышыңыз',
  sociological_research_38:
    'Биздин ишибиздеги илимий мамиле Украина жана Европа боюнча минималдуу ката менен так жана ишенимдүү социологиялык маалыматтарды камсыздайт.',
  sociological_research_39:
    'Биз социологиялык изилдөөлөрдү жүргүзүүнүн бардык этикалык принциптерин жана стандарттарын сактайбыз.',
  sociological_research_40:
    'Биз Украина Социологиялык Ассоциациясынын социологдорунун кесиптик этика кодексин жана Хельсинкинин изилдөөлөр боюнча этикалык принциптер декларациясын карманабыз. ESOMAR, Украина Маркетинг Ассоциациясы жана Украина Байланыш Борборлорунун Жалпыукраиналык Ассоциациясынын мүчөлөрүбүз.',
  sociological_research_41: 'Талаа',
  sociological_research_42: 'онлайн панель',
  sociological_research_43: 'туруктуу интервьюерлер',
  sociological_research_44: 'супервайзерлер',
  sociological_research_45: 'Талаа иштеринин сапатын көзөмөлдөө',
  sociological_research_46: 'GPS координаттарынын 100% катталышы (CAPI)',
  sociological_research_47: 'Анкеталарды валидациялоо (CAWI, CAPI, CATI, PAPI)',
  sociological_research_48: 'Маектердин 100% аудио жазуусу (CAPI, CATI)',
  sociological_research_49:
    'Биз лицензияланган программалык камсыздоону колдонобуз:',
  sociological_research_50:
    'SPSS — статистикалык маалыматтарды талдоо жана маалымат топтомдорун иштетүү үчүн',
  sociological_research_51:
    'DigSee Sure for CAPI: анкета логикасы, геолокация, маектердин аудио жазуусу, видеоматериалдарды көрсөтүү',
  sociological_research_52:
    'SurveyMonkey for CAWI: анкета логикасы, ыңгайлуу формат, визуалдаштыруу',
  sociological_research_53:
    'VoIPTime (байланыш борбору): ар кандай татаалдыктагы анкеталарды программалоо, аудио жазууларды кардарга өткөрүп берүү',
  sociological_research_54: 'Тандалма',
  sociological_research_55:
    'Биз ар кандай татаалдыктагы тандалмаларды эсептеп чыгып колдонобуз',
  sociological_research_56:
    'Ишибизде жөнөкөй, системалуу, стратификацияланган жана кластердик тандалмаларды колдонобуз',
  sociological_research_57:
    'Улуттук деңгээлде өкүлчүлүктүү бетме-бет сурамжылоолор үчүн көп баскычтуу стратификацияланган тандоо процедураларын колдонобуз',
  sociological_research_58:
    'Аймактар боюнча калктуу конуштарды тандоо алардын көлөмүнө жана түрүнө жараша жүргүзүлөт, алардын саны ар бир аймактагы үлүшүнө пропорционалдуу аныкталат',
  sociological_research_59: 'Команда',
  sociological_research_60:
    'Биздин социологдор Украина Социологдор Ассоциациясынын мүчөлөрү',
  sociological_research_61:
    'Бизде ар кандай тармактардагы сандык жана сапаттык долбоорлор боюнча тажрыйбасы бар 12 штаттык аналитик иштейт.',
  sociological_research_62:
    'Бизде изилдөө тармагында 10 жылдан ашык тажрыйбасы бар күчтүү аналитикалык команда бар. Курамыбызда окумуштуулар, PhD даражасына ээ адистер жана MBI адистери бар.',
  sociological_research_63: 'Ирина Максимюк',
  sociological_research_64:
    'Изилдөө бөлүмүнүн жетекчиси. Маркетингдик изилдөөлөрдө 15 жылдан ашык тажрыйбасы бар, бардык этаптардагы изилдөөлөрдү башкаруу, аналитикалык отчетторду жана презентацияларды даярдоо боюнча адис.',
  sociological_research_65: 'Андрий Билоскурский',
  sociological_research_66:
    'Программалоо жана маалыматтарды иштетүү бөлүмүнүн жетекчиси. Маркетингдик, социологиялык жана рыноктук изилдөөлөрдө 20 жылдык тажрыйбага ээ.',
  sociological_research_67: 'Олена Сомова',
  sociological_research_68:
    'Программалоо боюнча адис. DonSUUнун социология адистиги боюнча аспиранты. Маркетингдик изилдөөлөрдө 5 жылдык тажрыйбасы бар. Аялдардын Демократиялык Альянсынын Башкармалыгынын мүчөсү, фандрайзинг боюнча жетекчи.',
  sociological_research_69: 'Анна Падалка',
  sociological_research_70:
    'Изилдөө бөлүмүнүн Социологиялык изилдөөлөр бөлүмүнүн жетекчиси. Эл аралык жана улуттук деңгээлдеги социологиялык жана социалдык долбоорлордо 13 жылдык тажрыйбасы бар. Социология илимдеринин кандидаты (PhD), Украина Байланыш Борборлорунун Ассоциациясынын Изилдөө комитетинин жетекчиси.',
  ad_hoc_1: 'Ad Hoc',
  ad_hoc_2: 'Өзгөчө учурлар үчүн альтернативдүү изилдөөбүздү ачыңыз',
  ad_hoc_3: 'Биз менен байланышыңыз',
  ad_hoc_4: 'Биздин ыкма',
  ad_hoc_5:
    'Биздин эксперттер командасы чогултулган маалыматтарды кылдат талдап, өсүшүңүзгө салым кошо турган татаал чечимдерди сунуштайт.',
  ad_hoc_6:
    'Сиздин өзгөчө талаптарыңызга ылайык уникалдуу изилдөөнү иштеп чыгабыз, сурамжылоолор, интервьюлар, фокус-топтор, маалыматтарды талдоо жана башка көптөгөн методологияларды колдонобуз.',
  ad_hoc_7: 'Эмне үчүн Ad Hoc Research?',
  ad_hoc_8: 'Ийкемдүүлүк',
  ad_hoc_9:
    'Эки изилдөө долбоору бирдей болбойт. Ad Hoc Research менен биз ыкманы керектүү учурда ыңгайлаштырып жана өнүктүрүп турабыз, бул сиздин маалыматтарыңыздын актуалдуулугун жана практикалык баалуулугун камсыздайт.',
  ad_hoc_10: 'Тактык',
  ad_hoc_11:
    'Методологияларды сиздин өзгөчө талаптарыңызга ылайыкташтыруу аркылуу биз баалуу түшүнүктөрдү берген так жана багытталган натыйжаларды сунуштайбыз.',
  ad_hoc_12: 'Инновация',
  ad_hoc_13:
    'Биз изилдөө процессинде инновацияны жана чыгармачылыкты колдойбуз, жашыруун мүмкүнчүлүктөрдү жана көйгөйлөрдү табуу үчүн жаңы ыкмаларды изилдейбиз.',
  ad_hoc_14: 'Өз убагында аткаруу',
  ad_hoc_15:
    'Ad Hoc Research тез ишке ашырууга мүмкүндүк берет, ошондуктан сиз маанилүү маалыматтарды өз убагында алып, тармагыңызда алдыда боло аласыз.',
  ad_hoc_16: 'Биздин экспертиза',
  ad_hoc_17:
    '4Service компаниясынын рыноктук изилдөөлөр жана кардар тажрыйбасы боюнча 20 жылдан ашык тажрыйбасы бар эксперттери бизнесиңиздин өсүшүнө жардам берген уникалдуу чечимдерди түзүшөт',
  ad_hoc_18:
    'Биз сиздин өзгөчө талаптарыңызга жараша уникалдуу инструменттер топтомун колдонобуз',
  ad_hoc_19: 'Бир дагы стандарттуу методология сизге туура келбейби?',
  ad_hoc_20: 'Ad Hoc Research кызматына суроо жөнөтүңүз',
  ad_hoc_21: 'Белгилүү бир маселе үчүн ылайыкташтырылган',
  ad_hoc_22:
    'Биз ар кандай методологиялардын элементтерин айкалыштырып же толугу менен жаңы ыкманы колдонобуз',
  ad_hoc_23: 'Жекече мамиле',
  ad_hoc_24:
    'Биз чечимди сиздин көйгөйүңүзгө түздөн-түз ылайык кылып кылдат иштеп чыгабыз',
  ad_hoc_25: 'Күтүлгөндөн да жогору натыйжага жетиңиз',
  ad_hoc_26:
    'Биз бизнесиңиздин максаттарына жетүүсүнө жардам берүү үчүн практикалык сунуштар менен иш-аракеттер планын сунуштайбыз',
  ad_hoc_27: 'Сизде стандарттуу эмес маселе бар',
  ad_hoc_28: 'Сиздин маселеңиз үчүн бир дагы методология ылайыктуу эмес',
  ad_hoc_29:
    'Сиз бир эле учурда ар кандай методологияларды же алардын бөлүктөрүн колдонгуңуз келет',
  ad_hoc_30: 'Ad Hoc изилдөөсүнөн кимдер пайда алат?',
  service_design_1: 'Биздин айрым кардарлар',
  service_design_2: 'Кызмат дизайны',
  service_design_3:
    'Бизнесиңизди продукт жана сатууга багытталган моделден кызматка жана адамга багытталган моделге айлантыңыз',
  service_design_4: 'Эксперт менен сүйлөшүңүз',
  service_design_5: 'Акысыз үйрөнүңүз!',
  service_design_6:
    'Биз Service Design китепканабызда пайдалуу жана практикалык маалыматтарды топтодук',
  service_design_7:
    'Китепканада ар бир кадамдын кеңири сүрөттөлүшү, тиешелүү инструменттер жана ыкмалар, маанилүү деталдар боюнча кеңештер жана видео көрсөтмөлөр камтылган.',
  service_design_8: 'Китепканага өтүү',
  service_design_9: 'Service Design менен артыкчылыкка ээ болуңуз!',
  service_design_10:
    'Service Design колдонуучулардын канааттануусун жана операциялык натыйжалуулукту жогорулатуу үчүн адамдарды, процесстерди жана байланыш чекиттерин камтыган бүтүндөй кызмат экосистемасын карап чыгып, кызматтарды түзүүгө жана жакшыртууга багытталган.',
  service_design_11:
    'Service Design — бул бир кафени экинчисинен артык көрүшүңүздүн себеби гана эмес. Ошондой эле ал сиздин ошол жерге кайра-кайра кайтып келип, досторуңузга сунушташыңыздын себеби.',
  service_design_12: 'Бизнес Service Design аркылуу кандай пайда ала алат',
  service_design_13: 'Колдонуучулардын канааттануусу',
  service_design_14:
    'Колдонуучуларды кубандырган үзгүлтүксүз жана жекелештирилген тажрыйбаларды түзүңүз.',
  service_design_15: 'Операциялык натыйжалуулук',
  service_design_16:
    'Процесстерди жөнөкөйлөтүп, чыгымдарды азайтып жана кызмат көрсөтүүнүн сапатын жакшыртыңыз.',
  service_design_17: 'Бренддин ырааттуулугу',
  service_design_18:
    'Бардык байланыш чекиттери бренддин баалуулуктарына шайкеш болушун камсыз кылыңыз.',
  service_design_19: 'Өзгөрүүлөргө ыңгайлашуу',
  service_design_20:
    'Өзгөрүп жаткан муктаждыктар менен бирге өсүп жана өнүгө ала турган кызматтарды долбоорлоңуз.',
  service_design_21: 'Лоялдуулукту жогорулатуу',
  service_design_22:
    'Өзгөчө кызмат тажрыйбасы аркылуу кардарлар менен мамилени бекемдеп, лоялдуулукту арттырыңыз.',
  service_design_23: 'Атаандаштык артыкчылыгы',
  service_design_24:
    'Уникалдуу жана эстен кеткис кызмат тажрыйбалары аркылуу рынокто айырмаланыңыз.',
  service_design_25: 'Эмне үчүн',
  service_design_26: 'Эмне үчүн Service Design?',
  service_design_27:
    'Бул дүйнө жүзүндөгү компанияларга продукт жана сатууга багытталуудан адамдын муктаждыктарына жана көйгөйлөрүнө көңүл бурууга өтүүгө жардам берген маданият, методология жана ой жүгүртүү ыкмасы.',
  service_design_28: 'Биздин кызматтар',
  service_design_29: 'Кардарлар үчүн кызмат дизайны',
  service_design_30:
    'Биз жаңы өнүмдөрдү түзүү же учурдагы өнүмдөрдү жакшыртуу үчүн кардарларга багытталган долбоорлорду иштеп чыгып ишке ашырабыз. Ошондой эле бул өзгөрүүлөр менен келечекте өз алдынча иштөө үчүн окутууларды өткөрөбүз.',
  service_design_31: 'Кызматкерлер үчүн кызмат дизайны',
  service_design_32:
    'Компаниянын ичинде кызматкерлерге багытталган процесстерди, түзүмдөрдү жана өзгөрүүлөрдү иштеп чыгуу жана ишке ашыруу боюнча практикалык курс.',
  service_design_33: 'Келечекти долбоорлоо ой жүгүртүүсү',
  service_design_34:
    'Ар кандай сценарийлерди жана мүмкүн болгон инновацияларды эске алуу менен келечек концепцияларын жана компания стратегиясын иштеп чыгуу.',
  service_design_35: 'Бизнестеги чыгармачылык',
  service_design_36:
    'Катышуучуларга конкреттүү көйгөйлөрдү чечүү жана рынок үчүн уникалдуу чечимдерди иштеп чыгуу үчүн чыгармачылыкты колдонууга жардам берген практикалык тренинг.',
  service_design_37: 'Биздин воркшоптор',
  service_design_38:
    'Биз катышуучуларыбыз үчүн дүйнө жүзүндө таанылган сертификат менен практикалык воркшопторду өткөрөбүз',
  service_design_39:
    'Күтүлгөндөн ашкан өнүмдөрдү, кызматтарды жана объекттерди түзүңүз',
  service_design_40: 'Натыйжалуу иштеген бизнес процесстерин ишке ашырыңыз',
  service_design_41:
    'Компаниянын кызматкерлери менен кардарларынын ортосундагы мамилелерди шайкештириңиз',
  service_design_42: 'Календарь',
  service_design_43: 'Жакында',
  service_design_44: 'Мурунку иш-чараларыбыз тууралуу көбүрөөк билиңиз',
  service_design_45: 'Service Design негиздери',
  service_design_46:
    'Күтүлгөндөн ашкан өнүмдөрдү, кызматтарды жана объекттерди түзүңүз',
  service_design_47: 'EX Service Design',
  service_design_48:
    'Күтүлгөндөн ашкан өнүмдөрдү, кызматтарды жана объекттерди түзүңүз',
  service_design_49: 'Көбүрөөк',
  service_design_50: 'Биздин ыкма',
  service_design_51:
    '4Service — адамга багытталган кызматыңыздын ишенимдүү негизи!',
  service_design_52:
    'Биз компанияларга керектүү ой жүгүртүү маданиятын өнүктүрүүгө жана адамга багытталган ички чөйрөнү түзүүгө жардам беребиз.',
  service_design_53: 'Инструменттер',
  service_design_54:
    'Биз сиздин өзгөчө талаптарыңызга жараша ар кандай техникаларды жана инструменттерди колдонобуз',
  service_design_55: 'Колдонуучуларды изилдөө',
  service_design_56:
    'Колдонуучулардын муктаждыктарын жана жүрүм-турумун түшүнүү үчүн интервьюлар, сурамжылоолор, F2F жана этнографиялык изилдөөлөр',
  service_design_57: 'Персоналар',
  service_design_58:
    'Дизайн боюнча чечимдерди кабыл алууга жардам берүүчү ар кандай колдонуучу типтерин чагылдырган ойдон чыгарылган каармандар',
  service_design_59: 'Кардарлардын жол карталары',
  service_design_60:
    'Колдонуучунун кызмат менен болгон тажрыйбасын чагылдырган визуалдык карта, негизги байланыш чекиттерин жана көйгөйлүү учурларды аныктайт',
  service_design_61: 'Мээ чабуул сессиялары',
  service_design_62:
    'Идеяларды жана чечимдерди жаратуу үчүн кызыкдар тараптар менен биргелешкен сессиялар.',
  service_design_63: 'Прототиптөө',
  service_design_64:
    'Концепцияларды сыноо жана өркүндөтүү үчүн кызматтын алдын ала версияларын түзүү',
  service_design_65: 'Кызматтын схемалары',
  service_design_66:
    'Кызматтын ар кандай компоненттери менен процесстеринин ортосундагы байланыштарды көрсөткөн деталдуу диаграммалар',
  service_design_67: 'Өнөктөш',
  service_design_68: '4Service & DTA',
  service_design_69:
    '4Service — Design Thinking Academyнин расмий жана эксклюзивдүү өкүлү',
  service_design_70: 'Өнөктөштүгүбүздүн алкагында биз:',
  service_design_71:
    '<b>алдыңкы эксперттер тарабынан өткөрүлгөн воркшоптордо</b> кызмат дизайны ыкмасы боюнча практикалык окутууларды өткөрөбүз;',
  service_design_72:
    '<b>сертификацияланган</b> дизайн ой жүгүртүү адистерин даярдайбыз;',
  service_design_73:
    '<b>эл аралык фасилитаторлор менен</b> көптөгөн компаниялар үчүн кызмат дизайны долбоорлорун ишке ашырабыз.',
  service_design_74:
    'Биз төмөнкү өлкөлөрдө Service Design Excellence борборлорун түздүк:',
  service_design_75: 'Украина',
  service_design_76: 'Казакстан',
  service_design_77: 'Түркия',
  service_design_78: 'Грузия',
  service_design_79: 'Азербайжан',
  service_design_80: 'Биздин кейстер тууралуу көбүрөөк билиңиз',
  service_design_81: 'Китепканага өтүү',
  service_design_82: 'Service Design дүйнөсүнө кош келиңиз!',
  four_opinion_1: '4Service тарабынан жүргүзүлгөн сурамжылоо',
  four_opinion_2:
    'Онлайн сурамжылоолорго катышып, үйдөн чыкпай эле акча табыңыз',
  four_opinion_3: 'Баштоо',
  four_opinion_4: 'Биздин артыкчылыктар',
  four_opinion_5: 'Бизге ишенишет',
  four_opinion_6:
    'Биздин коомчулук Украинада 90 000ден ашуун жана Казакстанда 100 000ден ашуун керектөөчүлөрдү камтыйт',
  four_opinion_7: 'Биз сиздин убактыңызды адилеттүү баалайбыз',
  four_opinion_8:
    'Биз сиздин убактыңызды баалайбыз, ошондуктан сурамжылоолорго катышуу үчүн белек же акчалай сыйлык алуу мүмкүнчүлүгүнө ээ болосуз',
  four_opinion_9: 'Сиздин пикириңиз чоң мааниге ээ',
  four_opinion_10:
    'Сиздин ар бир комментарийиңиз бренддерге кардарларынын муктаждыктарын жакшыраак түшүнүүгө жардам берет',
  four_opinion_11:
    '4Service компаниясынын 4Opinion платформасында сурамжылоолорго катышып, онлайн акча табыңыз же байге утуп алыңыз',
  four_opinion_12: '4Opinion платформасына кошулуңуз',
  four_opinion_13: 'Каналыбызда дагы кызыктуу окуялар',
  four_opinion_14: 'Украина үчүн кененирээк маалымат',
  four_opinion_15: 'Казакстан үчүн кененирээк маалымат',
  four_opinion_16: 'Эмне үчүн бизди тандашат?',
  four_opinion_17:
    '4Service — кардарлардын тажрыйбасын башкарууга адистешкен эл аралык изилдөө холдинги',
  four_opinion_18:
    'Биз кардарлардын тажрыйбасын башкаруу боюнча Европадагы алдыңкы 10 агенттиктин катарына киребиз',
  four_opinion_19:
    'Биздин миссиябыз — дүйнө жүзү боюнча кардарларды тейлөөнү жакшыртуу!',
  four_opinion_20:
    'Онлайн сурамжылоолордон кантип киреше табууну баштоо керек?',
  four_opinion_21: 'Сайтта катталыңыз',
  four_opinion_22: 'Жеткиликтүү сурамжылоолор тууралуу билдирмелерди алыңыз',
  four_opinion_23: 'Сурамжылоолорду толтуруп, киреше табыңыз',
  four_opinion_24: 'Биздин респонденттердин чыныгы пикирлери',
  four_opinion_25: 'Виталий Кохан',
  four_opinion_26:
    '“Мен сурамжылоону толтуруп, ал тууралуу унутуп да калдым. Бир аз убакыт өткөндөн кийин Наталия айым мага телефон чалып, байге утуп алганымды айтты. Мына эми менин Samsung Galaxy M52 5G телефонум. Чоң рахмат😁”',
  four_opinion_27: 'Виктория Поповская',
  four_opinion_28:
    '“Мен колонканы алдым, ак ниеттүү, адилеттүү жана кызыктуу ойнотуу үчүн чоң рахмат.”',
  four_opinion_29: 'Юлия Александровна',
  four_opinion_30:
    '“Балким, бул акыркы убактарда менин жашоомдо болгон эң укмуштуу окуядыр💕 Мен утуп эле тим болбостон, чындап сонун нерсеге ээ болдум. Ар кандай нерсени күткөм, бирок мынчалык сонун болот деп элестете да алган эмесмин. Дагы бир жолу чоң рахмат!”',
  four_opinion_31:
    'Бизде гана сиз чыныгы акча табууга же байге утуп алууга мүмкүнчүлүк аласыз',
  four_opinion_32: 'Жеткиликтүү сурамжылоолорду биздин каналда байкап туруңуз',
  four_opinion_33: 'Каналга өтүү',
  career_1: '4Serviceтин бир бөлүгү болуңуз',
  career_2: '4Service',
  career_3:
    'Туруктуу кесиптик өнүгүү үчүн чексиз мүмкүнчүлүктөрү бар командага кошулушуңузду күтөбүз!',
  career_4: 'Вакансияларга өтүү',
  career_5: 'Вакансия таба алган жоксузбу?',
  career_6: 'Бизге резюмеңизди жөнөтүңүз, биз сиз менен байланышабыз!',
  career_7: 'Резюме жөнөтүү',
  career_8: 'Каттоо формасы',
  career_9: '*Аты',
  career_10: '*Фамилиясы',
  career_11: '*Email',
  career_12: '*Телефон номери',
  career_13: 'Резюмени жүктөө',
  career_14: 'Жөнөтүү',
  career_15: '4Serviceте карьераңызды баштаңыз',
  career_16: 'Негизги милдеттер:',
  career_17: 'Талаптар:',
  career_18: 'Биз сунуштайбыз:',
  career_19: 'Арыз берүү',
  career_20: '4Service — эл аралык изилдөө холдинги',
  career_21: '2001-жылдан бери иштеп келебиз',
  career_22: 'Биз жөнүндө',
  career_23: 'Корпоративдик маданиятты өнүктүрөбүз',
  career_24: 'Биздин демилгелер',
  career_25: 'Дүйнө жүзү боюнча кардарларды тейлөөнү жакшыртабыз',
  career_26: '4Service вакансиялары',
  career_27: '4Service менен мүмкүнчүлүктөрүңүз',
  career_28:
    '“Morning coffee” аттуу жумалык сессиялардын алкагында психикалык ден соолукту колдоо, тимбилдингдер жана социалдык демилгелер',
  career_29:
    'Mercedes, Huawei, Philip Morris сыяктуу дүйнөгө белгилүү бренддер менен кызыктуу иш тажрыйбасы <span>Mercedes, Huawei, Philip Morris</span>',
  career_30:
    'Семинарлар, тренингдер жана воркшоптор аркылуу үзгүлтүксүз кесиптик өнүгүү',
  career_31:
    'Жашыруун сатып алуучу ролу жана белгилүү бренддердин өнүгүүсүнө таасир берүү мүмкүнчүлүгү',
  career_32:
    'Дүйнөнүн каалаган жеринен кызматташуу жана <span>Украинада, Казакстанда, Румынияда, Австрияда, Азербайжанда, Грузияда</span> алыстан же кеңседе иштөө мүмкүнчүлүгү',
  career_33:
    'Иш-чараларга, вебинарларга жана нетворкингдерге катышуу аркылуу жеке брендиңизди өнүктүрүү',
  career: 'Карьера',
  footer_btn_1: 'Жашыруун сатып алуучу болуу',
  footer_btn_2: 'Акы төлөнүүчү сурамжылоолорго катышуу',
  diary_study_1: 'Күндөлүк',
  diary_study_2: 'Изилдөө',
  diary_study_3:
    'Убакыттын өтүшү менен өзгөрүп турган колдонуучулардын тажрыйбалары жана жашоо образы жөнүндө маалыматтарды көзөмөлдөңүз жана чогултуңуз',
  diary_study_4: 'Эксперт менен сүйлөшүү',
  diary_study_5: 'Биз менен байланышыңыз',
  diary_study_6: 'Баштоо',
  diary_study_7:
    'Сапаттык жана сандык маалыматтарга бирдиктүү жеткиликтүүлүк алып, керектөөчүлөрдүн жүрүм-туруму, рыноктук тенденциялар жана бренддин көрсөткүчтөрү боюнча баалуу түшүнүктөрдү алуу үчүн Diary Study заказ кылыңыз',
  diary_study_8:
    'Жашоо образынын жана колдонуучу тажрыйбасынын динамикадагы изилдөөсү',
  diary_study_9:
    'Diary Study колдонуучулардын өз ара аракеттенүүсүн терең контексттик деңгээлде түшүнүүгө жардам берип, башка ыкмалар менен байкалбай калышы мүмкүн болгон үлгүлөрдү жана өзгөрүүлөрдү аныктайт.',
  diary_study_10:
    'Бул ыкма табигый чөйрөдө реалдуу убакыт режиминде маалымат чогултууга мүмкүндүк берип, анын ишенимдүүлүгүн жана актуалдуулугун кыйла жогорулатат',
  diary_study_11: 'Сунуштайбыз',
  diary_study_12: 'Биз ылайыкташтырылган Diary Study изилдөөлөрүн сунуштайбыз',
  diary_study_13: 'Керектөөчүлөрдүн катышуусу',
  diary_study_14:
    'Биз катышуучулар күнүмдүк чөйрөсүндө өздөрүнүн жүрүм-турумун, аракеттерин жана тажрыйбаларын убакыттын өтүшү менен документтештирген онлайн коомчулуктарды уюштурабыз.',
  diary_study_15: 'Рыноктук изилдөө',
  diary_study_16:
    'Биздин ыкма кардарларыбыздын өзгөчө муктаждыктары үчүн пайдалуу жана актуалдуу маалыматтарды берүүчү терең рыноктук изилдөөгө негизделген.',
  diary_study_17: 'Бренд боюнча түшүнүктөр',
  diary_study_18:
    'Биз керектөөчүлөрдүн кабылдоолоруна жана жүрүм-турумуна терең талдоо жүргүзүп, бренд стратегияларын калыптандыруучу баалуу маалыматтарды ачабыз.',
  diary_study_19: 'Эксперттер',
  diary_study_20:
    '20 жылдан ашык кардар тажрыйбасына ээ болгон 4Service эксперттери бизнесиңиздин өсүшүнө жардам берген уникалдуу чечимдерди түзүшөт',
  diary_study_21: 'Долбоорду башкаруу',
  diary_study_22:
    'Биздин команда ар бир этап кылдат пландалып жана аткарылышын камсыз кылган комплекстүү долбоордук башкаруу колдоосун көрсөтөт.',
  diary_study_23: 'Консалтинг',
  diary_study_24:
    'Биз кардарларыбызга долбоордун бардык этаптарында эксперттик кеңеш берип, кыйынчылыктарды чечүүгө жана натыйжалуулукту жогорулатууга жардам беребиз.',
  diary_study_25: 'Сапатты камсыздоо',
  diary_study_26:
    'Биз ар бир этапта катуу сапат стандарттарын сактап, долбоорлорубуз күтүүлөргө жооп берүүсүн жана алардан ашып түшүүсүн камсыз кылабыз.',
  diary_study_27: 'Артыкчылыктар',
  diary_study_28: 'Биз менен артыкчылыктарга ээ болуңуз',
  diary_study_29: 'Убакыттын өтүшү менен <b>чексиз түшүнүктөрдүн булагы</b>',
  diary_study_30: 'Процесстин ар бир этабында <b>эксперттик көрсөтмөлөр</b>',
  diary_study_31:
    '<b>Бизнес менен керектөөчүлөрдү</b> дүйнө жүзү боюнча байланыштыруу',
  diary_study_32:
    'Терең пикирлер жана жооптор менен <b>ыңгайлуу маалымат чогултуу</b>',
  diary_study_33: 'Долбоордун каалаган этабында <b>жеткиликтүү маалыматтар</b>',
  diary_study_34: 'Өсүшүңүзгө салым кошкон <b>комплекстүү чечимдер</b>',
  diary_study_35: 'Изилдөө',
  diary_study_36:
    'Өзгөчө түшүнүктөрдү камтыган ылайыкташтырылган сандык изилдөөнү алыңыз',
  shoppers_1: 'Жашыруун сатып алуучулар платформасы',
  shoppers_2: 'Жашыруун Сатып Алуучулар',
  shoppers_3: 'Кошулуу',
  shoppers_4: 'Кызмат көрсөтүүнү баалап, 4Service менен киреше табыңыз',
  shoppers_5: '4Service менен карьераңызды баштаңыз',
  shoppers_6: 'Сизди кызыктуу долбоорлор күтөт',
  shoppers_7: 'Кошулуу',
  shoppers_8: 'Биздин командага кошулуңуз',
  shoppers_9: 'Көбүрөөк билүү ›',
  shoppers_10: 'Супервайзер',
  shoppers_11:
    'Команданын ишин көзөмөлдөгөн жетекчи, пландаштыруу, иштерди координациялоо, сапатты көзөмөлдөө жана уюштуруу маселелерин чечүү үчүн жооп берет, коюлган тапшырмалардын аткарылышын камсыздайт.',
  shoppers_12: 'Жашыруун сатып алуучу',
  shoppers_13:
    'Дүкөндөргө, ресторандарга же башка жайларга белгиленген сценарий боюнча барып, андан кийин өз таасирлери тууралуу отчет берген адис.',
  shoppers_14: 'Мерчендайзер',
  shoppers_15:
    'Бренддин же компаниянын стандарттарына ылайык дүкөндөрдө товарларды жайгаштыруу менен алектенген адис.',
  shoppers_16: 'Аудитор',
  shoppers_17:
    'Ишмердүүлүктүн стандарттарга жана талаптарга шайкештигин текшерген адис.',
  shoppers_18: 'Тестирлөөчү',
  shoppers_19:
    'Кардардын көз карашы менен кызмат көрсөтүүнүн, өнүмдөрдүн же процесстердин сапатын текшерип, керектөөчүлөрдүн күтүүлөрүнө шайкештигин баалаган жана мүмкүн болгон көйгөйлөрдү аныктаган адис.',
  shoppers_20: 'Жашыруун талапкер',
  shoppers_21:
    'Кардарларды тейлөө процессин талдап, байланыштын сапатын, жооп берүү ылдамдыгын, процедуралардын ыңгайлуулугун жана өз ара аракеттенүүдөн жалпы таасирди баалаган адис.',
  shoppers_22: 'Промоутер',
  shoppers_23:
    'Өнүмдөрдү көрсөтүү, жарнамалык материалдарды таратуу, акцияларды уюштуруу жана кардарлардын суроолоруна жооп берүү аркылуу товарларды илгерилеткен адис.',
  shoppers_24: 'Маектин катышуучусу',
  shoppers_25:
    'Тереңдетилген маектин катышуучусу белгилүү бир тема, продукт же кызмат боюнча өз ойлорун, эмоцияларын, мотивациясын же тажрыйбасын ачууга багытталган деталдуу изилдөөгө катышат.',
  shoppers_26: '4Service компаниясынын бир бөлүгү болуңуз',
  shoppers_27: 'Биз <b>дүйнө жүзү боюнча</b> иштейбиз',
  shoppers_28: 'Биздин командада <b>1000+ адис</b> бар',
  shoppers_29: 'Бизде рынокто <b>20+ жылдык ийгиликтүү тажрыйба</b> бар',
  shoppers_30: 'Нускамалар',
  shoppers_31: 'Сапардын аудио жазуусун кантип жасоо керек',
  shoppers_32: 'Чалуунун аудио жазуусун кантип жасоо керек',
  shoppers_33: 'Аудиофайлды анкетага тиркей албай жатасызбы?',
  shoppers_34:
    'Жашыруун сатып алуучулар үчүн MSPAнын кесиптик стандарттар жана этика кодекси',
  shoppers_35: 'F.A.Q.',
  shoppers_36: 'Көп берилүүчү суроолор',
  shoppers_37: 'Айына канча киреше табууга болот?',
  shoppers_38: 'Мен өз шаарымда тапшырмаларды канчалык көп аткара алам?',
  shoppers_39:
    'Эгер локация жабык болсо эмне кылуу керек жана мындай сапар үчүн кандай сый акы берилет?',
  shoppers_40: 'Сый акы кантип төлөнөт?',
  shoppers_41: 'Сый акыны алуу мөөнөттөрү кандай?',
  shoppers_42: 'Сый акы алуу боюнча суроолор менен кимге кайрылуу керек?',
  shoppers_43:
    'Сиздин айлык сый акыңыз тапшырмаларды кандай интенсивдүүлүк менен аткарганыңызга жараша болот.',
  shoppers_44:
    'Бир тапшырманы аткаруунун баасы жөнөкөй сапарлар жана чалуулар үчүн 40 гривнадан башталып, татаал жана премиум сапарлар үчүн 1200 гривнага чейин жетиши мүмкүн. Бул долбоордун татаалдыгына жана өзгөчөлүктөрүнө жараша болот.',
  shoppers_45:
    'Тапшырмаларды аткаруу сиз үчүн күнүмдүк сатып алуулар же досторуңуз менен кафе, пиццерия жана ресторандарга баруу менен айкалышкан жагымдуу хоббиге айланышы мүмкүн.',
  shoppers_46: 'локациялардын санына, долбоорлордун масштабына;',
  shoppers_47:
    'ротацияга (бир эле локацияга үч айда же кварталда бир жолудан ашык барбоо);',
  shoppers_48:
    'сиздин профилиңиздин/көндүмдөрүңүздүн долбоордун талаптарына шайкештик деңгээлине;',
  shoppers_49: 'арыз берүүнүн ыкчамдыгына.',
  shoppers_50: 'Эгер сиз текшерип жаткан локация:',
  shoppers_51:
    'Жабык болсо – кире бериш эшикти, жабылуу себеби көрсөтүлгөн жарыяны (эгер бар болсо) же иш графигин, ошондой эле дареги көрсөтүлгөн фасадды сүрөткө тартыңыз.',
  shoppers_52:
    'Көрсөтүлгөн даректе жок болсо – айлана-чөйрөнүн ВИДЕО ЖАЗУУСУН тартыңыз, жанындагы имараттын дареги көрүнгөн фасадынын сүрөтүн тартыңыз. Андан кийин координаторуңузга кайрылыңыз.',
  shoppers_53: 'Сый акы жеке адамдар үчүн «ПриватБанктын» картасына төлөнөт.',
  shoppers_54:
    'Сый акыны алуу мөөнөттөрү менен жеке кабинетиңизден тааныша аласыз.',
  shoppers_55:
    'Ошондой эле координаторуңуздан тактап же Жашыруун Сатып Алуучуларды колдоо кызматына ua@4service.support дареги боюнча кайрылсаңыз болот. Каттын темасында суроо жаралган долбоордун аталышын көрсөтүңүз.',
  shoppers_56:
    'Сый акыны алуунун жалпы мөөнөттөрү жеке кабинеттеги «Башкы бетте» көрсөтүлгөн.',
  shoppers_57:
    'Эгер сый акыңызды ала элек болсоңуз жана мөөнөт өтүп кеткен болсо, жеке кабинетиңизде төмөнкү аракеттерди жасаңыз:',
  shoppers_58:
    '1. Бардык жеке маалыматыңыз толтурулганын жана бош талаалар жок экенин текшериңиз;',
  shoppers_59:
    '2. Төлөм картаңыздын реквизиттери туура көрсөтүлгөнүн жана картанын мөөнөтү бүтө элек экенин текшериңиз;',
  shoppers_60: '3. Жеке адам үчүн банк картасы көрсөтүлгөнүн текшериңиз;',
  shoppers_61:
    '4. Системадагы аты-жөнүңүз картадагы аты-жөнүңүзгө дал келерин текшериңиз (ката жок толтурулган болушу керек).',
  shoppers_62:
    'Эгер бардык маалыматтарды текшерип, баары туура толтурулган болсо – Жашыруун Сатып Алуучуларды колдоо кызматына ua@4service.support дареги боюнча кайрылыңыз. Каттын темасында суроо жаралган долбоордун аталышын көрсөтүңүз.',
  shoppers_63: 'Жашыруун сатып алуучулар үчүн <br /> колдонмолор',
  shoppers_64: '4Soppers колдонмосун жүктөп алыңыз:',
  shoppers_65: 'же',
  shoppers_66: 'Биз менен байланышыңыз',
  shoppers_67: 'Колдоо кызматы менен чат',
  shoppers_68: 'Телефон:',
  shoppers_69: 'Электрондук почта:',
  shoppers_70: 'Суроолоруңуз калдыбы?',
  shoppers_71: 'Талаа кызматкерлерин <br /> колдоо кызматы',
  shoppers_72: 'Байланышуу',
  shoppers_73: 'Талаа кызматкерлерин колдоо кызматы',
  shoppers_74:
    'Сапарлар, төлөмдөр жана Жашыруун Сатып Алуучу катары иштөөнүн башка өзгөчөлүктөрү боюнча суроолор',
  shoppers_75: 'Мен жеке маалыматтарды иштетүүгө төмөнкүлөргө ылайык макулмун',
  shoppers_76: 'Сиздин аты-жөнүңүз',
  shoppers_77: 'Маселенин маңызы',
  shoppers_78: 'Сиздин логиниңиз',
  shoppers_79: 'Байланыш телефону',
  shoppers_80: 'Төлөм мөөнөттөрү',
  shoppers_81: 'Башка',
  shoppers_82: 'Биз менен байланышуу',
  employee_experience_1: 'Кызматкердин тажрыйбасы',
  employee_experience_2:
    'Сиздин бизнесиңиздин ийгилиги Кызматкердин тажрыйбасынан башталат',
  employee_experience_3: 'Биз менен байланышыңыз',
  employee_experience_4: 'Сиздин ийгилик тарыхыңыз ушул жерден башталат',
  employee_experience_5:
    '4Service компаниясынын 20 жылдан ашык рыноктук изилдөө жана кардарлардын тажрыйбасы боюнча эксперттери бизнесиңиздин өсүшүнө жардам берген уникалдуу чечимдерди түзүшөт.',
  employee_experience_6:
    'Биздин кызматтар бизнеске негизделген чечимдерди кабыл алуу, стратегияларды өркүндөтүү жана өз тармагында ийгиликке жетүү үчүн керектүү куралдарды камсыздайт.',
  employee_experience_7:
    'Биз сиздин муктаждыктарыңыз үчүн идеалдуу методологияны тандайбыз',
  employee_experience_8: 'Кызматкердин жол картасы',
  employee_experience_9:
    'Биз кызматкердин жумушка алынуудан тартып кетүүсүнө чейинки толук жолун картага түшүрүп, анын тажрыйбасына таасир эткен негизги байланыш чекиттерин аныктайбыз. Бул ар бир этапта канааттанууну жана катышууну жогорулатуу мүмкүнчүлүктөрүн табууга жардам берет.',
  employee_experience_10: 'Бенчмарк менен Кызматкердин жол картасы',
  employee_experience_11:
    'Биз кызматкерлердин жол картасын түзүүнү тармактык көрсөткүчтөр менен салыштыруу аркылуу дагы тереңдетебиз. Бул ички процесстерди жөнөкөйлөтүү, кызматкерлердин берилгендигин жогорулатуу жана мыкты тажрыйбаларды колдонуу жолдорун аныктоого жардам берет.',
  employee_experience_12: 'Иш берүүчү брендинин абалын изилдөө',
  employee_experience_13:
    'Биз кызматкерлер компаниянын брендин ички жактан кандай кабыл аларын баалайбыз. Күчтүү ички бренд көбүрөөк мотивацияланган жана берилген кызматкерлерди түзөт, бул жакшыраак кардарлар менен өз ара аракеттенүүгө жана тышкы абройго алып келет.',
  employee_experience_14: 'Кызматкерлердин таза сунуштоо индекси (eNPS)',
  employee_experience_15:
    'eNPS аркылуу биз кызматкерлердин компанияны иштөө үчүн мыкты жер катары сунуштоо ыктымалдыгын өлчөйбүз. Бул жөнөкөй, бирок күчтүү көрсөткүч жалпы канааттануу жана берилгендик жөнүндө маалымат берет.',
  employee_experience_16:
    'Кызматкерлердин берилгендиги жана канааттануу индекси (ECSI)',
  employee_experience_17:
    'Биздин ECSI методологиясы кызматкерлердин өз ролдоруна жана компанияга канчалык берилген жана канааттанганын баалайт. Бул алардын катышуу деңгээлин жана кадрларды сактап калуу үчүн жакшыртуу керек болгон багыттарды аныктоого жардам берет.',
  employee_experience_18:
    'Мурдагы жана учурдагы кызматкерлер менен терең маектер',
  employee_experience_19:
    'Биз мурдагы кызматкерлер менен эмне үчүн кеткенин жана кызматкерлерди сактап калууну кантип жакшыртууну түшүнүү үчүн маек жүргүзөбүз. Учурдагы кызматкерлер менен сүйлөшүүлөр кардарларды тейлөөнү жакшыртуу, катышууну жогорулатуу жана KPI көрсөткүчтөрүнө жетүүгө тоскоол болгон факторлорду жоюу жолдорун ачып берет.',
  employee_experience_20: 'UGC анализи',
  employee_experience_21:
    'Колдонуучулар жараткан контенттин (UGC) анализи атайын веб-сайттардан, социалдык тармактардан, форумдардан жана видео платформалардан сын-пикирлерди чогултуу аркылуу жүргүзүлөт. Бул анализ кардарлардын чыныгы күтүүлөрүн жана көйгөйлөрүн түшүнүүгө, тренддерди жана артыкчылыктардын өзгөрүшүн аныктоого, бренддин күчтүү жана алсыз жактарын атаандаштар менен салыштырууга жардам берет.',
  employee_experience_22: 'Жашыруун кызматкер',
  employee_experience_23:
    'Жашыруун кызматкер — бул компанияны потенциалдуу кызматкердин көз карашы менен баалоо. Ал ички процесстердин уюштурулушун, учурдагы кызматкерлердин талапкерлер менен өз ара аракеттенүүсүн жана компаниянын тейлөө жана байланыш стандарттарын канчалык натыйжалуу сактаарын баалайт.',
  employee_experience_24: 'Мотивациялык сапарлар',
  employee_experience_25:
    'Мотивациялык сапарлар кардарлар менен мыкты өз ара аракеттенүү же ийгиликтүү кошумча сатуу сыяктуу тейлөө стандарттарын аткарган кызматкерлерди сыйлайт. Жашыруун сатып алуучулар эң мыкты кызматкерлерди аныктап, мотивацияны жогорулатууга жана башкаларды да сыйлык жана таанылуу алуу үчүн алардын үлгүсүн ээрчүүгө шыктандырат.',
  employee_experience_26: 'Кызмат дизайны',
  employee_experience_27:
    'Биз кызмат дизайнын колдонуп, бизнестеги көйгөйлөрдү аныктап, инновациялык чечимдерди табабыз, кызмат көрсөтүүнү жакшыртуучу жана кардарлардын же кызматкерлердин муктаждыктарын чечүүчү стратегияларды түзөбүз.',
  employee_experience_28: 'HR изилдөө',
  employee_experience_29:
    'HR изилдөө кызматкерлердин компаниянын миссиясына жана баалуулуктарына канчалык шайкеш келерин жана аларды кардарларга канчалык натыйжалуу жеткирерин өлчөөгө жардам берет.',
  employee_experience_30: 'Кызматкерлер менен биргелешип түзүү (фокус-топтор)',
  employee_experience_31:
    'Биз кызматкерлерди түздөн-түз катыштырып, пикирлерди жана идеяларды чогултуу үчүн биргелешкен фокус-топторду өткөрөбүз. Бул кызматкерлерге өз иш чөйрөсүн калыптандырууга катышуу мүмкүнчүлүгүн берип, жоопкерчилик жана катышуу сезимин күчөтөт.',
  employee_experience_32:
    'Эмне үчүн Кызматкердин тажрыйбасына инвестиция салуу керек?',
  employee_experience_33: 'Кадрлардын алмашуусун азайтыңыз',
  employee_experience_34:
    'Кызматкерлер иштеп, өсүүнү каалаган жумуш ордун түзүү аркылуу мыкты адистериңизди сактап калыңыз.',
  employee_experience_35: 'Кызматкерлердин берилгендигин жогорулатыңыз',
  employee_experience_36:
    'Кайра жалдоого кеткен чыгымдарды азайтып, кызматкерлердин узак мөөнөттүү берилгендигин жана берилүүсүн камсыздаңыз.',
  employee_experience_37: 'Өзгөрүүлөргө жеңил ыңгайлашуу',
  employee_experience_38:
    'Жаңы эрежелерге жана демилгелерге каршылыкты азайтып, компанияңыздагы өтүүлөрдү жеңилдетиңиз.',
  employee_experience_39: 'Өндүрүмдүүлүктү жогорулатыңыз',
  employee_experience_40:
    'Командаңызга жаңы процесстерди кабыл алып, өз ролдорунда ийгиликтүү иштөөгө жардам бериңиз.',
  employee_experience_41: 'Бизнес чыгымдарын азайтыңыз',
  employee_experience_42:
    'Процесстерди оптималдаштырып, чыгымдарды кыскартып жана кирешени көбөйтүңүз.',
  employee_experience_43: 'Мыкты EX бизнестин өсүшүн камсыздайт',
  employee_experience_44:
    'Кызматкердин тажрыйбасы (EX) кызматкер компаниядагы өз жолунда туш болгон жана сезген бардык нерселерди камтыйт.',
  employee_experience_45:
    'Оң EX компаниянын максаттарына шайкештикти күчөтүп, мотивацияны жана катышууну жогорулатат.',
  employee_experience_46:
    'Бактылуу жана активдүү кызматкерлер мыкты тейлөөнү камсыздап, кардарлардын канааттануусуна жана туруктуу өсүүгө алып келет.',
  employee_experience_47:
    'EXке инвестиция салуу толкун эффектисин жаратат — кызматкерлерди жакшыраак сактоо, өндүрүмдүүлүктү жогорулатуу жана күчтүү бизнес натыйжалары.',
  employee_experience_48: 'Сиздин EX + CX түздөн-түз бизнесиңизге таасир этет',
  employee_experience_49:
    'Кызматкердин тажрыйбасы (EX) жана Кардардын тажрыйбасы (CX) бири-бири менен тыгыз байланышта. Канааттанган команда мыкты тейлөө көрсөтүүгө көбүрөөк даяр болот, бул кардарлардын канааттануусун жогорулатат. Биздин интеграцияланган EX жана CX ыкмасы ички маданиятты тышкы тейлөө сапаты менен шайкеш келтирүүгө жардам берет.',
  employee_experience_50:
    'Кызматкерлердин жана кардарлардын тажрыйбасы боюнча маалыматтарды бириктирүү аркылуу биз экөөнү тең жакшыртууга комплекстүү мамиле сунуштайбыз. Натыйжада бизнес ийгилигин колдогон күчтүү жана бирдиктүү корпоративдик маданият түзүлөт.',
  employee_experience_51: 'Бактылуу иш берүүчү',
  employee_experience_52: 'Мыкты тейлөө',
  employee_experience_53: 'Бактылуу кардар',
  cati_1: 'CATI',
  cati_2:
    'Компьютердин жардамы менен жүргүзүлгөн натыйжалуу телефондук сурамжылоолор',
  cati_3: 'Биз менен байланышыңыз',
  cati_4: 'Бизге ишенишет',
  cati_5:
    '<b>CATI (Computer Assisted Telephone Interviewing)</b> — бул телефон аркылуу сурамжылоо жүргүзүүчү маалымат чогултуу ыкмасы, анда операторлор жоопторду каттоо, суроолордун логикасын камсыз кылуу жана жыйынтыктарды талдоо үчүн атайын программалык камсыздоону колдонушат.',
  cati_6: '4Service тарабынан сунушталган CATIнин негизги артыкчылыктары:',
  cati_7: 'Сурамжылоолорду жүргүзүүнүн <b>ылдамдыгы</b>',
  cati_8: '<b>Маалыматтардын жогорку сапаты</b>',
  cati_9: 'Анкетаны ыңгайлаштыруудагы <b>ийкемдүүлүк</b>',
  cati_10: 'Процесстин <b>автоматташтырылышы</b>',
  cati_11: 'Сапатты көзөмөлдөө үчүн <b>кеңири куралдар топтому</b>',
  cati_12:
    'Респонденттердин <b>жетүү кыйын болгон категорияларын</b> сурамжылоо мүмкүнчүлүгү',
  cati_13: 'Кийинки текшерүү үчүн бардык <b>сүйлөшүүлөрдү жаздыруу</b>',
  cati_14: '<b>Кеңири максаттуу аудиторияга тез жетүү</b> мүмкүнчүлүгү',
  cati_15:
    'Башка маалымат чогултуу ыкмаларына салыштырмалуу <b>үнөмдүү ыкма</b>',
  cati_16: 'Чечет',
  cati_17: 'Телефондук сурамжылоолор аркылуу кандай милдеттерди чечүүгө болот:',
  cati_18:
    '<span>Рынокту сегменттөө боюнча изилдөөлөр.</span> Так багыттоо жана натыйжалуу маркетинг стратегиялары үчүн ар түрдүү керектөөчү топторун аныктоо',
  cati_19:
    '<span>Кардарлардын канааттануусун баалоо.</span> SCI жана NPS индекстери аркылуу керектөөчүлөрдүн өнүмдөргө жана кызматтарга берилгендигин өлчөө',
  cati_20:
    '<span>NPSти башкаруу жана иш-аракеттер планын ишке ашыруу.</span> Байланыш борбору аркылуу кардарлардын тажрыйбасын жакшыртуу үчүн телефондук сурамжылоолорду колдонуу',
  cati_21:
    '<span>Суроо-талапты жана рыноктук тренддерди талдоо.</span> Өнүмдөрдүн жана кызматтардын популярдуулугун изилдөө, келечектүү аймактарды жана өсүү багыттарын аныктоо',
  cati_22:
    '<span>Атаандаштык чөйрөнү талдоо.</span> Бренддин рыноктогу ордун баалоо, атаандаштар менен салыштыруу жана өсүү мүмкүнчүлүктөрүн аныктоо',
  cati_23: 'Кимдер үчүн',
  cati_24: 'CATI төмөнкүлөр үчүн эң ылайыктуу:',
  cati_25: 'Өнүм чыгарган компаниялар',
  cati_26:
    'Рыноктун актуалдуу маалыматтарын чогултуу, атаандаштык чөйрөнү талдоо жана керектөөчүлөрдүн артыкчылыктарын изилдөө үчүн',
  cati_27: 'Кардарлар менен иштеген бренддер жана компаниялар',
  cati_28:
    'Кардарлардын канааттануу деңгээлин баалоо (Customer Satisfaction, NPS), муктаждыктарды талдоо жана пикирлерди чогултуу үчүн',
  cati_29: 'Чекене соода жана электрондук коммерция',
  cati_30:
    'Керектөөчүлөрдүн жүрүм-турумун түшүнүү, жаңы өнүмдөрдү тестирлөө жана сатып алуу чечимдерине таасир эткен факторлорду аныктоо үчүн',
  cati_31: 'Банктар жана каржы мекемелери',
  cati_32:
    'Кызматтарды баалоо, компанияга болгон ишеним деңгээлин өлчөө жана кызматтар боюнча пикирлерди чогултуу үчүн',
  cati_33: 'Коомдук уюмдар',
  cati_34:
    'Социологиялык изилдөөлөрдү жүргүзүү жана коомдук пикирди талдоо үчүн',
  cati_35: 'Мамлекеттик мекемелер жана КЭУлар',
  cati_36:
    'Статистикалык маалыматтарды чогултуу, социалдык маселелерди изилдөө жана изилдөө программаларын ишке ашыруу үчүн',
  cati_37: 'Сапат',
  cati_38: 'Чалуулардын сапатын баалоо критерийлери',
  cati_39: 'Негизги коммуникация көндүмдөрү',
  cati_40:
    'Саламдашуу жана чалууну аяктоо стандарттарын сактоо, ошондой эле респондент үчүн ыңгайлуу тилге өтүү',
  cati_41: 'Байланыш стили',
  cati_42:
    'Сүйлөөнүн тактыгы, сылыктык, достук маанай жана респондент менен ишенимдүү байланыш түзүү жөндөмү',
  cati_43: 'Сүйлөшүүнү башкаруу',
  cati_44:
    'Активдүү угуу ыкмаларын колдонуу, респонденттин кызыгуусун сактоо жана диалогду натыйжалуу жүргүзүү',
  cati_45: 'Тема боюнча билим',
  cati_46:
    'Сурамжылоонун темасын терең түшүнүү жана респонденттин кошумча суроолоруна туура жооп берүү жөндөмү',
  cati_47: 'Анкетаны толтуруунун тактыгы',
  cati_48:
    'Жоопторду бурмалабай так киргизүү, көрсөтмөлөрдү сактоо жана сурамжылоону толтурууда каталарды болтурбоо',
  cati_49: 'Эмне үчүн 4Service',
  cati_50: 'Эмне үчүн 4Service компаниясынын CATI кызматын тандоо керек?',
  cati_51:
    'CATI телефондук сурамжылоолор аркылуу так жана түзүмдөлгөн маалымат алууну каалаган компаниялар үчүн ылайыктуу',
  cati_52: 'Өзүнүн байланыш борбору',
  cati_53:
    'Биз кардарлардын суроо-талаптарын 100% аткаруу көрсөткүчү менен 70 000ден ашык ийгиликтүү чалууларды жүргүзгөнбүз',
  cati_54: 'Сапат кепилдиги',
  cati_55:
    'Ар бир чалуунун 100% валидациясы – маалыматтын тактыгына кепилдик берет',
  cati_56: 'Жекече мамиле',
  cati_57:
    'Кардардын өзгөчө муктаждыктарына ылайык уникалдуу анкеталарды иштеп чыгуу',
  cati_58: 'Өнүккөн программалык камсыздоо',
  cati_59:
    'Ар кандай татаалдыктагы CATI долбоорлорун ишке ашыруу үчүн VoIPtime',
  cati_60: 'B2B сегменти менен иштөө тажрыйбасы',
  cati_61:
    'Биз юридикалык жактар менен иштеп, бизнес жана өнөр жайдын ар кандай тармактарындагы алдыңкы адистерден сурамжылоо жүргүзөбүз',
  cati_62: 'Сурам жөнөтүңүз, биз сиз үчүн эң жакшы чечимди табабыз!',
  cati_63: 'Технология',
  cati_64:
    'Биз жыйынтыктарды талдоо жана бизнесиңизди өнүктүрүү үчүн заманбап технологияларды колдонобуз',
  cati_65: 'Мүмкүнчүлүктөрү:',
  cati_66: '<span>VoIPtime</span> - кесипкөй программалык камсыздоо',
  cati_67:
    'Кирүүчү (ишеним телефону) жана чыгуучу автоматташтырылган линияларды уюштуруу',
  cati_68:
    'Операторлор боюнча статистика, кайрылуулардын ар бир түрү жана консультациялардын узактыгы',
  cati_69: 'Байланыш борборунун ишин онлайн көзөмөлдөө',
  cati_70: 'Телефон аркылуу бардык аудио консультацияларды жаздыруу',
  cati_71: 'Программалык камсыздоону алыстан жана оңой жөндөө',
  cati_72:
    '<span>Survey Monkey</span> - анкеталарды программалоо үчүн кесипкөй сервис',
  cati_73: 'ар кандай татаалдыктагы анкеталарды программалоо',
  cati_74: 'изилдөөнүн бардык муктаждыктарын эске алуу менен',
  cati_75: 'респонденттер үчүн жөнөкөйлүк, түшүнүктүүлүк жана ыңгайлуулук',
  cati_76: 'Сапат',
  cati_77: 'Кардарлар менен болгон диалогдун сапатын баалоо',
  cati_78: 'Чек-листке негизделген баалоо системасы',
  cati_79:
    'Кызматтын сапаты атайын чек-лист аркылуу өлчөнөт, анда сапатты баалоо кызматкерлери отчеттук мезгил ичинде орточо упай беришет',
  cati_80: 'Максаттуу шайкештик көрсөткүчтөрү',
  cati_81:
    'Стандарттарга шайкештик белгиленген деңгээлдер боюнча бааланат жана алар 90%дан төмөн болбошу керек. Бул көрсөткүчтөр кызматкердин тажрыйбасына жараша өзгөртүлүшү мүмкүн',
  cati_82: 'Чалууларды жазууларда жана реалдуу убакыт режиминде көзөмөлдөө',
  cati_83:
    'Чалуулардын болжол менен 40% жазуулар аркылуу жана 20% реалдуу убакытта текшерилет, бул стандарттардын бузулушуна ыкчам жооп берүүгө мүмкүндүк берет',
  cati_84: 'Эксперттер',
  cati_85: 'Биздин өзүбүздүн Байланыш борборубуз бар',
  cati_86: 'Байланыш борборунун менеджери',
  cati_87: 'Жалдоо боюнча менеджерлер',
  cati_88: 'Украинадагы алыстан иштөө аянтчасы',
  cati_89: 'Казакстандагы алыстан иштөө аянтчасы',
  cati_90: 'Техникалык координатор',
  cati_91: 'Долбоор менеджерлери',
  cati_92: 'Долбоор менеджерлери',
  cati_93: 'Окутуу жана сапатты көзөмөлдөө бөлүмү',
  cati_94: 'Операторлор – 60 адам (20% англис тилин эркин билет)',
  cati_95: 'Операторлор – 20 адам',
  cati_96: 'Сапатты көзөмөлдөө бөлүмүнүн жетекчиси',
  cati_97: 'Сапатты көзөмөлдөө боюнча адистер',
  cati_98: 'Окутуучу тренерлер',
};
